import { Injectable } from '@angular/core';
import { SessionHelper } from '../sessionHelper';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor() { }
  private translations = [
    {
      key: "projectoverview.header",
      EN: "Project Overview",
      DA: "Projekt Oversigt",
      NO: "Prosjekt Oversikt",
      FI: "Projektin Yleiskatsaus",
      SE: "Projektöversikt",
    },
    {
      key: "projectoverview.description",
      EN: "Find all your current projects here",
      DA: "Find alle dine nuværende projekter her",
      NO: "Finn alle dine nåværende prosjekter her",
      FI: "Löydä kaikki nykyiset projektisi täältä",
      SE: "Hitta alla dina nuvarande projekt här",
    },
    {
      key: "projectoverview.secondheader",
      EN: "Personal Overview",
      DA: "Personligt Overblik",
      NO: "Personlig Oversikt",
      FI: "Henkilökohtainen Yleiskatsaus",
      SE: "Personlig Översikt",
    },
    {
      key: "projectoverview.secondsubheader",
      EN: "Find all your current tasks",
      DA: "Find alle dine nuværende projekter her",
      NO: "Finn alle dine nåværende prosjekter her",
      FI: "Löydä kaikki nykyiset projektisi täältä",
      SE: "Hitta alla dina nuvarande projekt här",
    },
    {
      key: "projectoverview.Filemodalheader",
      EN: "Files",
      DA: "Filer",
      NO: "Filer",
      FI: "Tiedostot",
      SE: "Filer",
    },
    {
      key: "projectoverview.donetaskttitle",
      EN: "Done tasks",
      DA: "Udførte opgaver",
      NO: "Utførte oppgaver",
      FI: "Valmiit tehtävät",
      SE: "Utförda uppgifter",
    },
    {
      key: "projectoverview.removefilter",
      EN: "Remove filter",
      DA: "Fjern filter",
      NO: "Fjern filter",
      FI: "Poista suodatin",
      SE: "Ta bort filter",
    },
    {
      key: "projectoverview.filterontrack",
      EN: "Filter on track projects",
      DA: "Filtrer på igangværende projekter",
      NO: "Filtrer på pågående prosjekter",
      FI: "Suodata meneillään olevat projektit",
      SE: "Filtrera på pågående projekt",
    },
    {
      key: "projectoverview.filteralmostontrack",
      EN: "Filter by almost on track",
      DA: "Filtrer efter næsten på sporet",
      NO: "Filtrer etter nesten på sporet",
      FI: "Suodata lähes aikataulussa olevat projektit",
      SE: "Filtrera på nästan i tid",
    },
    {
      key: "projectoverview.filterbynotontrack",
      EN: "Filter by not on track",
      DA: "Filtrer efter ikke på sporet",
      NO: "Filtrer etter ikke på sporet",
      FI: "Suodata ei aikataulussa olevat projektit",
      SE: "Filtrera på inte i tid",
    },
    {
      key: "projectoverview.numberoftask30",
      EN: "The number of tasks done in the last 30 days",
      DA: "Antallet af opgaver udført i de sidste 30 dage",
      NO: "Antall oppgaver utført de siste 30 dagene",
      FI: "Tehtävien määrä, jotka on suoritettu viimeisten 30 päivän aikana",
      SE: "Antalet uppgifter som utförts under de senaste 30 dagarna",
    },
    {
      key: "projectoverview.viewallfiles",
      EN: "View all files",
      DA: "Se alle filer",
      NO: "Vis alle filer",
      FI: "Näytä kaikki tiedostot",
      SE: "Visa alla filer",
    },
    {
      key: "projectoverview.toggleuserview",
      EN: "Toggle userview",
      DA: "Skift brugeroversigt",
      NO: "Bytt brukeroversikt",
      FI: "Vaihda käyttäjänäkymä",
      SE: "Växla användarvy",
    },
    {
      key: "projectoverview.togglefreetext",
      EN: "Toggle free text filter",
      DA: "Skift fritekstfilter",
      NO: "Bytt fritekstfilter",
      FI: "Vaihda vapaatekstisuodatin",
      SE: "Växla fritt textfilter",
    },
    {
      key: "projectwizard.createproject",
      EN: "Create project",
      DA: "Opret projekt",
      NO: "Opprett prosjekt",
      FI: "Luo projekti mallista",
      SE: "Skapa projekt"
    },
    {
      key: "projectwizard.fromtemplate",
      EN: "From template",
      DA: "Fra skabelon",
      NO: "Fra mal",
      FI: "Mallista",
      SE: "Från mall",
    },
    {
      key: "projectwizard.saving",
      EN: "Saving...",
      DA: "Gemmer...",
      NO: "Lagrer...",
      FI: "Tallennetaan...",
      SE: "Sparar..."
    },
    {
      key: "projectwizard.fromblank",
      EN: "From blank",
      DA: "Fra tom",
      NO: "Fra blank",
      FI: "Tyhjältä",
      SE: "Från tomt",
    },
    {
      key: "projectwizard.Projectcreation",
      EN: "Project creation",
      DA: "Projektoprettelse",
      NO: "Prosjektskapelse",
      FI: "Projektin luominen",
      SE: "Projekt skapande",
    },
    {
      key: "projectwizard.Information",
      EN: "Information",
      DA: "Information",
      NO: "Informasjon",
      FI: "Tietoa",
      SE: "Information",
    },
    {
      key: "projectwizard.Assign",
      EN: "Assign",
      DA: "Tildel",
      NO: "Tildel",
      FI: "Määritä",
      SE: "Tilldela",
    },
    {
      key: "projectwizard.Tags",
      EN: "Tags",
      DA: "Tags",
      NO: "Merker",
      FI: "Tunnisteet",
      SE: "Taggar",
    },
    {
      key: "projectwizard.Done",
      EN: "Done",
      DA: "Udført",
      NO: "Ferdig",
      FI: "Valmis",
      SE: "Färdig",
    },
    {
      key: "projectwizard.createanew",
      EN: "Create a new project",
      DA: "Opret et nyt projekt",
      NO: "Opprett et nytt prosjekt",
      FI: "Luo uusi projekti",
      SE: "Skapa ett nytt projekt",
    },
    {
      key: "orgprojectadd.customercreationhelp",
      EN: "To create your first project you have to first create a customer.",
      DA: "For at oprette dit første projekt, skal du først oprette en kunde.",
      NO: "For å opprette ditt første prosjekt må du først opprette en kunde.",
      FI: "Luodaksesi ensimmäisen projektisi sinun täytyy ensin luoda asiakas.",
      SE: "För att skapa ditt första projekt måste du först skapa en kund."
    },
    {
      key: "orgprojectadd.projecttitle",
      EN: "Project Title",
      DA: "Projekttitel",
      NO: "Prosjekttittel",
      FI: "Projektin otsikko",
      SE: "Projekttitel",
    },
    {
      key: "orgprojectadd.projecttitleplace",
      EN: "Project Title...",
      DA: "Projekttitel...",
      NO: "Prosjekttittel...",
      FI: "Projektin otsikko...",
      SE: "Projekttitel...",
    },
    {
      key: "orgprojectadd.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning",
    },
    {
      key: "orgprojectadd.descriptionplace",
      EN: "Project Description...",
      DA: "Projekbeskrivelse...",
      NO: "Prosjektbeskrivelse...",
      FI: "Projektikuvauksen...",
      SE: "Projektbeskrivning...",
    },
    {
      key: "orgprojectadd.startdate",
      EN: "Start Date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivämäärä",
      SE: "Startdatum",
    },
    {
      key: "orgprojectadd.enddate",
      EN: "End Date",
      DA: "Slutdato",
      NO: "Sluttdato",
      FI: "Lopetuspäivämäärä",
      SE: "Slutdatum",
    },
    {
      key: "orgprojectadd.customer",
      EN: "Customer",
      DA: "Kunde",
      NO: "Kunde",
      FI: "Asiakas",
      SE: "Kund",
    },
    {
      key: "orgprojectadd.deal",
      EN: "Deal",
      DA: "Aftale",
      NO: "Avtale",
      FI: "Kauppa",
      SE: "Affär",
    },
    {
      key: "orgprojectadd.choose",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj...",
    },
    {
      key: "orgprojectadd.createproject",
      EN: "Create project",
      DA: "Opret projekt",
      NO: "Opprett prosjekt",
      FI: "Luo projekti",
      SE: "Skapa projekt",
    },
    {
      key: "orgprojectadd.createandassign",
      EN: "Create and assign",
      DA: "Opret og tildel",
      NO: "Opprett og tildel",
      FI: "Luo ja määritä",
      SE: "Skapa och tilldela",
    },
    {
      key: "orgprojectadd.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng",
    },
    {
      key: "orgprojectadd.createyourproject",
      EN: "Create Your Project",
      DA: "Opret dit projekt",
      NO: "Opprett prosjektet ditt",
      FI: "Luo projektisi",
      SE: "Skapa ditt projekt",
    },
    {
      key: "orgprojectadd.createyourcustomer",
      EN: "Create Your Customer",
      DA: "Opret din kunde",
      NO: "Opprett kunden din",
      FI: "Luo asiakkaasi",
      SE: "Skapa din kund",
    },
    {
      key: "orgprojectadd.createyourcustomer",
      EN: "Create Your Customer",
      DA: "Opret dit projekt",
      NO: "Opprett prosjektet ditt",
      FI: "Luo projektisi",
      SE: "Skapa ditt projekt",
    },
    {
      key: "orgprojectadd.createnewcustomer",
      EN: "Create new customer",
      DA: "Opret ny kunde",
      NO: "Opprett ny kunde",
      FI: "Luo uusi asiakas",
      SE: "Skapa ny kund",
    },
    {
      key: "customercreate.headerline",
      EN: "Here you can create your customer and return to finishing the creation of your project.",
      DA: "Her kan du oprette din kunde og vende tilbage for at færdiggøre oprettelsen af dit projekt.",
      NO: "Her kan du opprette kunden din og gå tilbake for å fullføre opprettelsen av prosjektet ditt.",
      FI: "Tässä voit luoda asiakastasi ja palata viimeistelemään projektisi luomista.",
      SE: "Här kan du skapa din kund och återvända för att slutföra skapandet av ditt projekt.",
    },
    {
      key: "customercreate.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn",
    },
    {
      key: "customercreate.nameplace",
      EN: "Customer Name Here...",
      DA: "Kundenavn her...",
      NO: "Kundenavn her...",
      FI: "Asiakkaan nimi täällä...",
      SE: "Kundens namn här...",
    },
    {
      key: "customercreate.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning",
    },
    {
      key: "customercreate.descriptionplace",
      EN: "Customer Description Here...",
      DA: "Kundebeskrivelse her...",
      NO: "Kunde beskrivelse her...",
      FI: "Asiakkaan kuvaus täällä...",
      SE: "Kundbeskrivning här...",
    },
    {
      key: "customercreate.website",
      EN: "Website",
      DA: "Hjemmeside",
      NO: "Nettside",
      FI: "Verkkosivusto",
      SE: "Webbplats",
    },
    {
      key: "customercreate.websiteplace",
      EN: "Customer Website Here...",
      DA: "Kundens hjemmeside her...",
      NO: "Kundens nettside her...",
      FI: "Asiakkaan verkkosivusto täällä...",
      SE: "Kundens webbplats här...",
    },
    {
      key: "customercreate.address",
      EN: "Address",
      DA: "Adresse",
      NO: "Adresse",
      FI: "Osoite",
      SE: "Adress",
    },
    {
      key: "customercreate.addressplace",
      EN: "Customer Address Here...",
      DA: "Kundens adresse her...",
      NO: "Kundens adresse her...",
      FI: "Asiakkaan osoite täällä...",
      SE: "Kundens adress här...",
    },
    {
      key: "customercreate.address2",
      EN: "Address2",
      DA: "Adresse 2",
      NO: "Adresse 2",
      FI: "Osoite 2",
      SE: "Adress 2",
    },
    {
      key: "customercreate.address2place",
      EN: "Customer Address Second Here...",
      DA: "Kundens anden adresse her...",
      NO: "Kundens andre adresse her...",
      FI: "Asiakkaan toinen osoite täällä...",
      SE: "Kundens andra adress här...",
    },
    {
      key: "customercreate.city",
      EN: "City",
      DA: "By",
      NO: "By",
      FI: "Kaupunki",
      SE: "Stad",
    },
    {
      key: "customercreate.cityplace",
      EN: "Customer City Here...",
      DA: "Kundens by her...",
      NO: "Kundens by her...",
      FI: "Asiakkaan kaupunki täällä...",
      SE: "Kundens stad här...",
    },
    {
      key: "customercreate.zip",
      EN: "Zip",
      DA: "Postnummer",
      NO: "Postnummer",
      FI: "Postinumero",
      SE: "Postnummer",
    },
    {
      key: "customercreate.zipplace",
      EN: "Customer Zip Here...",
      DA: "Kundens postnummer her...",
      NO: "Kundens postnummer her...",
      FI: "Asiakkaan postinumero täällä...",
      SE: "Kundens postnummer här...",
    },
    {
      key: "customercreate.contact",
      EN: "Main Contact",
      DA: "Hovedkontakt",
      NO: "Hovedkontakt",
      FI: "Pääyhteyshenkilö",
      SE: "Huvudkontakt",
    },
    {
      key: "customercreate.contactplace",
      EN: "Customer Main Contact Here...",
      DA: "Kundens hovedkontakt her...",
      NO: "Kundens hovedkontakt her...",
      FI: "Asiakkaan pääyhteyshenkilö täällä...",
      SE: "Kundens huvudkontakt här...",
    },
    {
      key: "customercreate.customercreate",
      EN: "Create your customer",
      DA: "Opret din kunde",
      NO: "Opprett kunden din",
      FI: "Luo asiakas",
      SE: "Skapa din kund",
    },
    {
      key: "orgprojectedit.header",
      EN: "Edit Your Project",
      DA: "Rediger dit projekt",
      NO: "Rediger prosjektet ditt",
      FI: "Muokkaa projektiasi",
      SE: "Redigera ditt projekt",
    },
    {
      key: "orgprojectedit.projecttitle",
      EN: "Project Title",
      DA: "Projekttitel",
      NO: "Prosjekttittel",
      FI: "Projektin otsikko",
      SE: "Projekttitel",
    },
    {
      key: "orgprojectedit.projecttitleplace",
      EN: "Project Title...",
      DA: "Projekttitel...",
      NO: "Prosjekttittel...",
      FI: "Projektin otsikko...",
      SE: "Projekttitel...",
    },
    {
      key: "orgprojectedit.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning",
    },
    {
      key: "orgprojectedit.descriptionplace",
      EN: "Project Description...",
      DA: "Projekbeskrivelse...",
      NO: "Prosjektbeskrivelse...",
      FI: "Projektin kuvaus...",
      SE: "Projektbeskrivning...",
    },
    {
      key: "orgprojectedit.startdate",
      EN: "Start date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivämäärä",
      SE: "Startdatum",
    },
    {
      key: "orgprojectedit.enddate",
      EN: "End date",
      DA: "Slutdato",
      NO: "Sluttdato",
      FI: "Lopetuspäivämäärä",
      SE: "Slutdatum",
    },
    {
      key: "orgprojectedit.customer",
      EN: "Customer",
      DA: "Kunde",
      NO: "Kunde",
      FI: "Asiakas",
      SE: "Kund",
    },
    {
      key: "orgprojectedit.customerhelp",
      EN: "Customer can only be set when creating a project.",
      DA: "Kunden kan kun angives, når du opretter et projekt.",
      NO: "Kunde kan bare settes når du oppretter et prosjekt.",
      FI: "Asiakas voidaan määrittää vain projektia luodessa.",
      SE: "Kunden kan endast ställas in när du skapar ett projekt.",
    },
    {
      key: "orgprojectedit.deal",
      EN: "Deal",
      DA: "Aftale",
      NO: "Avtale",
      FI: "Kauppa",
      SE: "Affär",
    },
    {
      key: "orgprojectedit.dealplace",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj...",
    },
    {
      key: "orgprojectedit.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng",
    },
    {
      key: "orgprojectedit.update",
      EN: "Update Project",
      DA: "Opdater projekt",
      NO: "Oppdater prosjekt",
      FI: "Päivitä projekti",
      SE: "Uppdatera projekt",
    },
    {
      key: "projecttemplatelist.notemplates",
      EN: "You have no templates, you can create templates from your existing projects.",
      DA: "Du har ingen skabeloner, du kan oprette skabeloner fra dine eksisterende projekter.",
      NO: "Du har ingen maler, du kan opprette maler fra dine eksisterende prosjekter.",
      FI: "Sinulla ei ole malleja, voit luoda malleja nykyisistä projekteistasi.",
      SE: "Du har inga mallar, du kan skapa mallar från dina befintliga projekt."
    },
    {
      key: "projecttemplatelist.choosetemplate",
      EN: "Choose your template",
      DA: "Vælg din skabelon",
      NO: "Velg malen din",
      FI: "Valitse mallisi",
      SE: "Välj din mall"
    },
    {
      key: "projecttemplatelist.createyourproject",
      EN: "Create your project",
      DA: "Opret dit projekt",
      NO: "Opprett prosjektet ditt",
      FI: "Luo projektisi",
      SE: "Skapa ditt projekt"
    },
    {
      key: "projecttemplatelist.createyourcustomer",
      EN: "Create your customer",
      DA: "Opret din kunde",
      NO: "Opprett kunden din",
      FI: "Luo asiakas",
      SE: "Skapa din kund"
    },
    {
      key: "projecttemplatelist.title",
      EN: "Title",
      DA: "Titel",
      NO: "Tittel",
      FI: "Otsikko",
      SE: "Titel"
    },
    {
      key: "projecttemplatelist.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "projecttemplatelist.creator",
      EN: "Creator",
      DA: "Opretter",
      NO: "Oppretter",
      FI: "Luojan",
      SE: "Skapare"
    },
    {
      key: "projecttemplatelist.templatetip",
      EN: "Click to Use template",
      DA: "Klik for at bruge skabelon",
      NO: "Klikk for å bruke malen",
      FI: "Klikkaa käyttääksesi mallia",
      SE: "Klicka för att använda mallen"
    },
    {
      key: "projecttemplatelist.projecttitle",
      EN: "Project title",
      DA: "Projekttitel",
      NO: "Prosjekttittel",
      FI: "Projektin otsikko",
      SE: "Projekttitel"
    },
    {
      key: "projecttemplatelist.subtitle",
      EN: "Subtitle",
      DA: "Undertitel",
      NO: "Undertittel",
      FI: "Alaotsikko",
      SE: "Undertitel"
    },
    {
      key: "projecttemplatelist.shortdescription",
      EN: "Short description",
      DA: "Kort beskrivelse",
      NO: "Kort beskrivelse",
      FI: "Lyhyt kuvaus",
      SE: "Kort beskrivning"
    },
    {
      key: "projecttemplatelist.startdatehelp",
      EN: "Start date (this template is designed to start on a",
      DA: "Startdato (denne skabelon er designet til at starte på en",
      NO: "Startdato (denne malen er designet for å starte på en",
      FI: "Aloituspäivä (tämä malli on suunniteltu alkamaan",
      SE: "Startdatum (denna mall är designad för att börja på en"
    },
    {
      key: "projecttemplatelist.enddate",
      EN: "End date:",
      DA: "Slutdato:",
      NO: "Sluttdato:",
      FI: "Lopetuspäivämäärä:",
      SE: "Slutdatum:"
    },
    {
      key: "projecttemplatelist.customer",
      EN: "Customer",
      DA: "Kunde",
      NO: "Kunde",
      FI: "Asiakas",
      SE: "Kund"
    },
    {
      key: "projecttemplatelist.customerplace",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "projecttemplatelist.deal",
      EN: "Deal",
      DA: "Aftale",
      NO: "Avtale",
      FI: "Sopimus",
      SE: "Avtal"
    },
    {
      key: "projecttemplatelist.dealplace",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "projecttemplatelist.createcustomer",
      EN: "Create customer",
      DA: "Opret kunde",
      NO: "Opprett kunde",
      FI: "Luo asiakas",
      SE: "Skapa kund"
    },
    {
      key: "projecttemplatelist.createfromtemplate",
      EN: "Create From Template",
      DA: "Opret fra skabelon",
      NO: "Opprett fra mal",
      FI: "Luo mallista",
      SE: "Skapa från mall"
    },
    {
      key: "projecttemplatelist.loader2",
      EN: "Loading templates...",
      DA: "Indlæser skabeloner...",
      NO: "Laster inn maler...",
      FI: "Ladataan malleja...",
      SE: "Laddar mallar..."
    },
    {
      key: "projecttemplatelist.loader",
      EN: "Creating project...",
      DA: "Opretter projekt...",
      NO: "Oppretter prosjekt...",
      FI: "Luodaan projektia...",
      SE: "Skapar projekt..."
    },
    {
      key: "projectassign.confirmassign",
      EN: "Assigning...",
      DA: "Tildeler...",
      NO: "Tildeler...",
      FI: "Tehtäviä määritetään...",
      SE: "Tilldelar..."
    },
    {
      key: "projectassign.assignrolehelper",
      EN: "The user role set here will control task ownership, also when turned into a template.",
      DA: "Den brugerrolle, der er indstillet her, vil styre opgaveejerskab, også når den omdannes til en skabelon.",
      NO: "Brukerrollen som er satt her, vil kontrollere oppgaveeierskap, også når den gjøres om til en mal.",
      FI: "Tässä asetettu käyttäjärooli hallitsee tehtävän omistajuutta, myös kun se muutetaan malliksi.",
      SE: "Den användarroll som anges här styr uppgiftsägandet, även när den omvandlas till en mall."
    },
    {
      key: "projectassign.assigntemplaterolehelper",
      EN: "The user role set here delegates the task given to the role when the template was generated.",
      DA: "Den brugerrolle, der er indstillet her, vil tildele opgaven til rollen, når skabelonen blev genereret.",
      NO: "Brukerrollen som er satt her, vil delegere oppgaven gitt til rollen når malen ble generert.",
      FI: "Tässä asetettu käyttäjärooli delegoi tehtävän roolille, kun malli luotiin.",
      SE: "Den användarroll som anges här delegerar uppgiften som tilldelats rollen när mallen genererades."
    },
    {
      key: "projectassign.assignhelpertext",
      EN: "The assign step is where you add the people to your project and define their roles, this will also be used when building templates to ensure all parties are delegated the correct tasks.",
      DA: "Tildelingssteppet er, hvor du tilføjer personer til dit projekt og definerer deres roller. Dette vil også blive brugt når du bygger skabeloner for at sikre, at alle parter får tildelt de korrekte opgaver.",
      NO: "Tildelingssteget er der du legger til personer i prosjektet ditt og definerer deres roller. Dette vil også bli brukt når du bygger maler for å sikre at alle parter får tildelt de riktige oppgavene.",
      FI: "Tehtävänjakovaihe on, missä lisäät ihmiset projektiisi ja määrität heidän roolinsa. Tätä käytetään myös mallien rakentamisen yhteydessä varmistaaksesi, että kaikki osapuolet saavat oikeat tehtävät.",
      SE: "Tilldelningssteget är där du lägger till personer till ditt projekt och definierar deras roller. Detta kommer även att användas när du bygger mallar för att säkerställa att alla parter får rätt uppgifter tilldelade."
    },
    {
      key: "projectassign.assignhelpertexttemplate",
      EN: "Assigning roles from your template can only happen on creation when the project is created you can no longer assign roles to people.",
      DA: "Tildeling af roller fra din skabelon kan kun ske ved oprettelse. Når projektet er oprettet, kan du ikke længere tildele roller til personer.",
      NO: "Tildeling av roller fra malen din kan kun skje ved opprettelse. Når prosjektet er opprettet, kan du ikke lenger tildele roller til personer.",
      FI: "Roolien määritys mallistasi voi tapahtua vain luomisen yhteydessä. Kun projekti on luotu, et voi enää määrittää rooleja ihmisille.",
      SE: "Tilldelning av roller från din mall kan endast ske vid skapandet. När projektet är skapat kan du inte längre tilldela roller till personer."
    },
    {
      key: "projectassign.taghelpertext",
      EN: "The tag step is where you can tag your project, this makes it easy to search for and you can sort your overview to filter by tags.",
      DA: "Tagging-trinet er, hvor du kan tagge dit projekt. Dette gør det nemt at søge efter, og du kan sortere din oversigt for at filtrere efter tags.",
      NO: "Tagging-steget er der du kan tagge prosjektet ditt. Dette gjør det enkelt å søke etter, og du kan sortere oversikten din for å filtrere etter tagger.",
      FI: "Tunnistevaihe on, jossa voit lisätä tunnisteen projektiisi. Tämä helpottaa projektin hakua, ja voit lajitella yleiskatsauksesi suodattamalla tunnisteiden mukaan.",
      SE: "Taggningssteget är där du kan tagga ditt projekt. Detta gör det enkelt att söka efter och du kan sortera din översikt för att filtrera efter taggar."
    },
    {
      key: "projectassign.unassignedpeople",
      EN: "Unassigned people",
      DA: "Uden tildelte personer",
      NO: "Uten tildelte personer",
      FI: "Määrittämättömät henkilöt",
      SE: "Oassignerade personer"
    },
    {
      key: "projectassign.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "projectassign.role",
      EN: "Project Role",
      DA: "Projektrolle",
      NO: "Prosjektrolle",
      FI: "Projektin rooli",
      SE: "Projektroll"
    },
    {
      key: "projectassign.title",
      EN: "Title",
      DA: "Titel",
      NO: "Tittel",
      FI: "Otsikko",
      SE: "Titel"
    },
    {
      key: "projectassign.actions",
      EN: "Actions",
      DA: "Handlinger",
      NO: "Handlinger",
      FI: "Toimenpiteet",
      SE: "Åtgärder"
    },
    {
      key: "projectassign.assigntool",
      EN: "Assign To Project",
      DA: "Tildel til projekt",
      NO: "Tildel til prosjekt",
      FI: "Määritä projektille",
      SE: "Tilldela till projekt"
    },
    {
      key: "projectassign.assignproject",
      EN: "Assign To Project",
      DA: "Tildel til projekt",
      NO: "Tildel til prosjekt",
      FI: "Määritä projektille",
      SE: "Tilldela till projekt"
    },
    {
      key: "projectassign.define",
      EN: "Define",
      DA: "Definer",
      NO: "Definer",
      FI: "Määritä",
      SE: "Definiera"
    },
    {
      key: "projectassign.defineplace",
      EN: "Type User role here...",
      DA: "Skriv brugerrolle her...",
      NO: "Skriv brukerrolle her...",
      FI: "Kirjoita käyttäjärooli tänne...",
      SE: "Skriv användarroll här..."
    },
    {
      key: "projectassign.template",
      EN: "Template",
      DA: "Skabelon",
      NO: "Mal",
      FI: "Malli",
      SE: "Mall"
    },
    {
      key: "projectassign.assignedpeople",
      EN: "Assigned people",
      DA: "Tildelte personer",
      NO: "Tildelte personer",
      FI: "Määritetyt henkilöt",
      SE: "Tilldelade personer"
    },
    {
      key: "projectassign.assign",
      EN: "Assign",
      DA: "Tildel",
      NO: "Tildel",
      FI: "Määritä",
      SE: "Tilldela"
    },
    {
      key: "projectassign.assignandtag",
      EN: "Assign and Tag",
      DA: "Tildel og tag",
      NO: "Tildel og tag",
      FI: "Määritä ja merkitse",
      SE: "Tilldela och tagga"
    },
    {
      key: "projectassign.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "projectassign.edituserrole",
      EN: "Edit User Role",
      DA: "Rediger brugerrolle",
      NO: "Rediger brukerrolle",
      FI: "Muokkaa käyttäjäroolia",
      SE: "Redigera användarroll"
    },
    {
      key: "projectassign.edituserroleplace",
      EN: "Enter User Role",
      DA: "Indtast brugerrolle",
      NO: "Skriv brukerrolle",
      FI: "Syötä käyttäjärooli",
      SE: "Ange användarroll"
    },
    {
      key: "projectassign.edituserrolehelp",
      EN: "Don't forget to assign the correct roles.",
      DA: "Glem ikke at tildele de rigtige roller.",
      NO: "Ikke glem å tildele de riktige rollene.",
      FI: "Älä unohda määrittää oikeita rooleja.",
      SE: "Glöm inte att tilldela de korrekta rollerna."
    },
    {
      key: "projectassign.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "projectassign.confirmuserremoveval",
      EN: "Confirm User Removal",
      DA: "Bekræft fjernelse af bruger",
      NO: "Bekreft fjerning av bruker",
      FI: "Vahvista käyttäjän poisto",
      SE: "Bekräfta borttagning av användare"
    },
    {
      key: "projectassign.confirmuserremovevalcheck",
      EN: "Are you sure you want to remove the user?",
      DA: "Er du sikker på, at du vil fjerne brugeren?",
      NO: "Er du sikker på at du vil fjerne brukeren?",
      FI: "Oletko varma, että haluat poistaa käyttäjän?",
      SE: "Är du säker på att du vill ta bort användaren?"
    },
    {
      key: "projectassign.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "projectassign.removeuser",
      EN: "Remove User",
      DA: "Fjern bruger",
      NO: "Fjern bruker",
      FI: "Poista käyttäjä",
      SE: "Ta bort användare"
    },
    {
      key: "assigntemplateroles.choose",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "assigntemplateroles.assignedto",
      EN: "assigned to",
      DA: "tildelt til",
      NO: "tildelt til",
      FI: "määritetty",
      SE: "tilldelad till"
    },
    {
      key: "tagaddremove.header",
      EN: "Here you can assign tags to your project.",
      DA: "Her kan du tildele tags til dit projekt.",
      NO: "Her kan du tildele tags til prosjektet ditt.",
      FI: "Tässä voit liittää tunnisteita projektiisi.",
      SE: "Här kan du tilldela taggar till ditt projekt."
    },
    {
      key: "tagaddremove.taghelp",
      EN: "Your tag...",
      DA: "Din tag...",
      NO: "Din tag...",
      FI: "Tunnisteesi...",
      SE: "Din tag..."
    },
    {
      key: "tagaddremove.create",
      EN: "Create",
      DA: "Opret",
      NO: "Opprett",
      FI: "Luo",
      SE: "Skapa"
    },
    {
      key: "tagaddremove.enablesort",
      EN: "Enables filters to sort tasks",
      DA: "Aktiverer filtre til at sortere opgaver",
      NO: "Aktiverer filtre for å sortere oppgaver",
      FI: "Aktivoi suodattimet tehtävien lajitteluun",
      SE: "Aktiverar filter för att sortera uppgifter"
    },
    {
      key: "tagaddremove.managetags",
      EN: "Manage tags",
      DA: "Administrer tags",
      NO: "Administrer tags",
      FI: "Hallitse tunnisteita",
      SE: "Hantera taggar"
    },
    {
      key: "tagaddremove.tags",
      EN: "Tags",
      DA: "Tags",
      NO: "Tags",
      FI: "Tunnisteet",
      SE: "Taggar"
    },
    {
      key: "tagaddremove.assigntags",
      EN: "Assign tags",
      DA: "Tildel tags",
      NO: "Tildel tags",
      FI: "Liitä tunnisteet",
      SE: "Tilldela taggar"
    },
    {
      key: "tagaddremove.tagmodalhelp",
      EN: "Here you can assign tags to your project.",
      DA: "Her kan du tildele tags til dit projekt.",
      NO: "Her kan du tildele tags til prosjektet ditt.",
      FI: "Tässä voit liittää tunnisteita projektiisi.",
      SE: "Här kan du tilldela taggar till ditt projekt."
    },
    {
      key: "projectlist.workload",
      EN: "Workload",
      DA: "Arbejdsbyrde",
      NO: "Arbeidsmengde",
      FI: "Työkuorma",
      SE: "Arbetsbelastning"
    },
    {
      key: "projectlist.open",
      EN: "Open",
      DA: "Åben",
      NO: "Åpne",
      FI: "Avaa",
      SE: "Öppna"
    },
    {
      key: "projectlist.header",
      EN: "You have no active projects",
      DA: "Du har ingen aktive projekter",
      NO: "Du har ingen aktive prosjekter",
      FI: "Sinulla ei ole aktiivisia projekteja",
      SE: "Du har inga aktiva projekt"
    },
    {
      key: "projectlist.headerfilter",
      EN: "You have no matching projects, check your filters",
      DA: "Du har ingen matchende projekter, tjek dine filtre",
      NO: "Du har ingen matchende prosjekter, sjekk filtrene dine",
      FI: "Sinulla ei ole vastaavia projekteja, tarkista suodattimesi",
      SE: "Du har inga matchande projekt, kontrollera dina filter"
    },
    {
      key: "projectlist.filterplace",
      EN: "Type to filter...",
      DA: "Skriv for at filtrere...",
      NO: "Skriv for å filtrere...",
      FI: "Kirjoita suodattaaksesi...",
      SE: "Skriv för att filtrera..."
    },
    {
      key: "projectlist.showdisabled",
      EN: "Show disabled projects",
      DA: "Vis inaktiverede projekter",
      NO: "Vis inaktiverte prosjekter",
      FI: "Näytä poistettavat projektit",
      SE: "Visa inaktiva projekt"
    },
    {
      key: "projectlist.hidedisabled",
      EN: "Hide disabled projects",
      DA: "Skjul inaktiverede projekter",
      NO: "Skjul inaktiverte prosjekter",
      FI: "Piilota poistettavat projektit",
      SE: "Dölj inaktiva projekt"
    },
    {
      key: "projectlist.created",
      EN: "created -",
      DA: "oprettet -",
      NO: "opprettet -",
      FI: "luotu -",
      SE: "skapat -"
    },
    {
      key: "projectlist.visiblity",
      EN: "Visibility",
      DA: "Synlighed",
      NO: "Synlighet",
      FI: "Näkyvyys",
      SE: "Synlighet"
    },
    {
      key: "projectlist.visiblitytip",
      EN: "Toggle visibility",
      DA: "Skift synlighed",
      NO: "Veksle synlighet",
      FI: "Vaihda näkyvyys",
      SE: "Växla synlighet"
    },
    {
      key: "projectlist.assign",
      EN: "Assign",
      DA: "Tildel",
      NO: "Tildel",
      FI: "Määritä",
      SE: "Tilldela"
    },
    {
      key: "projectlist.assigntip",
      EN: "Assign people to project",
      DA: "Tildel personer til projektet",
      NO: "Tildel personer til prosjektet",
      FI: "Määritä henkilöitä projektiin",
      SE: "Tilldela personer till projektet"
    },
    {
      key: "projectlist.generatetemplate",
      EN: "Generate template",
      DA: "Generer skabelon",
      NO: "Generer mal",
      FI: "Luo malli",
      SE: "Generera mall"
    },
    {
      key: "projectlist.generatetemplatetop",
      EN: "Generate template",
      DA: "Generer skabelon",
      NO: "Generer mal",
      FI: "Luo malli",
      SE: "Generera mall"
    },
    {
      key: "projectlist.edit",
      EN: "Edit",
      DA: "Rediger",
      NO: "Rediger",
      FI: "Muokkaa",
      SE: "Redigera"
    },
    {
      key: "projectlist.edittip",
      EN: "Edit Project",
      DA: "Rediger projekt",
      NO: "Rediger prosjekt",
      FI: "Muokkaa projektia",
      SE: "Redigera projekt"
    },
    {
      key: "projectlist.delete",
      EN: "Delete",
      DA: "Slet",
      NO: "Slett",
      FI: "Poista",
      SE: "Ta bort"
    },
    {
      key: "projectlist.automation",
      EN: "Automation",
      DA: "Automatisering",
      NO: "Automatisering",
      FI: "Automaatio",
      SE: "Automatisering"
    },
    {
      key: "projectlist.deletetip",
      EN: "Delete project",
      DA: "Slet projekt",
      NO: "Slett prosjekt",
      FI: "Poista projekti",
      SE: "Ta bort projekt"
    },
    {
      key: "projectlist.redindicatortool",
      EN: " is not on track",
      DA: " er ikke på rette spor",
      NO: " er ikke på rett spor",
      FI: " ei ole oikealla tiellä",
      SE: " är inte på rätt spår"
    },
    {
      key: "projectlist.yellowindicatortool",
      EN: " is almost on track",
      DA: " er næsten på rette spor",
      NO: " er nesten på rett spor",
      FI: " on melkein oikealla tiellä",
      SE: " är nästan på rätt spår"
    },
    {
      key: "projectlist.projectsettings",
      EN: "Project settings",
      DA: "Projektindstillinger",
      NO: "Prosjektinnstillinger",
      FI: "Projektin asetukset",
      SE: "Projektinställningar"
    },
    {
      key: "projectvisibilitytoggle.disableproject",
      EN: "Disable project",
      DA: "Deaktiver projekt",
      NO: "Deaktiver prosjekt",
      FI: "Poista projektin käytöstä",
      SE: "Inaktivera projekt"
    },
    {
      key: "projectvisibilitytoggle.loading",
      EN: "Changing project state...",
      DA: "Ændrer projektstatus...",
      NO: "Endrer prosjektstatus...",
      FI: "Muutetaan projektin tilaa...",
      SE: "Ändrar projektstatus..."
    },
    {
      key: "projectvisibilitytoggle.enableproject",
      EN: "Enable project",
      DA: "Aktiver projekt",
      NO: "Aktiver prosjekt",
      FI: "Ota projekti käyttöön",
      SE: "Aktivera projekt"
    },
    {
      key: "projectvisibilitytoggle.disabletip",
      EN: "Here you can disable your project, for all project participants",
      DA: "Her kan du deaktivere dit projekt for alle projekt deltagere",
      NO: "Her kan du deaktivere prosjektet for alle prosjekt deltagere",
      FI: "Täällä voit poistaa projektisi käytöstä kaikilta projektin osallistujilta",
      SE: "Här kan du inaktivera ditt projekt för alla projekt deltagare"
    },
    {
      key: "projectvisibilitytoggle.disablealert",
      EN: "This hides the project from your portal and excludes it from your overview!",
      DA: "Dette skjuler projektet fra din portal og ekskluderer det fra din oversigt!",
      NO: "Dette skjuler prosjektet fra portalen din og ekskluderer det fra oversikten din!",
      FI: "Tämä piilottaa projektin portaalistasi ja poistaa sen yhteenvetostasi!",
      SE: "Detta döljer projektet från din portal och utesluter det från din översikt!"
    },
    {
      key: "projectvisibilitytoggle.enabletip",
      EN: "Here you can enable your project, for all project participants.",
      DA: "Her kan du aktivere dit projekt for alle projekt deltagere.",
      NO: "Her kan du aktivere prosjektet for alle prosjekt deltagere.",
      FI: "Täällä voit ottaa projektisi käyttöön kaikille projektin osallistujille.",
      SE: "Här kan du aktivera ditt projekt för alla projekt deltagare."
    },
    {
      key: "projectvisibilitytoggle.enablealert",
      EN: "This puts the project back into your portal and includes it in your overview!",
      DA: "Dette sætter projektet tilbage i din portal og inkluderer det i din oversigt!",
      NO: "Dette setter prosjektet tilbake i portalen din og inkluderer det i oversikten din!",
      FI: "Tämä laittaa projektin takaisin portaalisi ja sisällyttää sen yhteenvetoon!",
      SE: "Detta lägger tillbaka projektet i din portal och inkluderar det i din översikt!"
    },
    {
      key: "projectvisibilitytoggle.successenable",
      EN: "Project successfully enabled!",
      DA: "Projekt aktiveret med succes!",
      NO: "Prosjekt aktivert vellykket!",
      FI: "Projekti aktivoitu onnistuneesti!",
      SE: "Projekt aktiverades framgångsrikt!"
    },
    {
      key: "projectvisibilitytoggle.successdisable",
      EN: "Project successfully disabled!",
      DA: "Projekt deaktiveret med succes!",
      NO: "Prosjekt deaktivert vellykket!",
      FI: "Projekti poistettu käytöstä onnistuneesti!",
      SE: "Projekt inaktiverades framgångsrikt!"
    },
    {
      key: "projectvisibilitytoggle.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "projectdelete.header",
      EN: "Delete Project",
      DA: "Slet projekt",
      NO: "Slett prosjekt",
      FI: "Poista projekti",
      SE: "Ta bort projekt"
    },
    {
      key: "projectdelete.alert",
      EN: "Important: This action removes the project permanently. To keep project use the disable icon!",
      DA: "Vigtigt: Denne handling fjerner projektet permanent. For at bevare projektet skal du bruge deaktiveringsikonet!",
      NO: "Viktig: Denne handling fjerner prosjektet permanent. For å bevare prosjektet, bruk deaktiveringsikonet!",
      FI: "Tärkeää: Tämä toiminto poistaa projektin pysyvästi. Säilyttääksesi projektin käytä poiskytkentäkuvaketta!",
      SE: "Viktigt: Denna åtgärd tar bort projektet permanent. För att behålla projektet, använd avaktiveringsikonen!"
    },
    {
      key: "projectdelete.confirm",
      EN: "Please confirm your action by choosing an option below.",
      DA: "Bekræft venligst din handling ved at vælge en mulighed nedenfor.",
      NO: "Vennligst bekreft handlingen din ved å velge et alternativ nedenfor.",
      FI: "Vahvista toimintosi valitsemalla vaihtoehto alla.",
      SE: "Vänligen bekräfta din åtgärd genom att välja ett alternativ nedan."
    },
    {
      key: "projectdelete.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "projectdelete.confirmdelete",
      EN: "Confirm Delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poistaminen",
      SE: "Bekräfta borttagning"
    },
    {
      key: "projectdelete.deleteloader",
      EN: "Deleting project...",
      DA: "Sletter projekt...",
      NO: "Sletter prosjekt...",
      FI: "Poistetaan projektia...",
      SE: "Tar bort projekt..."
    },
    {
      key: "projectdelete.deletemsg",
      EN: "Project deleted",
      DA: "Projekt slettet",
      NO: "Prosjekt slettet",
      FI: "Projekti poistettu",
      SE: "Projekt raderat"
    },
    {
      key: "projecttemplatecreate.header",
      EN: "Create Project Template",
      DA: "Opret projekt skabelon",
      NO: "Opprett prosjektmal",
      FI: "Luo projektipohja",
      SE: "Skapa projektsmall"
    },
    {
      key: "projecttemplatecreate.templatetitle",
      EN: "Template Title",
      DA: "Skabelon titel",
      NO: "Mal tittel",
      FI: "Pohjan otsikko",
      SE: "Malltitel"
    },
    {
      key: "projecttemplatecreate.templatetitleplace",
      EN: "Insert title here....",
      DA: "Indsæt titel her....",
      NO: "Sett inn tittel her....",
      FI: "Lisää otsikko tänne....",
      SE: "Infoga titel här...."
    },
    {
      key: "projecttemplatecreate.templatedescription",
      EN: "Template Description",
      DA: "Skabelon beskrivelse",
      NO: "Mal beskrivelse",
      FI: "Pohjan kuvaus",
      SE: "Mallbeskrivning"
    },
    {
      key: "projecttemplatecreate.templatedescriptionplace",
      EN: "Insert description here....",
      DA: "Indsæt beskrivelse her....",
      NO: "Sett inn beskrivelse her....",
      FI: "Lisää kuvaus tänne....",
      SE: "Infoga beskrivning här...."
    },
    {
      key: "projecttemplatecreate.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "projecttemplatecreate.createtemplate",
      EN: "Create Template",
      DA: "Opret skabelon",
      NO: "Opprett mal",
      FI: "Luo malli",
      SE: "Skapa mall"
    },
    {
      key: "projecttemplatecreate.loader",
      EN: "Creating template...",
      DA: "Opretter skabelon...",
      NO: "Oppretter mal...",
      FI: "Luodaan mallia...",
      SE: "Skapar mall..."
    },
    {
      key: "projectportal.bulkselecttip",
      EN: "Select multiple tasks",
      DA: "Vælg flere opgaver",
      NO: "Velg flere oppgaver",
      FI: "Valitse useita tehtäviä",
      SE: "Välj flera uppgifter"
    },
    {
      key: "projectportal.filterby",
      EN: "Click to filter by",
      DA: "Klik for at filtrere efter",
      NO: "Klikk for å filtrere etter",
      FI: "Klikkaa suodattaaksesi",
      SE: "Klicka för att filtrera efter"
    },
    {
      key: "projectportal.mytasks",
      EN: "My tasks",
      DA: "Mine opgaver",
      NO: "Mine oppgaver",
      FI: "Omat tehtäväni",
      SE: "Mina uppgifter"
    },
    {
      key: "projectportal.customer",
      EN: "Customer",
      DA: "Kunde",
      NO: "Kunde",
      FI: "Asiakas",
      SE: "Kund"
    },
    {
      key: "projectportal.vendor",
      EN: "Vendor",
      DA: "Leverandør",
      NO: "Leverandør",
      FI: "Toimittaja",
      SE: "Leverantör"
    },
    {
      key: "projectportal.addstage",
      EN: "Add stage",
      DA: "Tilføj fase",
      NO: "Legg til fase",
      FI: "Lisää vaihe",
      SE: "Lägg till steg"
    },
    {
      key: "projectportal.enablefilters",
      EN: "Enables filters to sort tasks",
      DA: "Aktiverer filtre til at sortere opgaver",
      NO: "Aktiverer filtre for å sortere oppgaver",
      FI: "Aktivoi suodattimet tehtävien lajittelemiseksi",
      SE: "Aktiverar filter för att sortera uppgifter"
    },
    {
      key: "projectportal.disablefilters",
      EN: "Disables filters",
      DA: "Deaktiverer filtre",
      NO: "Deaktiverer filtre",
      FI: "Poistaa suodattimet käytöstä",
      SE: "Inaktiverar filter"
    },
    {
      key: "projectportal.notificationsettings",
      EN: "Notification settings",
      DA: "Notifikationsindstillinger",
      NO: "Varslingsinnstillinger",
      FI: "Ilmoitusasetukset",
      SE: "Notifikationsinställningar"
    },
    {
      key: "projectportal.viewoptions",
      EN: "View options",
      DA: "Visningsmuligheder",
      NO: "Visningsalternativer",
      FI: "Näkymäasetukset",
      SE: "Visningsalternativ"
    },
    {
      key: "projectportal.newprojectmessage",
      EN: "This is a new project. Add the first stage by clicking the button at the top of this page.",
      DA: "Dette er et nyt projekt. Tilføj den første fase ved at klikke på knappen øverst på denne side.",
      NO: "Dette er et nytt prosjekt. Legg til den første fasen ved å klikke på knappen øverst på denne siden.",
      FI: "Tämä on uusi projekti. Lisää ensimmäinen vaihe napsauttamalla sivun yläosassa olevaa painiketta.",
      SE: "Detta är ett nytt projekt. Lägg till det första steget genom att klicka på knappen högst upp på denna sida."
    },
    {
      key: "projectportal.createstage",
      EN: "Create Stage",
      DA: "Opret fase",
      NO: "Opprett fase",
      FI: "Luo vaihe",
      SE: "Skapa steg"
    },
    {
      key: "projectportal.stagetitle",
      EN: "Stage Title",
      DA: "Fase titel",
      NO: "Fasetittel",
      FI: "Vaiheen otsikko",
      SE: "Steg titel"
    },
    {
      key: "projectportal.stagetitletip",
      EN: "Enter stage title",
      DA: "Indtast fase titel",
      NO: "Skriv inn fasetittel",
      FI: "Syötä vaiheen otsikko",
      SE: "Ange stegtitel"
    },
    {
      key: "projectportal.stagetitlehelp",
      EN: "Set the name for your stage",
      DA: "Sæt navnet for din fase",
      NO: "Sett navnet for fasen din",
      FI: "Aseta nimen vaiheellesi",
      SE: "Sätt namnet på ditt steg"
    },
    {
      key: "projectportal.stagedescription",
      EN: "Stage Description",
      DA: "Fase beskrivelse",
      NO: "Fasebeskrivelse",
      FI: "Vaiheen kuvaus",
      SE: "Steg beskrivning"
    },
    {
      key: "projectportal.stagedescriptiontip",
      EN: "Enter stage description",
      DA: "Indtast fasebeskrivelse",
      NO: "Skriv inn fasebeskrivelse",
      FI: "Syötä vaiheen kuvaus",
      SE: "Ange stegbeskrivning"
    },
    {
      key: "projectportal.stagedescriptionhelp",
      EN: "Set the description for your stage",
      DA: "Sæt beskrivelsen for din fase",
      NO: "Sett beskrivelsen for fasen din",
      FI: "Aseta kuvaus vaiheellesi",
      SE: "Sätt beskrivningen för ditt steg"
    },
    {
      key: "projectportal.startdate",
      EN: "Start date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Alku päivämäärä",
      SE: "Startdatum"
    },
    {
      key: "projectportal.enddate",
      EN: "End date",
      DA: "Slutdato",
      NO: "Sluttdato",
      FI: "Loppu päivämäärä",
      SE: "Slutdatum"
    },
    {
      key: "projectportal.visibility",
      EN: "Visibility",
      DA: "Synlighed",
      NO: "Synlighet",
      FI: "Näkyvyys",
      SE: "Synlighet"
    },
    {
      key: "projectportal.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "projectportal.roleassignment",
      EN: "Role assignment",
      DA: "Rolle tildeling",
      NO: "Rolletildeling",
      FI: "Roolin määritys",
      SE: "Rolltilldelning"
    },
    {
      key: "projectportal.clarify",
      EN: "Clarify your role in this project",
      DA: "Præciser din rolle i dette projekt",
      NO: "Klargjør din rolle i dette prosjektet",
      FI: "Selkeytä rooliasi tässä projektissa",
      SE: "Klargör din roll i detta projekt"
    },
    {
      key: "projectportal.assignrole",
      EN: "Assign Role",
      DA: "Tildel rolle",
      NO: "Tildel rolle",
      FI: "Määritä rooli",
      SE: "Tilldela roll"
    },
    {
      key: "projectportal.projectsettings",
      EN: "Project Settings",
      DA: "Projektindstillinger",
      NO: "Prosjektinnstillinger",
      FI: "Projektiasetukset",
      SE: "Projektinställningar"
    },
    {
      key: "customername.clicktoclose",
      EN: "Click To Close",
      DA: "Klik for at lukke",
      NO: "Klikk for å lukke",
      FI: "Napsauta sulkeaksesi",
      SE: "Klicka för att stänga"
    },
    {
      key: "customername.customer",
      EN: "Customer -  ",
      DA: "Kunde -  ",
      NO: "Kunde -  ",
      FI: "Asiakas -  ",
      SE: "Kund -  "
    },
    {
      key: "projecttimeshift.header",
      EN: "Time shift",
      DA: "Tidsforskyvning",
      NO: "Tidsforskyvning",
      FI: "Aikasiirto",
      SE: "Tidsförskjutning"
    },
    {
      key: "projecttimeshift.postponeall",
      EN: "Postpone all unfinished tasks by",
      DA: "Udsæt alle ufærdige opgaver med",
      NO: "Utsett alle uferdige oppgaver med",
      FI: "Siirrä kaikki keskeneräiset tehtävät",
      SE: "Skjut upp alla ofullständiga uppgifter med"
    },
    {
      key: "projecttimeshift.selectamount",
      EN: "Select amount",
      DA: "Vælg beløb",
      NO: "Velg beløp",
      FI: "Valitse määrä",
      SE: "Välj belopp"
    },
    {
      key: "projecttimeshift.typeamount",
      EN: "Type your amount",
      DA: "Indtast dit beløb",
      NO: "Skriv inn beløpet ditt",
      FI: "Kirjoita määräsi",
      SE: "Skriv ditt belopp"
    },
    {
      key: "projecttimeshift.days",
      EN: "days",
      DA: "dage",
      NO: "dager",
      FI: "päivää",
      SE: "dagar"
    },
    {
      key: "projecttimeshift.timemachine",
      EN: "Time machine",
      DA: "Tidsmaskine",
      NO: "Tidsmaskin",
      FI: "Aikakone",
      SE: "Tidsmaskin"
    },
    {
      key: "projecttimeshift.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "projecttimeshift.confirmchanges",
      EN: "Confirm changes",
      DA: "Bekræft ændringer",
      NO: "Bekreft endringer",
      FI: "Vahvista muutokset",
      SE: "Bekräfta ändringar"
    },
    {
      key: "projecttimeshift.timeshift",
      EN: "Time shift",
      DA: "Tidsforskyvning",
      NO: "Tidsforskyvning",
      FI: "Aikasiirto",
      SE: "Tidsförskjutning"
    },
    {
      key: "projectnotification.header",
      EN: "Notification Settings",
      DA: "Notifikationsindstillinger",
      NO: "Varslingsinnstillinger",
      FI: "Ilmoitusasetukset",
      SE: "Notifikationsinställningar"
    },
    {
      key: "projectnotification.subheader",
      EN: "These are the settings for the project in question.",
      DA: "Dette er indstillingerne for det pågældende projekt.",
      NO: "Dette er innstillingene for prosjektet det gjelder.",
      FI: "Nämä ovat asetukset kyseiselle projektille.",
      SE: "Det här är inställningarna för det aktuella projektet."
    },
    {
      key: "projectnotification.default.subheader",
      EN: "These are the default notification settings for all new customer users",
      DA: "Dette er standard notifikationsindstillinger for alle nye kundebrugere",
      NO: "Dette er standard varslingsinnstillingene for alle nye kunde brukere",
      FI: "Nämä ovat oletusilmoitusasetukset kaikille uusille asiakaskäyttäjille",
      SE: "Det här är standardinställningarna för alla nya kundanvändare."
    },
    {
      key: "projectnotification.projecttaskdone",
      EN: "Project task done",
      DA: "Projektopgave fuldført",
      NO: "Prosjektoppgave fullført",
      FI: "Projektitehtävä valmis",
      SE: "Projektuppgift klar"
    },
    {
      key: "projectnotification.projectautomations",
      EN: "Has automation",
      DA: "Har automatisering",
      NO: "Har automatisering",
      FI: "Sisältää automaation",
      SE: "Har automation"
    },
    {
      key: "projectnotification.mytaskdue",
      EN: "My task due",
      DA: "Min opgave forfalden",
      NO: "Min oppgave forfalt",
      FI: "Minun tehtäväni erääntyy",
      SE: "Min uppgift förfaller"
    },
    {
      key: "projectnotification.mytaskstart",
      EN: "My task start",
      DA: "Min opgave starter",
      NO: "Min oppgave starter",
      FI: "Minun tehtäväni alkaa",
      SE: "Min uppgift börjar"
    },
    {
      key: "projectnotification.projecttaskadded",
      EN: "Project task added",
      DA: "Projektopgave tilføjet",
      NO: "Prosjektoppgave lagt til",
      FI: "Projektitehtävä lisätty",
      SE: "Projektuppgift tillagd"
    },
    {
      key: "projectnotification.projectcommentadded",
      EN: "Project comment added",
      DA: "Projektkommentar tilføjet",
      NO: "Prosjektkommentar lagt til",
      FI: "Projektikommentti lisätty",
      SE: "Projektkommentar tillagd"
    },
    {
      key: "projectnotification.imtaggedincomment",
      EN: "I'm tagged in comment",
      DA: "Jeg er nævnt i kommentar",
      NO: "Jeg er tagget i kommentar",
      FI: "Olen mainittu kommentissa",
      SE: "Jag är nämnd i kommentar"
    },
    {
      key: "projectstage.successtaskcreate",
      EN: "Task created",
      DA: "Opgave oprettet",
      NO: "Oppgave opprettet",
      FI: "Tehtävä luotu",
      SE: "Uppgift skapad"
    },
    {
      key: "projectstage.downloadlink",
      EN: "Download link",
      DA: "Download-link",
      NO: "Nedlastingslenke",
      FI: "Latauslinkki",
      SE: "Nedladdningslänk"
    },
    {
      key: "projectstage.downloadtext",
      EN: "Download text",
      DA: "Download-tekst",
      NO: "Nedlastingstekst",
      FI: "Latausteksti",
      SE: "Nedladdningstext"
    },
    {
      key: "projectstage.vendoronly",
      EN: "Vendor only",
      DA: "Kun leverandør",
      NO: "Kun leverandør",
      FI: "Vain toimittaja",
      SE: "Endast leverantör"
    },
    {
      key: "projectstage.editstage",
      EN: "Edit stage",
      DA: "Rediger fase",
      NO: "Rediger fase",
      FI: "Muokkaa vaihetta",
      SE: "Redigera fas"
    },
    {
      key: "projectstage.deletestage",
      EN: "Delete stage",
      DA: "Slet fase",
      NO: "Slett fase",
      FI: "Poista vaihe",
      SE: "Radera fas"
    },
    {
      key: "projectstage.start",
      EN: "Start",
      DA: "Start",
      NO: "Start",
      FI: "Aloita",
      SE: "Starta"
    },
    {
      key: "projectstage.end",
      EN: "End",
      DA: "Slut",
      NO: "Slutt",
      FI: "Lopeta",
      SE: "Slut"
    },
    {
      key: "projectstage.addtask",
      EN: "Add task",
      DA: "Tilføj opgave",
      NO: "Legg til oppgave",
      FI: "Lisää tehtävä",
      SE: "Lägg till uppgift"
    },
    {
      key: "projectstage.assigmembers",
      EN: "Assign members",
      DA: "Tildel medlemmer",
      NO: "Tilordne medlemmer",
      FI: "Määritä jäseniä",
      SE: "Tilldela medlemmar"
    },
    {
      key: "projectstage.assigmemberstip",
      EN: "Assign project members to add tasks",
      DA: "Tildel projektmedlemmer til at tilføje opgaver",
      NO: "Tilordne prosjektmedlemmer for å legge til oppgaver",
      FI: "Määritä projektin jäseniä lisäämään tehtäviä",
      SE: "Tilldela projektmedlemmar att lägga till uppgifter"
    },
    {
      key: "projectstage.createtask",
      EN: "Create Task",
      DA: "Opret opgave",
      NO: "Opprett oppgave",
      FI: "Luo tehtävä",
      SE: "Skapa uppgift"
    },
    {
      key: "projectstage.title",
      EN: "Title",
      DA: "Titel",
      NO: "Tittel",
      FI: "Otsikko",
      SE: "Titel"
    },
    {
      key: "projectstage.titleplace",
      EN: "Enter task title",
      DA: "Indtast opgavetitel",
      NO: "Skriv inn oppgavetittel",
      FI: "Anna tehtävän otsikko",
      SE: "Ange uppgiftstitel"
    },
    {
      key: "projectstage.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "projectstage.descriptionplace",
      EN: "Enter task description",
      DA: "Indtast opgavebeskrivelse",
      NO: "Skriv inn oppgavebeskrivelse",
      FI: "Anna tehtävän kuvaus",
      SE: "Ange uppgiftsbeskrivning"
    },
    {
      key: "projectstage.responsible",
      EN: "Responsible",
      DA: "Ansvarlig",
      NO: "Ansvarlig",
      FI: "Vastuuhenkilö",
      SE: "Ansvarig"
    },
    {
      key: "projectstage.organization",
      EN: "Organization",
      DA: "Organisation",
      NO: "Organisasjon",
      FI: "Organisaatio",
      SE: "Organisation"
    },
    {
      key: "projectstage.customer",
      EN: "Customer",
      DA: "Kunde",
      NO: "Kunde",
      FI: "Asiakas",
      SE: "Kund"
    },
    {
      key: "projectstage.warning",
      EN: "Warning",
      DA: "Advarsel",
      NO: "Advarsel",
      FI: "Varoitus",
      SE: "Varning"
    },
    {
      key: "projectstage.warningdesc",
      EN: "Setting responsible to someone else will make you lose access to editing and deleting this task after you save it. Please accept this by checking the check box:",
      DA: "Hvis du sætter en anden som ansvarlig, mister du adgang til at redigere og slette denne opgave efter, at du har gemt den. Accepter venligst dette ved at markere afkrydsningsfeltet:",
      NO: "Hvis du setter noen andre som ansvarlig, mister du tilgang til å redigere og slette denne oppgaven etter at du har lagret den. Vennligst aksepter dette ved å merke av i avkrysningsboksen:",
      FI: "Jos asetat jonkun muun vastuuhenkilöksi, menetät oikeudet muokata tai poistaa tehtävää tallennuksen jälkeen. Hyväksy tämä valitsemalla valintaruutu:",
      SE: "Om du ställer in en annan som ansvarig kommer du att förlora åtkomst till att redigera och radera denna uppgift efter att du sparat den. Vänligen acceptera detta genom att markera kryssrutan:"
    },
    {
      key: "projectstage.eventstart",
      EN: "Event start",
      DA: "Starttidspunkt",
      NO: "Starttidspunkt",
      FI: "Aloitusaika",
      SE: "Starttidpunkt"
    },
    {
      key: "projectstage.eventend",
      EN: "Event end",
      DA: "Sluttidspunkt",
      NO: "Sluttidspunkt",
      FI: "Päättymisaika",
      SE: "Sluttidpunkt"
    },
    {
      key: "projectstage.startdate",
      EN: "Start date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivä",
      SE: "Startdatum"
    },
    {
      key: "projectstage.duedate",
      EN: "Due date",
      DA: "Forfaldsdato",
      NO: "Forfallsdato",
      FI: "Eräpäivä",
      SE: "Slutdatum"
    },
    {
      key: "projectstage.filetitleheader",
      EN: "File header...",
      DA: "Filoverskrift...",
      NO: "Filoverskrift...",
      FI: "Tiedoston otsikko...",
      SE: "Filrubrik..."
    },
    {
      key: "projectstage.uploadaddfile",
      EN: "Add file",
      DA: "Tilføj fil",
      NO: "Legg til fil",
      FI: "Lisää tiedosto",
      SE: "Lägg till fil"
    },
    {
      key: "projectstage.tasktypeheader",
      EN: "Task type",
      DA: "Opgavetype",
      NO: "Oppgavetype",
      FI: "Tehtävätyyppi",
      SE: "Uppgiftstyp"
    },
    {
      key: "projectstage.formtypeheader",
      EN: "Form",
      DA: "Formular",
      NO: "Skjema",
      FI: "Lomake",
      SE: "Formulär"
    },
    {
      key: "projectstage.formtypeselect",
      EN: "Select Form...",
      DA: "Vælg formular...",
      NO: "Velg skjema...",
      FI: "Valitse lomake...",
      SE: "Välj formulär..."
    },
    {
      key: "projectstage.tasktypetask",
      EN: "Task",
      DA: "Opgave",
      NO: "Oppgave",
      FI: "Tehtävä",
      SE: "Uppgift"
    },
    {
      key: "projectstage.tasktypeevent",
      EN: "Event",
      DA: "Begivenhed",
      NO: "Hendelse",
      FI: "Tapahtuma",
      SE: "Händelse"
    },
    {
      key: "projectstage.tasktypesubmit",
      EN: "Upload",
      DA: "Upload",
      NO: "Last opp",
      FI: "Lataa",
      SE: "Ladda upp"
    },
    {
      key: "projectstage.tasktypedownload",
      EN: "Download",
      DA: "Download",
      NO: "Last ned",
      FI: "Lataa alas",
      SE: "Ladda ner"
    },
    {
      key: "projectstage.tasktypeform",
      EN: "Form",
      DA: "Formular",
      NO: "Skjema",
      FI: "Lomake",
      SE: "Formulär"
    },
    {
      key: "projectstage.visibility",
      EN: "Visibility",
      DA: "Synlighed",
      NO: "Synlighet",
      FI: "Näkyvyys",
      SE: "Synlighet"
    },
    {
      key: "projectstage.shared",
      EN: "Shared",
      DA: "Delt",
      NO: "Delt",
      FI: "Jaettu",
      SE: "Delad"
    },
    {
      key: "projectstage.taskcreated",
      EN: "Task created!",
      DA: "Opgave oprettet!",
      NO: "Oppgave opprettet!",
      FI: "Tehtävä luotu!",
      SE: "Uppgift skapad!"
    },
    {
      key: "projectstage.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "projectstage.create",
      EN: "Create",
      DA: "Opret",
      NO: "Opprett",
      FI: "Luo",
      SE: "Skapa"
    },
    {
      key: "projectstage.stagetitle",
      EN: "Stage Title",
      DA: "Fasetitel",
      NO: "Fasetittel",
      FI: "Vaiheen otsikko",
      SE: "Fas titel"
    },
    {
      key: "projectstage.stagetitleplace",
      EN: "Enter stage title",
      DA: "Indtast fasetitel",
      NO: "Skriv inn fasetittel",
      FI: "Anna vaiheen otsikko",
      SE: "Ange fas titel"
    },
    {
      key: "projectstage.stagetitlehelp",
      EN: "Set the name for your stage",
      DA: "Indstil navnet på din fase",
      NO: "Sett navnet på fasen din",
      FI: "Aseta vaiheesi nimi",
      SE: "Ange namn för din fas"
    },
    {
      key: "projectstage.stagedescription",
      EN: "Stage Description",
      DA: "Fasebeskrivelse",
      NO: "Fasebeskrivelse",
      FI: "Vaiheen kuvaus",
      SE: "Fasbeskrivning"
    },
    {
      key: "projectstage.stagedescriptionplace",
      EN: "Enter stage description",
      DA: "Indtast fasebeskrivelse",
      NO: "Skriv inn fasebeskrivelse",
      FI: "Anna vaiheen kuvaus",
      SE: "Ange fasbeskrivning"
    },
    {
      key: "projectstage.stagedescriptionhelp",
      EN: "Set the description for your stage",
      DA: "Indstil beskrivelsen for din fase",
      NO: "Sett beskrivelsen for fasen din",
      FI: "Aseta vaiheen kuvaus",
      SE: "Ange beskrivning för din fas"
    },
    {
      key: "projectstage.enddate",
      EN: "End date",
      DA: "Slutdato",
      NO: "Sluttdato",
      FI: "Päättymispäivä",
      SE: "Slutdatum"
    },
    {
      key: "projectstage.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "projectstage.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "projectstage.deletestage",
      EN: "Delete stage",
      DA: "Slet fase",
      NO: "Slett fase",
      FI: "Poista vaihe",
      SE: "Radera fas"
    },
    {
      key: "projectstage.confirmdelete",
      EN: "Are you sure you want to delete this stage?",
      DA: "Er du sikker på, at du vil slette denne fase?",
      NO: "Er du sikker på at du vil slette denne fasen?",
      FI: "Oletko varma, että haluat poistaa tämän vaiheen?",
      SE: "Är du säker på att du vill radera denna fas?"
    },
    {
      key: "projectstage.confirmdeleteheader",
      EN: "Confirm stage deletion",
      DA: "Bekræft sletning af fase",
      NO: "Bekreft sletting av fase",
      FI: "Vahvista vaiheen poistaminen",
      SE: "Bekräfta radering av fas"
    },
    {
      key: "taskeditmodal.succesalert",
      EN: "Task updated",
      DA: "Opgave opdateret",
      NO: "Oppgave oppdatert",
      FI: "Tehtävä päivitetty",
      SE: "Uppgift uppdaterad"
    },
    {
      key: "projecttask.deletedalert",
      EN: "Task deleted",
      DA: "Opgave slettet",
      NO: "Oppgave slettet",
      FI: "Tehtävä poistettu",
      SE: "Uppgift borttagen"
    },
    {
      key: "projecttask.project",
      EN: "Project - ",
      DA: "Projekt - ",
      NO: "Prosjekt - ",
      FI: "Projekti - ",
      SE: "Projekt - "
    },
    {
      key: "projecttask.duration",
      EN: "Duration - ",
      DA: "Varighed - ",
      NO: "Varighet - ",
      FI: "Kesto - ",
      SE: "Varaktighet - "
    },
    {
      key: "projecttask.customer",
      EN: "Customer - ",
      DA: "Kunde - ",
      NO: "Kunde - ",
      FI: "Asiakas - ",
      SE: "Kund - "
    },
    {
      key: "projecttask.taskisdone",
      EN: "Task is Done",
      DA: "Opgaven er fuldført",
      NO: "Oppgaven er fullført",
      FI: "Tehtävä on suoritettu",
      SE: "Uppgiften är klar"
    },
    {
      key: "projecttask.attachtip",
      EN: "Files are attached to this task",
      DA: "Filer er vedhæftet til denne opgave",
      NO: "Filer er vedlagt denne oppgaven",
      FI: "Tiedostot on liitetty tähän tehtävään",
      SE: "Filer är bifogade till denna uppgift"
    },
    {
      key: "projecttask.commentsrelated",
      EN: "Comments related to this task",
      DA: "Kommentarer relateret til denne opgave",
      NO: "Kommentarer relatert til denne oppgaven",
      FI: "Kommentit liittyvät tähän tehtävään",
      SE: "Kommentarer relaterade till denna uppgift"
    },
    {
      key: "projecttask.visibilityvendor",
      EN: "This task is only visible to the vendor",
      DA: "Denne opgave er kun synlig for leverandøren",
      NO: "Denne oppgaven er kun synlig for leverandøren",
      FI: "Tämä tehtävä näkyy vain toimittajalle",
      SE: "Denna uppgift är endast synlig för leverantören"
    },
    {
      key: "projecttask.finishtask",
      EN: "Finish Task",
      DA: "Afslut opgave",
      NO: "Fullfør oppgave",
      FI: "Valmis tehtävä",
      SE: "Avsluta uppgift"
    },
    {
      key: "projecttask.duedate",
      EN: "Due date - ",
      DA: "Forfaldsdato - ",
      NO: "Forfallsdato - ",
      FI: "Eräpäivä - ",
      SE: "Förfallodag - "
    },
    {
      key: "projecttask.eventstart",
      EN: "Event start - ",
      DA: "Starttidspunkt - ",
      NO: "Starttidspunkt - ",
      FI: "Aloitusaika - ",
      SE: "Starttidpunkt - "
    },
    {
      key: "projecttask.eventend",
      EN: "Event end - ",
      DA: "Sluttidspunkt - ",
      NO: "Sluttidspunkt - ",
      FI: "Päättymisaika - ",
      SE: "Sluttidpunkt - "
    },
    {
      key: "projecttask.startdate",
      EN: "Start Date - ",
      DA: "Startdato - ",
      NO: "Startdato - ",
      FI: "Aloituspäivä - ",
      SE: "Startdatum - "
    },
    {
      key: "projecttask.filesareattached",
      EN: "Files are attached to this task",
      DA: "Filer er vedhæftet til denne opgave",
      NO: "Filer er vedlagt denne oppgaven",
      FI: "Tiedostot on liitetty tähän tehtävään",
      SE: "Filer är bifogade till denna uppgift"
    },
    {
      key: "projecttask.taskduetoday",
      EN: "Task due today",
      DA: "Opgaven forfalder i dag",
      NO: "Oppgaven forfaller i dag",
      FI: "Tehtävä erääntyy tänään",
      SE: "Uppgiften förfaller idag"
    },
    {
      key: "projecttask.taskdue",
      EN: "Task due",
      DA: "Opgaven forfalder",
      NO: "Oppgaven forfaller",
      FI: "Tehtävä erääntyy",
      SE: "Uppgiften förfaller"
    },
    {
      key: "projecttask.deletetask",
      EN: "Delete Task",
      DA: "Slet opgave",
      NO: "Slett oppgave",
      FI: "Poista tehtävä",
      SE: "Radera uppgift"
    },
    {
      key: "projecttask.edittask",
      EN: "Edit Task",
      DA: "Rediger opgave",
      NO: "Rediger oppgave",
      FI: "Muokkaa tehtävää",
      SE: "Redigera uppgift"
    },
    {
      key: "projecttask.attachfiles",
      EN: "Attach files",
      DA: "Vedhæft filer",
      NO: "Legg ved filer",
      FI: "Liitä tiedostoja",
      SE: "Bifoga filer"
    },
    {
      key: "projecttask.commentontask",
      EN: "Comment On Task",
      DA: "Kommenter på opgaven",
      NO: "Kommenter på oppgaven",
      FI: "Kommentoi tehtävää",
      SE: "Kommentera uppgiften"
    },
    {
      key: "projecttask.launchproject",
      EN: "Launch Project",
      DA: "Lancér projekt",
      NO: "Start prosjekt",
      FI: "Käynnistä projekti",
      SE: "Starta projekt"
    },
    {
      key: "projecttask.formtemplate",
      EN: "Form Template",
      DA: "Formularskabelon",
      NO: "Skjemamal",
      FI: "Lomakepohja",
      SE: "Formulärmall"
    },
    {
      key: "projecttask.selectform",
      EN: "Select a form template...",
      DA: "Vælg en formularskabelon...",
      NO: "Velg en skjemamal...",
      FI: "Valitse lomakepohja...",
      SE: "Välj en formulärmall..."
    },
    {
      key: "projecttask.loadingforms",
      EN: "Loading forms...",
      DA: "Indlæser formularer...",
      NO: "Laster skjemaer...",
      FI: "Ladataan lomakkeita...",
      SE: "Laddar formulär..."
    },
    {
      key: "projecttask.nopublishedforms",
      EN: "No published forms available",
      DA: "Ingen offentliggjorte formularer tilgængelige",
      NO: "Ingen publiserte skjemaer tilgjengelige",
      FI: "Ei julkaistuja lomakkeita saatavilla",
      SE: "Inga publicerade formulär tillgängliga"
    },
    {
      key: "projecttask.publishformsfirst",
      EN: "Please publish a form template before linking to tasks",
      DA: "Udgiv venligst en formularskabelon, før du linker til opgaver",
      NO: "Vennligst publiser en skjemamal før du kobler til oppgaver",
      FI: "Julkaise lomakepohja ennen kuin linkität tehtäviin",
      SE: "Vänligen publicera en formulärmall innan du länkar till uppgifter"
    },
    {
      key: "projecttask.formerror",
      EN: "Please select a form template",
      DA: "Vælg venligst en formularskabelon",
      NO: "Vennligst velg en skjemamal",
      FI: "Valitse lomakepohja",
      SE: "Vänligen välj en formulärmall"
    },
    {
      key: "projecttask.linkedform",
      EN: "Linked Form",
      DA: "Tilknyttet formular",
      NO: "Tilknyttet skjema",
      FI: "Linkitetty lomake",
      SE: "Länkat formulär"
    },
    {
      key: "projecttask.marktaskasdone",
      EN: "Mark Task as Done",
      DA: "Marker opgaven som fuldført",
      NO: "Marker oppgaven som fullført",
      FI: "Merkitse tehtävä tehdyksi",
      SE: "Markera uppgiften som klar"
    },
    {
      key: "projecttask.formfill",
      EN: "Open form",
      DA: "Åbn formular",
      NO: "Åpne skjema",
      FI: "Avaa lomake",
      SE: "Öppna formulär"
    },
    {
      key: "projecttask.formtip",
      EN: "Formular attached",
      DA: "Form vedhæftet",
      NO: "Skjema vedlagt",
      FI: "Lomake liitetty",
      SE: "Formulär bifogat"
    },
    {
      key: "projecttask.marktaskasundone",
      EN: "Mark Task as Undone",
      DA: "Marker opgaven som ikke fuldført",
      NO: "Marker oppgaven som ikke fullført",
      FI: "Merkitse tehtävä tekemättömäksi",
      SE: "Markera uppgiften som ej klar"
    },
    {
      key: "projecttask.title",
      EN: "Title",
      DA: "Titel",
      NO: "Tittel",
      FI: "Otsikko",
      SE: "Titel"
    },
    {
      key: "projecttask.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "projecttask.descriptionplace",
      EN: "Enter task description",
      DA: "Indtast opgavebeskrivelse",
      NO: "Skriv oppgavebeskrivelse",
      FI: "Anna tehtävän kuvaus",
      SE: "Ange uppgiftsbeskrivning"
    },
    {
      key: "projecttask.responsible",
      EN: "Responsible",
      DA: "Ansvarlig",
      NO: "Ansvarlig",
      FI: "Vastuuhenkilö",
      SE: "Ansvarig"
    },
    {
      key: "projecttask.warning",
      EN: "Warning",
      DA: "Advarsel",
      NO: "Advarsel",
      FI: "Varoitus",
      SE: "Varning"
    },
    {
      key: "projecttask.warningmsg",
      EN: "Setting responsible to someone else will make you lose access to editing and deleting this task after you save it. Please accept this by checking the check box:",
      DA: "Hvis du tildeler ansvaret til en anden, mister du adgangen til at redigere og slette denne opgave, efter du gemmer den. Accepter dette ved at markere afkrydsningsfeltet:",
      NO: "Å sette ansvarlig til noen andre vil gjøre at du mister tilgang til å redigere og slette denne oppgaven etter at du lagrer den. Vennligst aksepter dette ved å merke av i avmerkingsboksen:",
      FI: "Vastuuhenkilön vaihtaminen toiselle vie sinulta oikeuden muokata tai poistaa tätä tehtävää tallennuksen jälkeen. Hyväksy tämä rastittamalla valintaruutu:",
      SE: "Genom att sätta ansvarig på någon annan förlorar du möjligheten att redigera och radera denna uppgift efter att du har sparat den. Acceptera detta genom att kryssa i rutan:"
    },
    {
      key: "projecttask.startdat",
      EN: "Start date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivä",
      SE: "Startdatum"
    },
    {
      key: "projecttask.duedat",
      EN: "Due date",
      DA: "Forfaldsdato",
      NO: "Forfallsdato",
      FI: "Eräpäivä",
      SE: "Förfallodag"
    },
    {
      key: "projecttask.visibility",
      EN: "Visibility",
      DA: "Synlighed",
      NO: "Synlighet",
      FI: "Näkyvyys",
      SE: "Synlighet"
    },
    {
      key: "projecttask.shared",
      EN: "Shared",
      DA: "Delt",
      NO: "Delt",
      FI: "Jaettu",
      SE: "Delad"
    },
    {
      key: "projecttask.vendoronly",
      EN: "Vendor only",
      DA: "Kun leverandør",
      NO: "Kun leverandør",
      FI: "Vain toimittaja",
      SE: "Endast leverantör"
    },
    {
      key: "projecttask.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "projecttask.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "projecttask.pleaseconfirm",
      EN: "Please confirm the removal of the task",
      DA: "Bekræft venligst sletningen af opgaven",
      NO: "Vennligst bekreft fjerning av oppgaven",
      FI: "Vahvista tehtävän poistaminen",
      SE: "Vänligen bekräfta borttagningen av uppgiften"
    },
    {
      key: "projecttask.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "projecttask.delete",
      EN: "Delete",
      DA: "Slet",
      NO: "Slett",
      FI: "Poista",
      SE: "Radera"
    },
    {
      key: "usersettings.updated",
      EN: "Updated!",
      DA: "Opdateret!",
      NO: "Oppdatert!",
      FI: "Päivitetty!",
      SE: "Uppdaterad!"
    },
    {
      key: "usersettings.usersettingsheader",
      EN: "User Settings",
      DA: "Brugerindstillinger",
      NO: "Brukerinnstillinger",
      FI: "Käyttäjäasetukset",
      SE: "Användarinställningar"
    },
    {
      key: "usersettings.systemlanguage",
      EN: "System Language",
      DA: "Systemets sprog",
      NO: "Systemspråk",
      FI: "Järjestelmän kieli",
      SE: "Systemspråk"
    },
    {
      key: "usersettings.default",
      EN: "Default",
      DA: "Standard",
      NO: "Standard",
      FI: "Oletus",
      SE: "Standard"
    },
    {
      key: "usersettings.english",
      EN: "English",
      DA: "Engelsk",
      NO: "Engelsk",
      FI: "Englanti",
      SE: "Engelska"
    },
    {
      key: "usersettings.danish",
      EN: "Danish",
      DA: "Dansk",
      NO: "Dansk",
      FI: "Tanska",
      SE: "Danska"
    },
    {
      key: "usersettings.swedish",
      EN: "Swedish",
      DA: "Svensk",
      NO: "Svensk",
      FI: "Ruotsi",
      SE: "Svenska"
    },
    {
      key: "usersettings.norwegian",
      EN: "Norwegian",
      DA: "Norsk",
      NO: "Norsk",
      FI: "Norja",
      SE: "Norska"
    },
    {
      key: "usersettings.finnish",
      EN: "Finnish",
      DA: "Finsk",
      NO: "Finsk",
      FI: "Suomi",
      SE: "Finska"
    },
    {
      key: "usersettings.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "usersettings.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "refreshauth.refreshauthentication",
      EN: "Refresh authentication",
      DA: "Opdater godkendelse",
      NO: "Oppdater autentisering",
      FI: "Päivitä todennus",
      SE: "Uppdatera autentisering"
    },
    {
      key: "refreshauth.Authenticationrefreshed",
      EN: "Authentication Refreshed",
      DA: "Godkendelse opdateret",
      NO: "Autentisering oppdatert",
      FI: "Todennus päivitetty",
      SE: "Autentisering uppdaterad"
    },
    {
      key: "useraccount.editinformation",
      EN: "Information",
      DA: "Oplysninger",
      NO: "Informasjon",
      FI: "Tietoja",
      SE: "Information"
    },
    {
      key: "useraccount.managephoto",
      EN: "Manage photo",
      DA: "Administrer billede",
      NO: "Administrer bilde",
      FI: "Hallitse kuvaa",
      SE: "Hantera foto"
    },
    {
      key: "useraccount.settings",
      EN: "Settings",
      DA: "Indstillinger",
      NO: "Innstillinger",
      FI: "Asetukset",
      SE: "Inställningar"
    },
    {
      key: "useraccount.settingstip",
      EN: "User Settings",
      DA: "Brugerindstillinger",
      NO: "Brukerinnstillinger",
      FI: "Käyttäjän asetukset",
      SE: "Användarinställningar"
    },
    {
      key: "useraccount.support",
      EN: "Support",
      DA: "Support",
      NO: "Støtte",
      FI: "Tuki",
      SE: "Support"
    },
    {
      key: "useraccount.privacypolicy",
      EN: "Privacy policy",
      DA: "Privatlivspolitik",
      NO: "Personvernerklæring",
      FI: "Tietosuojakäytäntö",
      SE: "Integritetspolicy"
    },
    {
      key: "useraccount.termsofuse",
      EN: "Terms of use",
      DA: "Brugsbetingelser",
      NO: "Bruksvilkår",
      FI: "Käyttöehdot",
      SE: "Användarvillkor"
    },
    {
      key: "useraccount.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "useraccount.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "person.email",
      EN: "Email",
      DA: "E-mail",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "person.emailhelp",
      EN: "Type your email here",
      DA: "Indtast din e-mail her",
      NO: "Skriv inn din e-post her",
      FI: "Kirjoita sähköpostisi tähän",
      SE: "Ange din e-post här"
    },
    {
      key: "person.phone",
      EN: "Phone",
      DA: "Telefon",
      NO: "Telefon",
      FI: "Puhelin",
      SE: "Telefon"
    },
    {
      key: "person.phonehelp",
      EN: "Type your phone number here",
      DA: "Indtast dit telefonnummer her",
      NO: "Skriv inn ditt telefonnummer her",
      FI: "Kirjoita puhelinnumerosi tähän",
      SE: "Ange ditt telefonnummer här"
    },
    {
      key: "person.instantmessaging",
      EN: "Instant messaging",
      DA: "Chatbesked",
      NO: "Direktemelding",
      FI: "Pikaviestin",
      SE: "Snabbmeddelanden"
    },
    {
      key: "person.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "person.descriptionhelp",
      EN: "Describe your role in the organization",
      DA: "Beskriv din rolle i organisationen",
      NO: "Beskriv din rolle i organisasjonen",
      FI: "Kuvaile rooliasi organisaatiossa",
      SE: "Beskriv din roll i organisationen"
    },
    {
      key: "person.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "person.namehelp",
      EN: "Type your name here",
      DA: "Indtast dit navn her",
      NO: "Skriv inn ditt navn her",
      FI: "Kirjoita nimesi tähän",
      SE: "Skriv ditt namn här"
    },
    {
      key: "person.imhelp",
      EN: "Type your instant messaging handle",
      DA: "Indtast dit chatnavn",
      NO: "Skriv inn ditt brukernavn for direktemelding",
      FI: "Kirjoita pikaviestintänimesi",
      SE: "Ange ditt snabbmeddelande-ID"
    },
    {
      key: "person.defaultorganization",
      EN: "Default organization",
      DA: "Standardorganisation",
      NO: "Standardorganisasjon",
      FI: "Oletusorganisaatio",
      SE: "Standardorganisation"
    },
    {
      key: "person.defaultorganizationhelp",
      EN: "Select your default organization",
      DA: "Vælg din standardorganisation",
      NO: "Velg din standardorganisasjon",
      FI: "Valitse oletusorganisaatiosi",
      SE: "Välj din standardorganisation"
    },
    {
      key: "personimage.header",
      EN: "Profile picture",
      DA: "Profilbillede",
      NO: "Profilbilde",
      FI: "Profiilikuva",
      SE: "Profilbild"
    },
    {
      key: "personimage.successmsg",
      EN: "Your image was successfully changed!",
      DA: "Dit billede blev ændret med succes!",
      NO: "Bildet ditt ble endret!",
      FI: "Kuvasi on vaihdettu onnistuneesti!",
      SE: "Din bild har ändrats!"
    },
    {
      key: "personimage.choosefile",
      EN: "Choose file...",
      DA: "Vælg fil...",
      NO: "Velg fil...",
      FI: "Valitse tiedosto...",
      SE: "Välj fil..."
    },
    {
      key: "personimage.croptofit",
      EN: "Here you can crop your image to fit",
      DA: "Her kan du beskære dit billede, så det passer",
      NO: "Her kan du beskjære bildet ditt",
      FI: "Täällä voit rajata kuvasi sopivaksi",
      SE: "Här kan du beskära din bild"
    },
    {
      key: "personimage.croppreview",
      EN: "This is your preview of your crop",
      DA: "Dette er din forhåndsvisning af beskæringen",
      NO: "Dette er forhåndsvisningen av beskjæringen din",
      FI: "Tämä on esikatselusi rajauksesta",
      SE: "Detta är din förhandsgranskning av beskärningen"
    },
    {
      key: "personimage.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "personimage.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "personmodal.sendalert",
      EN: "If left unchecked the user will not receive login credentials.",
      DA: "Hvis dette felt ikke er markeret, vil kunden ikke modtage loginoplysninger.",
      NO: "Hvis dette ikke er markert, vil kunden ikke motta innloggingsinformasjon.",
      FI: "Jos tätä ei valita, asiakas ei saa kirjautumistietoja.",
      SE: "Om detta inte är markerat kommer kunden inte att få inloggningsuppgifter."
    },
    {
      key: "personmodal.sendalert2",
      EN: "The user will receive login credentials.",
      DA: "Kunden vil nu modtage loginoplysninger.",
      NO: "Kunden vil nå motta innloggingsinformasjon.",
      FI: "Asiakas saa nyt kirjautumistiedot.",
      SE: "Kunden kommer nu att få inloggningsuppgifter."
    },
    {
      key: "personmodal.header",
      EN: "Person Information",
      DA: "Personoplysninger",
      NO: "Personinformasjon",
      FI: "Henkilötiedot",
      SE: "Personinformation"
    },
    {
      key: "personmodal.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "personmodal.function",
      EN: "Function",
      DA: "Funktion",
      NO: "Funksjon",
      FI: "Tehtävä",
      SE: "Funktion"
    },
    {
      key: "personmodal.phone",
      EN: "Phone",
      DA: "Telefon",
      NO: "Telefon",
      FI: "Puhelin",
      SE: "Telefon"
    },
    {
      key: "personmodal.kickalert",
      EN: "Important: This action will remove any record off the users on current and past projects, all access will be removed!",
      DA: "Vigtigt: Denne handling vil fjerne alle brugeres optegnelser fra nuværende og tidligere projekter, al adgang vil blive fjernet!",
      NO: "Viktig: Denne handlingen vil fjerne alle brukerens oppføringer fra nåværende og tidligere prosjekter, all tilgang vil bli fjernet!",
      FI: "Tärkeää: Tämä toiminto poistaa käyttäjän kaikki tiedot nykyisistä ja aiemmista projekteista, kaikki pääsy poistetaan!",
      SE: "Viktigt: Den här åtgärden tar bort alla användarens poster i nuvarande och tidigare projekt, all åtkomst kommer att tas bort!"
    },
    {
      key: "personmodal.nofunction",
      EN: "Important: Member function has not been set, you can not assign a role without a function present!",
      DA: "Vigtigt: Medlemsfunktion er ikke blevet angivet, du kan ikke tildele en rolle uden en funktion!",
      NO: "Viktig: Medlemsfunksjonen er ikke angitt, du kan ikke tildele en rolle uten en funksjon!",
      FI: "Tärkeää: Jäsenen tehtävää ei ole asetettu, et voi antaa roolia ilman tehtävää!",
      SE: "Viktigt: Medlemsfunktion har inte angetts, du kan inte tilldela en roll utan en funktion!"
    },
    {
      key: "personmodal.editperson",
      EN: "Edit person",
      DA: "Rediger person",
      NO: "Rediger person",
      FI: "Muokkaa henkilöä",
      SE: "Redigera person"
    },
    {
      key: "personmodal.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "personmodal.deletefromorg",
      EN: "Delete from org",
      DA: "Slet fra organisation",
      NO: "Slett fra organisasjon",
      FI: "Poista organisaatiosta",
      SE: "Ta bort från organisation"
    },
    {
      key: "personmodal.remove",
      EN: "Remove",
      DA: "Fjern",
      NO: "Fjern",
      FI: "Poista",
      SE: "Ta bort"
    },
    {
      key: "personmodal.hasbeenremoved",
      EN: "has been removed",
      DA: "er blevet fjernet",
      NO: "har blitt fjernet",
      FI: "on poistettu",
      SE: "har tagits bort"
    },
    {
      key: "personmodal.userrole",
      EN: "User Role",
      DA: "Brugerrolle",
      NO: "Brukerrolle",
      FI: "Käyttäjärooli",
      SE: "Användarroll"
    },
    {
      key: "personmodal.userpostion",
      EN: "User Position",
      DA: "Brugerposition",
      NO: "Brukerposisjon",
      FI: "Käyttäjän asema",
      SE: "Användarposition"
    },
    {
      key: "personmodal.admin",
      EN: "Admin",
      DA: "Administrator",
      NO: "Administrator",
      FI: "Ylläpitäjä",
      SE: "Administratör"
    },
    {
      key: "personmodal.user",
      EN: "User",
      DA: "Bruger",
      NO: "Bruker",
      FI: "Käyttäjä",
      SE: "Användare"
    },
    {
      key: "personmodal.positionhelp",
      EN: "Enter Position",
      DA: "Indtast position",
      NO: "Skriv inn posisjon",
      FI: "Syötä asema",
      SE: "Ange position"
    },
    {
      key: "personmodal.sendemailinvite",
      EN: "Send email invite",
      DA: "Send email-invitation",
      NO: "Send e-postinvitasjon",
      FI: "Lähetä sähköpostikutsu",
      SE: "Skicka e-postinbjudan"
    },
    {
      key: "personmodal.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "personname.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "personname.closetip",
      EN: "Click To Close",
      DA: "Klik for at lukke",
      NO: "Klikk for å lukke",
      FI: "Napsauta sulkeaksesi",
      SE: "Klicka för att stänga"
    },
    {
      key: "personorglist.header",
      EN: "Your Organisations",
      DA: "Dine organisationer",
      NO: "Dine organisasjoner",
      FI: "Organisaatiosi",
      SE: "Dina organisationer"
    },
    {
      key: "personorglist.orgname",
      EN: "Organisation Name",
      DA: "Organisationsnavn",
      NO: "Organisasjonsnavn",
      FI: "Organisaation nimi",
      SE: "Organisationsnamn"
    },
    {
      key: "personorglist.relation",
      EN: "Relation",
      DA: "Relation",
      NO: "Relasjon",
      FI: "Suhde",
      SE: "Relation"
    },
    {
      key: "personorglist.requesteddate",
      EN: "Requested Date",
      DA: "Anmodet dato",
      NO: "Anmodet dato",
      FI: "Pyyntöpäivämäärä",
      SE: "Begärd datum"
    },
    {
      key: "personorglist.joineddate",
      EN: "Joined Date",
      DA: "Dato for tilslutning",
      NO: "Bli med dato",
      FI: "Liittymis päivä",
      SE: "Datum för anslutning"
    },
    {
      key: "personorglist.exitdate",
      EN: "Exit Date",
      DA: "Udrejse dato",
      NO: "Utgangsdato",
      FI: "Poistumispäivämäärä",
      SE: "Utträdesdatum"
    },
    {
      key: "personorglist.showdetailsof",
      EN: "Show details of",
      DA: "Vis detaljer om",
      NO: "Vis detaljer om",
      FI: "Näytä tiedot",
      SE: "Visa detaljer om"
    },
    {
      key: "personorglist.relationtip",
      EN: "Your Relation",
      DA: "Din relation",
      NO: "Din relasjon",
      FI: "Suhteesi",
      SE: "Din relation"
    },
    {
      key: "personorglist.daterequested",
      EN: "Date Requested",
      DA: "Anmodet dato",
      NO: "Anmodet dato",
      FI: "Pyyntöpäivämäärä",
      SE: "Begärd datum"
    },
    {
      key: "personorglist.datejoined",
      EN: "Date joined",
      DA: "Dato for tilslutning",
      NO: "Dato for deltakelse",
      FI: "Liittymis päivämäärä",
      SE: "Datum för anslutning"
    },
    {
      key: "personorglist.dateleft",
      EN: "Date left",
      DA: "Dato for afgang",
      NO: "Utgangsdato",
      FI: "Poistumispäivämäärä",
      SE: "Utträdesdatum"
    },
    {
      key: "personorglist.breakwarning",
      EN: "You're breaking the link with orgDetail.organizationname!",
      DA: "Du bryder forbindelsen med orgDetail.organizationname!",
      NO: "Du bryter forbindelsen med orgDetail.organizationname!",
      FI: "Rikot linkin orgDetail.organizationname!",
      SE: "Du bryter länken med orgDetail.organizationname!"
    },
    {
      key: "personorglist.confirmbreak",
      EN: "Confirm breaking Link to Organisation",
      DA: "Bekræft brydning af link til organisation",
      NO: "Bekreft brudd på lenke til organisasjonen",
      FI: "Vahvista linkin rikkominen organisaatioon",
      SE: "Bekräfta brytning av länken till organisationen"
    },
    {
      key: "personorglist.breaklink",
      EN: "Break Link to Organisation",
      DA: "Bryde link til organisation",
      NO: "Bryte lenke til organisasjon",
      FI: "Rikkoa linkki organisaatioon",
      SE: "Bryt länk till organisation"
    },
    {
      key: "personorglist.relink",
      EN: "Relink to Organisation",
      DA: "Genopret link til organisation",
      NO: "Gjenopprett lenke til organisasjon",
      FI: "Palauta linkki organisaatioon",
      SE: "Återkoppla till organisation"
    },
    {
      key: "tagadmin.tagadministration",
      EN: "Tag administration",
      DA: "Tagadministration",
      NO: "Tagadministrasjon",
      FI: "Tag-hallinta",
      SE: "Taggadministration"
    },
    {
      key: "tagadmin.customertags",
      EN: "Customer tags",
      DA: "Kundemærker",
      NO: "Kundetiketter",
      FI: "Asiakastunnisteet",
      SE: "Kundtaggar"
    },
    {
      key: "tagadmin.customertagsplace",
      EN: "Your tag...",
      DA: "Din tag...",
      NO: "Din tag...",
      FI: "Oma tagisi...",
      SE: "Din tagg..."
    },
    {
      key: "tagadmin.projecttags",
      EN: "Project tags",
      DA: "Projektmærker",
      NO: "Prosjektetiketter",
      FI: "Projektitunnisteet",
      SE: "Projekt-taggar"
    },
    {
      key: "topnav.admin",
      EN: "Admin",
      DA: "Admin",
      NO: "Admin",
      FI: "Admin",
      SE: "Admin"
    },
    {
      key: "topnav.portal",
      EN: "Portal",
      DA: "Portal",
      NO: "Portal",
      FI: "Portaali",
      SE: "Portal"
    },
    {
      key: "topnav.people",
      EN: "People",
      DA: "Personer",
      NO: "Personer",
      FI: "Ihmiset",
      SE: "Personer"
    },
    {
      key: "topnav.planning",
      EN: "Planning",
      DA: "Planlægning",
      NO: "Planlegging",
      FI: "Suunnittelu",
      SE: "Planering"
    },
    {
      key: "topnav.customers",
      EN: "Customers",
      DA: "Kunder",
      NO: "Kunder",
      FI: "Asiakkaat",
      SE: "Kunder"
    },
    {
      key: "topnav.adhoc",
      EN: "Adhoc",
      DA: "Ad hoc",
      NO: "Ad hoc",
      FI: "Ad hoc",
      SE: "Ad hoc"
    },
    {
      key: "adhoc.title",
      EN: "Adhoc tasks",
      DA: "Ad hoc-opgaver",
      NO: "Ad hoc-oppgaver",
      FI: "Ad hoc -tehtävät",
      SE: "Ad hoc-uppgifter"
    },
    {
      key: "adhoc.subtitle",
      EN: "Tasks not tied to a project stage",
      DA: "Opgaver der ikke er knyttet til et projektstadie",
      NO: "Oppgaver som ikke er knyttet til et prosjektstadium",
      FI: "Tehtävät, jotka eivät liity projektin vaiheeseen",
      SE: "Uppgifter som inte är kopplade till ett projektstadium"
    },
    {
      key: "adhoc.createtip",
      EN: "Create adhoc task",
      DA: "Opret ad hoc-opgave",
      NO: "Opprett ad hoc-oppgave",
      FI: "Luo ad hoc -tehtävä",
      SE: "Skapa ad hoc-uppgift"
    },
    {
      key: "adhoc.notasks",
      EN: "No adhoc tasks yet",
      DA: "Ingen ad hoc-opgaver endnu",
      NO: "Ingen ad hoc-oppgaver ennå",
      FI: "Ei vielä ad hoc -tehtäviä",
      SE: "Inga ad hoc-uppgifter än"
    },
    {
      key: "adhoc.responsible",
      EN: "Responsible",
      DA: "Ansvarlig",
      NO: "Ansvarlig",
      FI: "Vastuuhenkilö",
      SE: "Ansvarig"
    },
    {
      key: "adhoc.project",
      EN: "Project",
      DA: "Projekt",
      NO: "Prosjekt",
      FI: "Projekti",
      SE: "Projekt"
    },
    {
      key: "adhoc.customer",
      EN: "Customer",
      DA: "Kunde",
      NO: "Kunde",
      FI: "Asiakas",
      SE: "Kund"
    },
    {
      key: "adhoc.duedate",
      EN: "Due date",
      DA: "Forfaldsdato",
      NO: "Forfallsdato",
      FI: "Eräpäivä",
      SE: "Förfallodatum"
    },
    {
      key: "adhoc.startdate",
      EN: "Start date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivä",
      SE: "Startdatum"
    },
    {
      key: "adhoc.edittask",
      EN: "Edit adhoc task",
      DA: "Rediger ad hoc-opgave",
      NO: "Rediger ad hoc-oppgave",
      FI: "Muokkaa ad hoc -tehtävää",
      SE: "Redigera ad hoc-uppgift"
    },
    {
      key: "adhoc.newtask",
      EN: "New adhoc task",
      DA: "Ny ad hoc-opgave",
      NO: "Ny ad hoc-oppgave",
      FI: "Uusi ad hoc -tehtävä",
      SE: "Ny ad hoc-uppgift"
    },
    {
      key: "adhoc.tasktitle",
      EN: "Title",
      DA: "Titel",
      NO: "Tittel",
      FI: "Otsikko",
      SE: "Titel"
    },
    {
      key: "adhoc.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "adhoc.choose",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "adhoc.optional",
      EN: "optional",
      DA: "valgfri",
      NO: "valgfritt",
      FI: "valinnainen",
      SE: "valfritt"
    },
    {
      key: "adhoc.none",
      EN: "None",
      DA: "Ingen",
      NO: "Ingen",
      FI: "Ei mitään",
      SE: "Ingen"
    },
    {
      key: "adhoc.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "adhoc.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "notification.shownotifications",
      EN: "Show Notifications",
      DA: "Vis notifikationer",
      NO: "Vis varsler",
      FI: "Näytä ilmoitukset",
      SE: "Visa aviseringar"
    },
    {
      key: "notification.notifications",
      EN: "Notifications",
      DA: "Notifikationer",
      NO: "Varsler",
      FI: "Ilmoitukset",
      SE: "Aviseringar"
    },
    {
      key: "notification.useraccount",
      EN: "User Account",
      DA: "Brugerkonto",
      NO: "Brukerkonto",
      FI: "Käyttäjätili",
      SE: "Användarkonto"
    },
    {
      key: "orgaccount.automations",
      EN: "Automations",
      DA: "Automatiseringer",
      NO: "Automatiseringer",
      FI: "Automaatio",
      SE: "Automationer"
    },
    {
      key: "notification.orgaccount",
      EN: "Org Account",
      DA: "Organisationskonto",
      NO: "Organisasjonskonto",
      FI: "Organisaatiotili",
      SE: "Organisationskonto"
    },
    {
      key: "orgaccount.emaildelivery",
      EN: "Email delivery",
      DA: "E-mail levering",
      NO: "E-postlevering",
      FI: "Sähköpostin toimitus",
      SE: "E-postleverans"
    },
    {
      key: "orgaccount.choosedelivery",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "orgaccount.apihere",
      EN: "Api key here...",
      DA: "API-nøgle her...",
      NO: "API-nøkkel her...",
      FI: "API-avain tähän...",
      SE: "API-nyckel här..."
    },
    {
      key: "orgaccount.apikey",
      EN: "Api key",
      DA: "API-nøgle",
      NO: "API-nøkkel",
      FI: "API-avain",
      SE: "API-nyckel"
    },
    {
      key: "orgaccount.fromaddress",
      EN: "From address",
      DA: "Fra adresse",
      NO: "Fra-adresse",
      FI: "Lahettajaosoite",
      SE: "Fran-adress"
    },
    {
      key: "orgaccount.fromaddresshere",
      EN: "From address here...",
      DA: "Fra adresse her...",
      NO: "Fra-adresse her...",
      FI: "Lahettajaosoite tahan...",
      SE: "Fran-adress har..."
    },
    {
      key: "notification.signout",
      EN: "Sign Out",
      DA: "Log ud",
      NO: "Logg ut",
      FI: "Kirjaudu ulos",
      SE: "Logga ut"
    },
    {
      key: "notification.confirm",
      EN: "Confirm",
      DA: "Bekræft",
      NO: "Bekreft",
      FI: "Vahvista",
      SE: "Bekräfta"
    },
    {
      key: "notification.created",
      EN: "Created: ",
      DA: "Oprettet: ",
      NO: "Opprettet: ",
      FI: "Luotu: ",
      SE: "Skapad: "
    },
    {
      key: "notification.markreadtip",
      EN: "Mark Message Read",
      DA: "Marker besked som læst",
      NO: "Merk melding som lest",
      FI: "Merkitse viesti luetuksi",
      SE: "Markera meddelande som läst"
    },
    {
      key: "notification.viewall",
      EN: "View All",
      DA: "Se alle",
      NO: "Se alle",
      FI: "Näytä kaikki",
      SE: "Visa alla"
    },
    {
      key: "notification.areyoustaying",
      EN: "Are You Staying?",
      DA: "Bliver du?",
      NO: "Blir du?",
      FI: "Jäätkö?",
      SE: "Stannar du?"
    },
    {
      key: "notification.pressabuttontocontinue",
      EN: "Press a button to continue",
      DA: "Tryk på en knap for at fortsætte",
      NO: "Trykk på en knapp for å fortsette",
      FI: "Paina painiketta jatkaaksesi",
      SE: "Tryck på en knapp för att fortsätta"
    },
    {
      key: "notification.stay",
      EN: "Stay",
      DA: "Bliv",
      NO: "Bli",
      FI: "Pysy",
      SE: "Stanna"
    },
    {
      key: "notification.leave",
      EN: "Leave",
      DA: "Forlad",
      NO: "Gå",
      FI: "Lähde",
      SE: "Lämna"
    },
    {
      key: "notification.notificationhistory",
      EN: "Notification History",
      DA: "Notifikationshistorik",
      NO: "Varselhistorikk",
      FI: "Ilmoitushistoria",
      SE: "Aviseringshistorik"
    },
    {
      key: "notification.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "orgswitcher.header",
      EN: "Choose organisation",
      DA: "Vælg organisation",
      NO: "Velg organisasjon",
      FI: "Valitse organisaatio",
      SE: "Välj organisation"
    },
    {
      key: "orgswitcher.subhead",
      EN: "Here you can choose what org to enter.",
      DA: "Her kan du vælge, hvilken organisation du vil åbne.",
      NO: "Her kan du velge hvilken organisasjon du vil åpne.",
      FI: "Täällä voit valita, mihin organisaatioon haluat siirtyä.",
      SE: "Här kan du välja vilken organisation du vill öppna."
    },
    {
      key: "support.faq",
      EN: "FAQS",
      DA: "Ofte stillede spørgsmål",
      NO: "Ofte stilte spørsmål",
      FI: "Usein kysytyt kysymykset",
      SE: "Vanliga frågor"
    },
    {
      key: "support.releasenotes",
      EN: "Release Notes",
      DA: "Udgivelsesnoter",
      NO: "Utgivelsesnotater",
      FI: "Julkaisutiedot",
      SE: "Versionsanteckningar"
    },
    {
      key: "support.faq1",
      EN: "How to create an account with ClearRamp?",
      DA: "Hvordan opretter jeg en konto hos ClearRamp?",
      NO: "Hvordan oppretter jeg en konto hos ClearRamp?",
      FI: "Kuinka luon tilin ClearRampilla?",
      SE: "Hur skapar jag ett konto hos ClearRamp?"
    },
    {
      key: "support.faq1answer",
      EN: "In the event that your organisation is already set up ask your administrator to create you and you will receive an email invitation to setup your account, in the case your organisation doesnt have an account reach out to us.",
      DA: "Hvis din organisation allerede er oprettet, bed din administrator om at oprette dig, og du vil modtage en e-mailinvitation til at oprette din konto. Hvis din organisation ikke har en konto, kan du kontakte os.",
      NO: "Dersom organisasjonen din allerede er satt opp, be administratoren din om å opprette deg, så vil du motta en e-postinvitasjon for å opprette kontoen din. Hvis organisasjonen din ikke har en konto, vennligst kontakt oss.",
      FI: "Jos organisaatiosi on jo asetettu, pyydä järjestelmänvalvojaasi luomaan sinut, ja saat sähköposti kutsun tilisi asettamiseksi. Jos organisaatiollasi ei ole tiliä, ota yhteyttä meihin.",
      SE: "Om din organisation redan är inställd, be din administratör att skapa dig, så får du en e-postinbjudan för att ställa in ditt konto. Om din organisation inte har ett konto, kontakta oss."
    },
    {
      key: "support.faq2",
      EN: "How to customize ClearRamp?",
      DA: "Hvordan tilpasser jeg ClearRamp?",
      NO: "Hvordan tilpasser jeg ClearRamp?",
      FI: "Kuinka räätälöin ClearRampia?",
      SE: "Hur anpassar jag ClearRamp?"
    },
    {
      key: "support.faq2answer",
      EN: "If you as an organisation have purchased whitelabelling this enables you to change and adapt lots of things about the UI to fit into your organisation branding, if anything is missing or you require additional assets please reach out to us.",
      DA: "Hvis din organisation har købt hvidmærkning, giver det dig mulighed for at ændre og tilpasse mange ting i brugergrænsefladen, så den passer til din organisations branding. Hvis noget mangler, eller du har brug for yderligere ressourcer, bedes du kontakte os.",
      NO: "Hvis din organisasjon har kjøpt hvitmerking, gir dette deg muligheten til å endre og tilpasse mange ting om brukergrensesnittet for å passe til merkevaren din. Hvis noe mangler eller du trenger ytterligere ressurser, vennligst ta kontakt med oss.",
      FI: "Jos organisaatiosi on ostanut valkoista etikettiä, tämä mahdollistaa UI:n monien asioiden muuttamisen ja mukauttamisen organisaatiosi brändin mukaiseksi. Jos jotain puuttuu tai tarvitset lisäresursseja, ota meihin yhteyttä.",
      SE: "Om din organisation har köpt vitmärkning kan detta göra att du kan ändra och anpassa många saker om användargränssnittet så att det passar din organisations varumärke. Om något saknas eller om du behöver ytterligare resurser, vänligen kontakta oss."
    },
    {
      key: "support.faq3",
      EN: "Why use ClearRamp?",
      DA: "Hvorfor bruge ClearRamp?",
      NO: "Hvorfor bruke ClearRamp?",
      FI: "Miksi käyttää ClearRampia?",
      SE: "Varför använda ClearRamp?"
    },
    {
      key: "support.faq3answer",
      EN: "ClearRamp helps SaaS vendors optimize customer onboarding by providing a simple and easy to use customer onboarding platform and a project care service that helps you succeed. Successful customer onboarding increase customer retention, engagement and lifetime value. All these benefits have a clear impact on your company’s success.",
      DA: "ClearRamp hjælper SaaS-udbydere med at optimere kundens onboarding ved at tilbyde en enkel og brugervenlig onboarding-platform og en projektplejeservice, der hjælper dig med at få succes. En vellykket onboarding af kunder øger kundens fastholdelse, engagement og livstidsværdi. Alle disse fordele har en klar indvirkning på din virksomheds succes.",
      NO: "ClearRamp hjelper SaaS-leverandører med å optimalisere kundens onboarding ved å tilby en enkel og brukervennlig onboarding-plattform og en prosjektpleietjeneste som hjelper deg med å lykkes. Vel lykkes onboarding av kunder øker kundelojaliteten, engasjementet og livstidsverdien. Alle disse fordelene har en klar innvirkning på selskapets suksess.",
      FI: "ClearRamp auttaa SaaS-toimittajia optimoimaan asiakaslähetykset tarjoamalla yksinkertaisen ja helppokäyttöisen asiakaslähetysalustan ja projektinhoitopalvelun, joka auttaa sinua menestymään. Onnistunut asiakaslähetys lisää asiakastyytyväisyyttä, sitoutumista ja elinkaaren arvoa. Kaikilla näillä eduilla on selvä vaikutus yrityksesi menestykseen.",
      SE: "ClearRamp hjälper SaaS-leverantörer att optimera kundernas onboarding genom att erbjuda en enkel och användarvänlig onboarding-plattform och en projektvårdservice som hjälper dig att lyckas. En framgångsrik onboarding ökar kundretentionen, engagemanget och livstidsvärdet. Alla dessa fördelar har en tydlig inverkan på företagets framgång."
    },
    {
      key: "support.report",
      EN: "Report a bug or Feature request",
      DA: "Rapportér en fejl eller funktionsanmodning",
      NO: "Rapporter en feil eller funksjonsforespørsel",
      FI: "Ilmoita virheestä tai ominaisuuspyynnöstä",
      SE: "Rapportera en bugg eller funktionsförfrågan"
    },
    {
      key: "support.contact",
      EN: "Contact - support@clearramp.com",
      DA: "Kontakt - support@clearramp.com",
      NO: "Kontakt - support@clearramp.com",
      FI: "Ota yhteyttä - support@clearramp.com",
      SE: "Kontakta - support@clearramp.com"
    },
    {
      key: "support.email",
      EN: "Email address",
      DA: "E-mail adresse",
      NO: "E-postadresse",
      FI: "Sähköpostiosoite",
      SE: "E-postadress"
    },
    {
      key: "support.type",
      EN: "Type",
      DA: "Type",
      NO: "Type",
      FI: "Tyyppi",
      SE: "Typ"
    },
    {
      key: "support.choose",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "support.bug",
      EN: "Bug",
      DA: "Fejl",
      NO: "Feil",
      FI: "Virhe",
      SE: "Bugg"
    },
    {
      key: "support.featurerequest",
      EN: "Feature request",
      DA: "Funktionsanmodning",
      NO: "Funksjonsforespørsel",
      FI: "Ominaisuuspyyntö",
      SE: "Funktionsförfrågan"
    },
    {
      key: "support.other",
      EN: "Other",
      DA: "Andet",
      NO: "Annet",
      FI: "Muu",
      SE: "Annat"
    },
    {
      key: "support.message",
      EN: "Message",
      DA: "Besked",
      NO: "Melding",
      FI: "Viesti",
      SE: "Meddelande"
    },
    {
      key: "support.send",
      EN: "Send",
      DA: "Send",
      NO: "Send",
      FI: "Lähetä",
      SE: "Skicka"
    },
    {
      key: "support.legal",
      EN: "Legal - ",
      DA: "Juridisk - ",
      NO: "Juridisk - ",
      FI: "Oikeudellinen - ",
      SE: "Juridisk - "
    },
    {
      key: "support.termsofuse",
      EN: "Terms of use",
      DA: "Brugsbetingelser",
      NO: "Bruksvilkår",
      FI: "Käyttöehdot",
      SE: "Användarvillkor"
    },
    {
      key: "support.privacy",
      EN: "Privacy",
      DA: "Privatliv",
      NO: "Personvern",
      FI: "Tietosuoja",
      SE: "Sekretess"
    },
    {
      key: "projectuserview.notontrack",
      EN: "Not on track",
      DA: "Ikke på rette spor",
      NO: "Ikke på sporet",
      FI: "Ei oikealla tiellä",
      SE: "Inte på rätt spår"
    },
    {
      key: "projectuserview.duetoday",
      EN: "Due today",
      DA: "Forfald i dag",
      NO: "Forfall i dag",
      FI: "Erääntyy tänään",
      SE: "Förfallodag idag"
    },
    {
      key: "projectuserview.upcomingtasks",
      EN: "Upcoming tasks",
      DA: "Kommende opgaver",
      NO: "Kommende oppgaver",
      FI: "Tulevat tehtävät",
      SE: "Kommande uppgifter"
    },
    {
      key: "planning.overview",
      EN: "Planning Overview",
      DA: "Planlægningsoversigt",
      NO: "Planleggingsoversikt",
      FI: "Suunnittelu Yleiskatsaus",
      SE: "Planeringsöversikt"
    },
    {
      key: "planning.lastmonth",
      EN: "Show last month",
      DA: "Vis sidste måned",
      NO: "Vis forrige måned",
      FI: "Näytä viime kuukausi",
      SE: "Visa förra månaden"
    },
    {
      key: "planning.nextmonth",
      EN: "Show next month",
      DA: "Vis næste måned",
      NO: "Vis neste måned",
      FI: "Näytä seuraava kuukausi",
      SE: "Visa nästa månad"
    },
    {
      key: "orgaccount.editinformation",
      EN: "Information",
      DA: "Information",
      NO: "Informasjon",
      FI: "Tietoja",
      SE: "Information"
    },
    {
      key: "orgaccount.managelogo",
      EN: "Logo",
      DA: "Logoer",
      NO: "Logoer",
      FI: "Logoja",
      SE: "Logotyper"
    },
    {
      key: "orgaccount.tags",
      EN: "Tags",
      DA: "Mærkater",
      NO: "Etiketter",
      FI: "Tunnisteet",
      SE: "Taggar"
    },
    {
      key: "orgaccount.tagstip",
      EN: "Tag administration",
      DA: "Mærkatadministration",
      NO: "Etikettadministrasjon",
      FI: "Tunnisteiden hallinta",
      SE: "Taggadministration"
    },
    {
      key: "orgaccount.notifications",
      EN: "Notifications",
      DA: "Notifikationer",
      NO: "Varsler",
      FI: "Ilmoitukset",
      SE: "Aviseringar"
    },
    {
      key: "orgaccount.notificationstip",
      EN: "Notification settings",
      DA: "Notifikationsindstillinger",
      NO: "Varselinnstillinger",
      FI: "Ilmoitusasetukset",
      SE: "Aviseringsinställningar"
    },
    {
      key: "orgaccount.managedesign",
      EN: "Designs",
      DA: "Design",
      NO: "Design",
      FI: "Suunnitelmia",
      SE: "Design"
    },
    {
      key: "orgaccount.viewtemplates",
      EN: "Templates",
      DA: "Skabeloner",
      NO: "Maler",
      FI: "Mallipohjat",
      SE: "Mallar"
    },
    {
      key: "orgaccount.viewtemplatestip",
      EN: "Show templates",
      DA: "Vis skabeloner",
      NO: "Vis maler",
      FI: "Näytä mallipohjat",
      SE: "Visa mallar"
    },
    {
      key: "orgaccount.privacypolicy",
      EN: "Privacy policy",
      DA: "Privatlivspolitik",
      NO: "Personvernpolicy",
      FI: "Tietosuojakäytäntö",
      SE: "Integritetspolicy"
    },
    {
      key: "orgaccount.settings",
      EN: "Settings",
      DA: "Indstillinger",
      NO: "Innstillinger",
      FI: "Asetukset",
      SE: "Inställningar"
    },
    {
      key: "orgaccount.settingstip",
      EN: "Org settings",
      DA: "Organisationsindstillinger",
      NO: "Organisasjonsinnstillinger",
      FI: "Organisaation asetukset",
      SE: "Organisationsinställningar"
    },
    {
      key: "orgaccount.termsofuse",
      EN: "Terms of use",
      DA: "Brugsvilkår",
      NO: "Bruksvilkår",
      FI: "Käyttöehdot",
      SE: "Användarvillkor"
    },
    {
      key: "orgaccount.support",
      EN: "Support",
      DA: "Support",
      NO: "Støtte",
      FI: "Tuki",
      SE: "Support"
    },
    {
      key: "orgaccount.customerwelcome",
      EN: "Customer welcome",
      DA: "Kunde velkomst",
      NO: "Kunde velkomst",
      FI: "Asiakkaan tervetuloa",
      SE: "Kund välkommen"
    },
    {
      key: "orgaccount.integrations",
      EN: "Integrations",
      DA: "Integrationer",
      NO: "Integrasjoner",
      FI: "Integraatiot",
      SE: "Integrationer"
    },
    {
      key: "orgaccount.organisationprojectsettings",
      EN: "Organisation project settings",
      DA: "Projektindstillinger for organisation",
      NO: "Organisasjonens prosjektinnstillinger",
      FI: "Organisaation projektiasetukset",
      SE: "Organisationsprojektinställningar"
    },
    {
      key: "orgaccount.defaultprojectsettings",
      EN: "Default project settings",
      DA: "Standard projektindstillinger",
      NO: "Standard prosjektinnstillinger",
      FI: "Oletusprojektiasetukset",
      SE: "Standardprojektinställningar"
    },
    {
      key: "orgaccount.defaultprojectsettingssub",
      EN: "This is the settings for all new created projects",
      DA: "Dette er indstillingerne for alle nye projekter",
      NO: "Dette er innstillingene for alle nye prosjekter",
      FI: "Nämä ovat asetukset kaikille uusille projekteille",
      SE: "Detta är inställningarna för alla nya projekt"
    },
    {
      key: "orgaccount.alert",
      EN: "This will change preferences for all new projects that relates to your organisation.",
      DA: "Dette vil ændre præferencer for alle nye projekter relateret til din organisation.",
      NO: "Dette vil endre preferanser for alle nye prosjekter som er knyttet til organisasjonen din.",
      FI: "Tämä muuttaa asetuksia kaikille uusille projekteille, jotka liittyvät organisaatioosi.",
      SE: "Detta kommer att ändra preferenser för alla nya projekt som rör din organisation."
    },
    {
      key: "orgaccount.nostartdate",
      EN: "No start date",
      DA: "Ingen startdato",
      NO: "Ingen startdato",
      FI: "Ei aloituspäivämäärää",
      SE: "Ingen startdatum"
    },
    {
      key: "orgaccount.noenddate",
      EN: "No end date",
      DA: "Ingen slutdato",
      NO: "Ingen sluttdato",
      FI: "Ei päättymispäivämäärää",
      SE: "Inget slutdatum"
    },
    {
      key: "orgaccount.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "orgaccount.organisationinformationedit",
      EN: "Organisation information edit",
      DA: "Rediger organisationsoplysninger",
      NO: "Rediger organisasjonsinformasjon",
      FI: "Muokkaa organisaation tietoja",
      SE: "Redigera organisationsinformation"
    },
    {
      key: "orgaccount.clickimages",
      EN: "Click the image to choose a file for upload.",
      DA: "Klik på billedet for at vælge en fil til upload.",
      NO: "Klikk på bildet for å velge en fil for opplasting.",
      FI: "Napsauta kuvaa valitaksesi tiedoston ladattavaksi.",
      SE: "Klicka på bilden för att välja en fil att ladda upp."
    },
    {
      key: "orgaccount.rectangularlogo",
      EN: "Logo",
      DA: "Logo",
      NO: "Logo",
      FI: "Logo",
      SE: "Logo"
    },
    {
      key: "orgaccount.squarelogo",
      EN: "Square logo",
      DA: "Firkantet logo",
      NO: "Firkantet logo",
      FI: "Neliömäinen logo",
      SE: "Kvadratisk logotyp"
    },
    {
      key: "orgaccount.forms",
      EN: "Forms",
      DA: "Formularer",
      NO: "Skjemaer",
      FI: "Lomakkeet",
      SE: "Formulär"
    },
    {
      key: "orgnotification.header",
      EN: "Notification Templates",
      DA: "Notifikationsskabeloner",
      NO: "Varselmaler",
      FI: "Ilmoitusmallit",
      SE: "Notifikationsmallar"
    },
    {
      key: "orgnotification.subheader",
      EN: "This is where your organization's notification templates are listed.",
      DA: "Her er din organisations notifikationsskabeloner listet.",
      NO: "Her er organisasjonens varselmaler oppført.",
      FI: "Täällä luetellaan organisaatiosi ilmoitusmallit.",
      SE: "Här listas din organisations notifikationsmallar."
    },
    {
      key: "orgnotification.addnotification",
      EN: "Create new notification",
      DA: "Opret ny notifikation",
      NO: "Opprett ny varsling",
      FI: "Luo uusi ilmoitus",
      SE: "Skapa ny notifikation"
    },
    {
      key: "orgtemplatelist.header",
      EN: "Project Templates",
      DA: "Projekt skabeloner",
      NO: "Prosjektsmaler",
      FI: "Projektimallit",
      SE: "Projeksmallar"
    },
    {
      key: "orgtemplatelist.subheader",
      EN: "This is where your organization's project templates are listed.",
      DA: "Her er din organisations projekt skabeloner listet.",
      NO: "Her er organisasjonens prosjektsmaler oppført.",
      FI: "Täällä luetellaan organisaatiosi projektimallit.",
      SE: "Här listas organisationens projeksmallar."
    },
    {
      key: "orgtemplatelist.state",
      EN: "State: ",
      DA: "Status: ",
      NO: "Status: ",
      FI: "Tila: ",
      SE: "Status: "
    },
    {
      key: "orgtemplatelist.created",
      EN: "Created: ",
      DA: "Oprettet: ",
      NO: "Opprettet: ",
      FI: "Luotu: ",
      SE: "Skapad: "
    },
    {
      key: "orgtemplatelist.delete",
      EN: "Delete Template",
      DA: "Slet skabelon",
      NO: "Slett mal",
      FI: "Poista malli",
      SE: "Radera mall"
    },
    {
      key: "orgtemplatelist.confirmdelete",
      EN: "Please confirm your deletion of the template",
      DA: "Bekræft venligst sletning af skabelonen",
      NO: "Bekreft sletting av malen",
      FI: "Vahvista mallin poistaminen",
      SE: "Bekräfta att du vill radera mallen"
    },
    {
      key: "orgtemplatelist.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "orgtemplatelist.deletebutton",
      EN: "Delete",
      DA: "Slet",
      NO: "Slett",
      FI: "Poista",
      SE: "Radera"
    },
    {
      key: "orgtemplatelist.templatedetails",
      EN: "Template details",
      DA: "Skabelondetaljer",
      NO: "Maldetaljer",
      FI: "Mallin tiedot",
      SE: "Malldetaljer"
    },
    {
      key: "orgtemplatelist.titlemodal",
      EN: "Title: ",
      DA: "Titel: ",
      NO: "Tittel: ",
      FI: "Otsikko: ",
      SE: "Titel: "
    },
    {
      key: "orgtemplatelist.descriptionmodal",
      EN: "Description: ",
      DA: "Beskrivelse: ",
      NO: "Beskrivelse: ",
      FI: "Kuvaus: ",
      SE: "Beskrivning: "
    },
    {
      key: "orgtemplatelist.recipemodal",
      EN: "Recipe: ",
      DA: "Opskrift: ",
      NO: "Oppskrift: ",
      FI: "Resepti: ",
      SE: "Recept: "
    },
    {
      key: "customerwelcomeedit.header",
      EN: "Customer Welcome",
      DA: "Kunde Velkommen",
      NO: "Kunde Velkommen",
      FI: "Asiakkaan tervetuloa",
      SE: "Kund Välkommen"
    },
    {
      key: "customerwelcomeedit.headerspecific",
      EN: "Customer Specific Welcome",
      DA: "Kunde Specifik Velkomst",
      NO: "Kunde Spesifikk Velkomst",
      FI: "Asiakkaalle räätälöity tervetuloa",
      SE: "Kundanpassad Välkomst"
    },
    {
      key: "customerwelcomeedit.subheaderline1",
      EN: "Here you change your customer's welcome message and media.",
      DA: "Her ændrer du din kundes velkomstbesked og medier.",
      NO: "Her endrer du kundens velkomstmelding og media.",
      FI: "Täällä voit muuttaa asiakkaan tervetuloviestiä ja mediaa.",
      SE: "Här ändrar du kundens välkomstmeddelande och media."
    },
    {
      key: "customerwelcomeedit.subheaderline2",
      EN: "To merge in the user's name into your text, you can insert this [username], which will be replaced with the user's name when they view the page.",
      DA: "For at flette brugerens navn ind i din tekst, kan du indsætte dette [username], som erstattes med brugerens navn, når de ser siden.",
      NO: "For å flette inn brukernavnet i teksten din, kan du sette inn [username], som blir erstattet med brukernavnet når de ser siden.",
      FI: "Lisätäksesi käyttäjän nimen tekstiisi voit lisätä tämän [username], joka korvataan käyttäjän nimellä, kun he katsovat sivua.",
      SE: "För att lägga till användarens namn i texten kan du använda [username], som ersätts med användarens namn när de ser sidan."
    },
    {
      key: "customerwelcomeedit.customeruserwelcome",
      EN: "Customer user welcome",
      DA: "Kunde bruger velkomst",
      NO: "Kunde brukervelkomst",
      FI: "Asiakas käyttäjän tervetulotoivotus",
      SE: "Kundens användarvälkomst"
    },
    {
      key: "customerwelcomeedit.enterwelcome",
      EN: "Enter welcome...",
      DA: "Indtast velkomst...",
      NO: "Skriv inn velkomst...",
      FI: "Syötä tervetuloa...",
      SE: "Skriv in välkomst..."
    },
    {
      key: "customerwelcomeedit.customerusermedialink",
      EN: "Customer user media link",
      DA: "Kunde bruger medielink",
      NO: "Kunde brukermedialink",
      FI: "Asiakaskäyttäjän medialinkki",
      SE: "Kundens användarmedialänk"
    },
    {
      key: "customerwelcomeedit.alert",
      EN: "You need to provide text and a media link before your customer welcome will be displayed for your customer users!",
      DA: "Du skal indsætte tekst og et medielink før din kundes velkomst vil blive vist for dine kundebrugere!",
      NO: "Du må legge til tekst og en medialink før kundens velkomst vil vises for brukerne!",
      FI: "Sinun tulee lisätä teksti ja medialinkki ennen kuin asiakas tervetuloa näytetään käyttäjille!",
      SE: "Du måste ange text och en medialänk innan kundens välkomst visas för användarna!"
    },
    {
      key: "customerwelcomeedit.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "customerwelcomeedit.savechanges",
      EN: "Save Changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "orgstyle.header",
      EN: "Organizational Style",
      DA: "Organisatorisk stil",
      NO: "Organisatorisk stil",
      FI: "Organisatorinen tyyli",
      SE: "Organisationsstil"
    },
    {
      key: "orgstyle.navigation",
      EN: "Navigation",
      DA: "Navigation",
      NO: "Navigasjon",
      FI: "Navigointi",
      SE: "Navigering"
    },
    {
      key: "orgstyle.missingsettings",
      EN: " - Missing settings",
      DA: " - Manglende indstillinger",
      NO: " - Manglende innstillinger",
      FI: " - Puuttuvat asetukset",
      SE: " - Saknade inställningar"
    },
    {
      key: "orgstyle.navlinks",
      EN: "Navigation Links",
      DA: "Navigationslinks",
      NO: "Navigasjonslenker",
      FI: "Navigointilinkit",
      SE: "Navigeringslänkar"
    },
    {
      key: "orgstyle.navlinkssize",
      EN: "Navigation link size",
      DA: "Navigationslink størrelse",
      NO: "Navigasjonslenkestørrelse",
      FI: "Navigointilinkin koko",
      SE: "Navigeringslänkstorlek"
    },
    {
      key: "orgstyle.extrasmall",
      EN: "Extra small - 12px",
      DA: "Ekstra lille - 12px",
      NO: "Ekstra liten - 12px",
      FI: "Erittäin pieni - 12px",
      SE: "Extra liten - 12px"
    },
    {
      key: "orgstyle.small",
      EN: "Small",
      DA: "Lille",
      NO: "Liten",
      FI: "Pieni",
      SE: "Liten"
    },
    {
      key: "orgstyle.medium",
      EN: "Medium",
      DA: "Mellem",
      NO: "Medium",
      FI: "Keskikokoinen",
      SE: "Medium"
    },
    {
      key: "orgstyle.big",
      EN: "Big",
      DA: "Stor",
      NO: "Stor",
      FI: "Iso",
      SE: "Stor"
    },
    {
      key: "orgstyle.navlinkweight",
      EN: "Nav link weight",
      DA: "Navigationslink vægt",
      NO: "Navigasjonslenke vekt",
      FI: "Navigointilinkin paino",
      SE: "Navigeringslänk vikt"
    },
    {
      key: "orgstyle.thin",
      EN: "Thin",
      DA: "Tynd",
      NO: "Tynn",
      FI: "Ohut",
      SE: "Tunn"
    },
    {
      key: "orgstyle.light",
      EN: "Light",
      DA: "Lys",
      NO: "Lett",
      FI: "Kevyt",
      SE: "Ljus"
    },
    {
      key: "orgstyle.regular",
      EN: "Regular",
      DA: "Normal",
      NO: "Vanlig",
      FI: "Säännöllinen",
      SE: "Reguljär"
    },
    {
      key: "orgstyle.semibold",
      EN: "Semibold",
      DA: "Halvfed",
      NO: "Halvfet",
      FI: "Puolilihava",
      SE: "Halvfet"
    },
    {
      key: "orgstyle.bold",
      EN: "Bold",
      DA: "Fed",
      NO: "Fet",
      FI: "Lihava",
      SE: "Fet"
    },
    {
      key: "orgstyle.activenavlinkweight",
      EN: "Active nav link weight",
      DA: "Aktiv navigationslink vægt",
      NO: "Aktiv navigasjonslenke vekt",
      FI: "Aktiivinen navigointilinkin paino",
      SE: "Aktiv navigeringslänk vikt"
    },
    {
      key: "orgstyle.navlinkfont",
      EN: "Nav link font",
      DA: "Navigationslink skrifttype",
      NO: "Navigasjonslenke skrift",
      FI: "Navigointilinkin fontti",
      SE: "Navigeringslänk teckensnitt"
    },
    {
      key: "orgstyle.navicons",
      EN: "Nav Icons",
      DA: "Navigationsikoner",
      NO: "Navigasjonsikoner",
      FI: "Navigointikuvakkeet",
      SE: "Navigeringsikoner"
    },
    {
      key: "orgstyle.naviconcolor",
      EN: "Nav icon color",
      DA: "Navigationsikon farve",
      NO: "Navigasjonsikon farge",
      FI: "Navigointikuvakkeen väri",
      SE: "Navigeringsikon färg"
    },
    {
      key: "orgstyle.naviconcoloronhover",
      EN: "Nav icon color on hover",
      DA: "Navigationsikon farve ved hover",
      NO: "Navigasjonsikon farge ved hover",
      FI: "Navigointikuvakkeen väri hoverilla",
      SE: "Navigeringsikon färg vid hover"
    },
    {
      key: "orgstyle.naviconbackgroundcolor",
      EN: "Nav icon background color",
      DA: "Navigationsikon baggrundsfarve",
      NO: "Navigasjonsikon bakgrunnsfarge",
      FI: "Navigointikuvakkeen taustaväri",
      SE: "Navigeringsikon bakgrundsfärg"
    },
    {
      key: "orgstyle.naviconbackgroundcoloronhover",
      EN: "Nav icon background color on hover",
      DA: "Navigationsikon baggrundsfarve ved hover",
      NO: "Navigasjonsikon bakgrunnsfarge ved hover",
      FI: "Navigointikuvakkeen taustaväri hoverilla",
      SE: "Navigeringsikon bakgrundsfärg vid hover"
    },
    {
      key: "orgstyle.mainnavbordercolor",
      EN: "Main Nav Border Color",
      DA: "Hoved navigation kantfarve",
      NO: "Hovednavigasjon kantfarge",
      FI: "Pää navigoinnin reunan väri",
      SE: "Huvudnavigering kantfärg"
    },
    {
      key: "orgstyle.bottomnavicons",
      EN: "Bottom nav Icons",
      DA: "Bund navigation ikoner",
      NO: "Bunnnavigasjonsikoner",
      FI: "Alapalkin navigointikuvakkeet",
      SE: "Nedersta navigeringsikoner"
    },
    {
      key: "orgstyle.bottomnaviconbackgroundcolor",
      EN: "Bottom nav icon background color",
      DA: "Bund navigation ikon baggrundsfarve",
      NO: "Bunnnavigasjonsikon bakgrunnsfarge",
      FI: "Alapalkin navigointikuvakkeen taustaväri",
      SE: "Nedersta navigeringsikon bakgrundsfärg"
    },
    {
      key: "orgstyle.bottomnaviconbackgroundcoloronhover",
      EN: "Bottom nav icon background color on hover",
      DA: "Bund navigation ikon baggrundsfarve ved hover",
      NO: "Bunnnavigasjonsikon bakgrunnsfarge ved hover",
      FI: "Alapalkin navigointikuvakkeen taustaväri hoverilla",
      SE: "Nedersta navigeringsikon bakgrundsfärg vid hover"
    },
    {
      key: "orgstyle.bottomnaviconcolor",
      EN: "Bottom nav icon color",
      DA: "Bund navigation ikon farve",
      NO: "Bunnnavigasjonsikon farge",
      FI: "Alapalkin navigointikuvakkeen väri",
      SE: "Nedersta navigeringsikon färg"
    },
    {
      key: "orgstyle.bottomnaviconcoloronhover",
      EN: "Bottom nav icon color on hover",
      DA: "Bund navigation ikon farve ved hover",
      NO: "Bunnnavigasjonsikon farge ved hover",
      FI: "Alapalkin navigointikuvakkeen väri hoverilla",
      SE: "Nedersta navigeringsikon färg vid hover"
    },
    {
      key: "orgstyle.pageheaders",
      EN: "Page headers",
      DA: "Sideskrifter",
      NO: "Sidetopper",
      FI: "Sivun otsikot",
      SE: "Sidhuvuden"
    },
    {
      key: "orgstyle.pageheaderoptions",
      EN: "Page header options",
      DA: "Sideskriftsmuligheder",
      NO: "Sidetoppalternativer",
      FI: "Sivun otsikkovaihtoehdot",
      SE: "Sidhuvudalternativ"
    },
    {
      key: "orgstyle.pagetitleweight",
      EN: "Page title weight",
      DA: "Side titelvægt",
      NO: "Sidetittel vekt",
      FI: "Sivun otsikon paino",
      SE: "Sidrubrik vikt"
    },
    {
      key: "orgstyle.pagetitlesize",
      EN: "Page title size",
      DA: "Side titels størrelse",
      NO: "Sidetittel størrelse",
      FI: "Sivun otsikon koko",
      SE: "Sidrubrik storlek"
    },
    {
      key: "orgstyle.pagetitlefont",
      EN: "Page title font",
      DA: "Side titels skrifttype",
      NO: "Sidetittel skrift",
      FI: "Sivun otsikon fontti",
      SE: "Sidrubrik teckensnitt"
    },
    {
      key: "orgstyle.pagetitlecolor",
      EN: "Page title color",
      DA: "Side titel farve",
      NO: "Sidetittel farge",
      FI: "Sivun otsikon väri",
      SE: "Sidrubrik färg"
    },
    {
      key: "orgstyle.pagesubtitleoptions",
      EN: "Page sub title options",
      DA: "Side undertitel muligheder",
      NO: "Sidetittelalternativer",
      FI: "Sivun alaotsikon vaihtoehdot",
      SE: "Sidrubrik alternativ"
    },
    {
      key: "orgstyle.pagetitlesubsize",
      EN: "Page title sub size",
      DA: "Side undertitel størrelse",
      NO: "Sidetittel understørrelse",
      FI: "Sivun alaotsikon koko",
      SE: "Sidrubrik understorlek"
    },
    {
      key: "orgstyle.pagetitlesubweight",
      EN: "Page title sub weight",
      DA: "Side undertitel vægt",
      NO: "Sidetittel undervekt",
      FI: "Sivun alaotsikon paino",
      SE: "Sidrubrik undervikt"
    },
    {
      key: "orgstyle.pagetitlesubcolor",
      EN: "Page title sub color",
      DA: "Side undertitel farve",
      NO: "Sidetittel underfarge",
      FI: "Sivun alaotsikon väri",
      SE: "Sidrubrik underfärg"
    },
    {
      key: "orgstyle.pagetitlesubfont",
      EN: "Page title sub font",
      DA: "Side undertitel skrifttype",
      NO: "Sidetittel underfont",
      FI: "Sivun alaotsikon fontti",
      SE: "Sidrubrik underteckensnitt"
    },
    {
      key: "orgstyle.colors",
      EN: "Colors",
      DA: "Farver",
      NO: "Farger",
      FI: "Värit",
      SE: "Färger"
    },
    {
      key: "orgstyle.organisationcolors",
      EN: "Organisation colors",
      DA: "Organisationsfarver",
      NO: "Organisasjonsfarger",
      FI: "Organisaation värit",
      SE: "Organisationsfärger"
    },
    {
      key: "orgstyle.mainorganizationalcolor",
      EN: "Main Organizational Color",
      DA: "Hovedorganisationsfarve",
      NO: "Hovedorganisasjonsfarge",
      FI: "Pääorganisaation väri",
      SE: "Huvudorganisationsfärg"
    },
    {
      key: "orgstyle.secondorganizationalcolor",
      EN: "Second Organizational Color",
      DA: "Anden organisationsfarve",
      NO: "Andre organisasjonsfarge",
      FI: "Toinen organisaation väri",
      SE: "Andra organisationsfärg"
    },
    {
      key: "orgstyle.portaliconcolors",
      EN: "Portal icon colors",
      DA: "Portal ikonfarver",
      NO: "Portal ikonfarger",
      FI: "Portaalikuvakkeen värit",
      SE: "Portalikonfärger"
    },
    {
      key: "orgstyle.portaliconcolor",
      EN: "Portal icon color",
      DA: "Portal ikon farve",
      NO: "Portal ikonfarge",
      FI: "Portaalikuvakkeen väri",
      SE: "Portalikonfärg"
    },
    {
      key: "orgstyle.portaliconcoloronhover",
      EN: "Portal icon color on hover",
      DA: "Portal ikon farve ved hover",
      NO: "Portal ikonfarge ved hover",
      FI: "Portaalikuvakkeen väri hoverilla",
      SE: "Portalikonfärg vid hover"
    },
    {
      key: "orgstyle.portalbgcolor",
      EN: "Portal bg color",
      DA: "Portal baggrundsfarve",
      NO: "Portal bakgrunnsfarge",
      FI: "Portaalin taustaväri",
      SE: "Portal bakgrundsfärg"
    },
    {
      key: "orgstyle.portalbgcoloronhover",
      EN: "Portal bg color on hover",
      DA: "Portal baggrundsfarve ved hover",
      NO: "Portal bakgrunnsfarge ved hover",
      FI: "Portaalin taustaväri hoverilla",
      SE: "Portal bakgrundsfärg vid hover"
    },
    {
      key: "orgstyle.fontcolors",
      EN: "Font colors",
      DA: "Skriftfarver",
      NO: "Skriftfarger",
      FI: "Fonttivärit",
      SE: "Teckensnittsfärger"
    },
    {
      key: "orgstyle.titlecolor",
      EN: "Title Color",
      DA: "Titelfarve",
      NO: "Tittelfarge",
      FI: "Otsikon väri",
      SE: "Titelfärg"
    },
    {
      key: "orgstyle.fontcolor",
      EN: "Font Color",
      DA: "Skriftfarve",
      NO: "Skriftfarge",
      FI: "Fontin väri",
      SE: "Teckensnittsfärg"
    },
    {
      key: "orgstyle.iconcolor",
      EN: "Icon Color",
      DA: "Ikon farve",
      NO: "Ikonfarge",
      FI: "Kuvakkeen väri",
      SE: "Ikonfärg"
    },
    {
      key: "orgstyle.iconcolors",
      EN: "Icon Colors",
      DA: "Ikonfarver",
      NO: "Ikonfarger",
      FI: "Kuvakkeiden värit",
      SE: "Ikonfärger"
    },
    {
      key: "orgstyle.iconhovercolor",
      EN: "Icon Hover Color",
      DA: "Ikon hover farve",
      NO: "Ikon hover farge",
      FI: "Kuvakkeen hover-väri",
      SE: "Ikon hover färg"
    },
    {
      key: "orgstyle.buttoncolors",
      EN: "Button colors",
      DA: "Knapfarver",
      NO: "Knappfarger",
      FI: "Painikkeen värit",
      SE: "Knapparnas färger"
    },
    {
      key: "orgstyle.buttontextcolor",
      EN: "Button Text Color",
      DA: "Knaptekstfarve",
      NO: "Knapptekstfarge",
      FI: "Painikkeen tekstin väri",
      SE: "Knapptextfärg"
    },
    {
      key: "orgstyle.buttonbackgroundcolor",
      EN: "Button Background Color",
      DA: "Knapbaggrundsfarve",
      NO: "Knapp bakgrunnsfarge",
      FI: "Painikkeen taustaväri",
      SE: "Knappens bakgrundsfärg"
    },
    {
      key: "orgstyle.buttonbackgroundhovercolor",
      EN: "Button Background Hover Color",
      DA: "Knapbaggrundsfarve ved hover",
      NO: "Knapp bakgrunnsfarge ved hover",
      FI: "Painikkeen taustaväri hoverilla",
      SE: "Knappens bakgrundsfärg vid hover"
    },
    {
      key: "orgstyle.buttontexthovercolor",
      EN: "Button Text Hover Color",
      DA: "Knaptekstfarve ved hover",
      NO: "Knapptekstfarge ved hover",
      FI: "Painikkeen tekstin väri hoverilla",
      SE: "Knappt text färg vid hover"
    },
    {
      key: "orgstyle.tablecolors",
      EN: "Table colors",
      DA: "Tabel farver",
      NO: "Tabellfarger",
      FI: "Taulukon värit",
      SE: "Tabellfärger"
    },
    {
      key: "orgstyle.tabletextcolor",
      EN: "Table text color",
      DA: "Tabeltekst farve",
      NO: "Tabelltekst farge",
      FI: "Taulukon tekstin väri",
      SE: "Tabelltextfärg"
    },
    {
      key: "orgstyle.customerpagecolors",
      EN: "Customerpage colors",
      DA: "Kundeside farver",
      NO: "Kundesidefarger",
      FI: "Asiakassivun värit",
      SE: "Kundsida färger"
    },
    {
      key: "orgstyle.customerpagetextcolor",
      EN: "Customerpage text color",
      DA: "Kundeside tekstfarve",
      NO: "Kundeside tekstfarge",
      FI: "Asiakassivun tekstin väri",
      SE: "Kundsida textfärg"
    },
    {
      key: "orgstyle.dropdowncolors",
      EN: "Dropdown colors",
      DA: "Dropdown farver",
      NO: "Dropdown farger",
      FI: "Pudotusvalikon värit",
      SE: "Dropdown färger"
    },
    {
      key: "orgstyle.dropdowntextcolor",
      EN: "Drop down text color",
      DA: "Dropdown tekstfarve",
      NO: "Dropdown tekstfarge",
      FI: "Pudotusvalikon tekstin väri",
      SE: "Dropdown textfärg"
    },
    {
      key: "orgstyle.fonts",
      EN: "Fonts",
      DA: "Skrifttyper",
      NO: "Skrifter",
      FI: "Fontit",
      SE: "Teckensnitt"
    },
    {
      key: "orgstyle.titlefont",
      EN: "Title font",
      DA: "Titel skrifttype",
      NO: "Tittelskrift",
      FI: "Otsikon fontti",
      SE: "Titelskrift"
    },
    {
      key: "orgstyle.contentfont",
      EN: "Content font",
      DA: "Indhold skrifttype",
      NO: "Innholdsskrift",
      FI: "Sisällön fontti",
      SE: "Innehållsskrift"
    },
    {
      key: "orgstyle.titleweight",
      EN: "Title weight",
      DA: "Titel vægt",
      NO: "Tittel vekt",
      FI: "Otsikon paino",
      SE: "Titel vikt"
    },
    {
      key: "orgstyle.logos",
      EN: "Favicon",
      DA: "Favikon",
      NO: "Favikon",
      FI: "Favikoni",
      SE: "Favikon"
    },
    {
      key: "orgstyle.organizational",
      EN: "Organizational",
      DA: "Organisatorisk",
      NO: "Organisatorisk",
      FI: "Organisatorinen",
      SE: "Organisatorisk"
    },
    {
      key: "orgstyle.icon",
      EN: "Favicon",
      DA: "Favikon",
      NO: "Favikon",
      FI: "Favikoni",
      SE: "Favikon"
    },
    {
      key: "orgstyle.borders",
      EN: "Borders",
      DA: "Kanter",
      NO: "Kanter",
      FI: "Reunat",
      SE: "Kanter"
    },
    {
      key: "orgstyle.borderradius",
      EN: "Border Radius",
      DA: "Kanteradius",
      NO: "Kanteradius",
      FI: "Reunuksen säde",
      SE: "Kantens radie"
    },
    {
      key: "orgstyle.animations",
      EN: "Animations",
      DA: "Animationer",
      NO: "Animasjoner",
      FI: "Animaatiot",
      SE: "Animationer"
    },
    {
      key: "orgstyle.tasktoggleanimation",
      EN: "Task toggle animation",
      DA: "Opgaveskift animation",
      NO: "Oppgaveveksling animasjon",
      FI: "Tehtävän vaihtumisanimaatio",
      SE: "Uppgiftsväxling animation"
    },
    {
      key: "orgstyle.default",
      EN: "Default",
      DA: "Standard",
      NO: "Standard",
      FI: "Oletus",
      SE: "Standard"
    },
    {
      key: "orgstyle.swing",
      EN: "Swing",
      DA: "Sving",
      NO: "Sving",
      FI: "Heilahdus",
      SE: "Sväng"
    },
    {
      key: "orgstyle.wobble",
      EN: "Wobble",
      DA: "Vrikke",
      NO: "Vingle",
      FI: "Horjua",
      SE: "Vingla"
    },
    {
      key: "orgstyle.bounce",
      EN: "Bounce",
      DA: "Hoppe",
      NO: "Sprette",
      FI: "Pomppu",
      SE: "Studsa"
    },
    {
      key: "orgstyle.rubberBand",
      EN: "rubberBand",
      DA: "Elastikbånd",
      NO: "Gummistrikk",
      FI: "Kuminauha",
      SE: "Gummiband"
    },
    {
      key: "orgstyle.taskoptions",
      EN: "Task options",
      DA: "Opgave muligheder",
      NO: "Oppgave alternativer",
      FI: "Tehtävän asetukset",
      SE: "Uppgiftsalternativ"
    },
    {
      key: "orgstyle.mytaskbackgroundcolor",
      EN: "My task background color",
      DA: "Min opgave baggrundsfarve",
      NO: "Min oppgave bakgrunnsfarge",
      FI: "Tehtäväni taustaväri",
      SE: "Min uppgift bakgrundsfärg"
    },
    {
      key: "orgstyle.vendorbackgroundcolor",
      EN: "Vendor background color",
      DA: "Leverandør baggrundsfarve",
      NO: "Leverandør bakgrunnsfarge",
      FI: "Toimittajan taustaväri",
      SE: "Leverantör bakgrundsfärg"
    },
    {
      key: "orgstyle.customerbackgroundcolor",
      EN: "Customer background color",
      DA: "Kunde baggrundsfarve",
      NO: "Kunde bakgrunnsfarge",
      FI: "Asiakkaan taustaväri",
      SE: "Kundens bakgrundsfärg"
    },
    {
      key: "orgstyle.tasktextcolor",
      EN: "Task text color",
      DA: "Opgave tekstfarve",
      NO: "Oppgave tekstfarge",
      FI: "Tehtävän tekstin väri",
      SE: "Uppgiftens textfärg"
    },
    {
      key: "orgstyle.reset",
      EN: "Reset",
      DA: "Nulstil",
      NO: "Tilbakestill",
      FI: "Nollaa",
      SE: "Återställ"
    },
    {
      key: "orgstyle.stylereset",
      EN: "Style Reset",
      DA: "Stil nulstilling",
      NO: "Stil tilbakestilling",
      FI: "Tyylin nollaus",
      SE: "Stil återställning"
    },
    {
      key: "orgstyle.cancelreset",
      EN: "Cancel Reset",
      DA: "Annuller nulstilling",
      NO: "Avbryt tilbakestilling",
      FI: "Peruuta nollaus",
      SE: "Avbryt återställning"
    },
    {
      key: "orgstyle.resetwarning",
      EN: "This will delete all your settings, and return you to the ClearRamp standards!",
      DA: "Dette vil slette alle dine indstillinger og returnere dig til ClearRamp standarder!",
      NO: "Dette vil slette alle innstillingene dine og gjenopprette ClearRamp-standardene!",
      FI: "Tämä poistaa kaikki asetuksesi ja palauttaa sinut ClearRampin standardeihin!",
      SE: "Detta kommer att ta bort alla dina inställningar och återställa dig till ClearRamp-standarder!"
    },
    {
      key: "orgstyle.confirmreset",
      EN: "Confirm Reset",
      DA: "Bekræft nulstilling",
      NO: "Bekreft tilbakestilling",
      FI: "Vahvista nollaus",
      SE: "Bekräfta återställning"
    },
    {
      key: "orgstyle.finishedtaskbackgroundcolor",
      EN: "Finished task background color",
      DA: "Baggrundsfarve for færdig opgave",
      NO: "Bakgrunnsfarge for fullført oppgave",
      FI: "Valmiin tehtävän taustaväri",
      SE: "Bakgrundsfärg för slutförd uppgift"
    },
    {
      key: "orgstyle.customerbackgroundcolour",
      EN: "Customer task background color",
      DA: "Kundeopgavens baggrundsfarve",
      NO: "Kundeoppgavens bakgrunnsfarge",
      FI: "Asiakastehtävän taustaväri",
      SE: "Bakgrundsfärg för kunduppgift"
    },
    {
      key: "orgstyle.notificationdescriptioncolor",
      EN: "Notification description color",
      DA: "Farve på notifikationsbeskrivelse",
      NO: "Farge på varslingsbeskrivelse",
      FI: "Ilmoituksen kuvauksen väri",
      SE: "Färg på notifikationsbeskrivning"
    },
    {
      key: "orgstyle.notificationtitlecolor",
      EN: "Notification title color",
      DA: "Farve på notifikationstitel",
      NO: "Farge på varslingstittel",
      FI: "Ilmoituksen otsikon väri",
      SE: "Färg på notifikationstitel"
    },
    {
      key: "orgstyle.notificationbackgroundcolor",
      EN: "Notification background color",
      DA: "Baggrundsfarve på notifikation",
      NO: "Bakgrunnsfarge på varsling",
      FI: "Ilmoituksen taustaväri",
      SE: "Bakgrundsfärg på notifikation"
    },
    {
      key: "orgstyle.notifications",
      EN: "Notifications",
      DA: "Notifikationer",
      NO: "Varsler",
      FI: "Ilmoitukset",
      SE: "Notifikationer"
    },
    {
      key: "orgstyle.email",
      EN: "Email",
      DA: "Email",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "orgstyle.lastmnavlinkssizeonth",
      EN: "Nav link size",
      DA: "Størrelse på navigationslink",
      NO: "Størrelse på navigasjonslenke",
      FI: "Navigointilinkin koko",
      SE: "Navigeringslänkstorlek"
    },
    {
      key: "orgstyle.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "orgstyle.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "orgstyle.importexport",
      EN: "Import and Export",
      DA: "Importer og eksporter",
      NO: "Importer og eksporter",
      FI: "Tuo ja vie",
      SE: "Importera och exportera"
    },
    {
      key: "orgstyle.sourceorg",
      EN: "Source org",
      DA: "Kildeorganisation",
      NO: "Kildeorganisasjon",
      FI: "Lähdeorganisaatio",
      SE: "Källorganisation"
    },
    {
      key: "orgstyle.sourceorg.placeholder",
      EN: "Choose Source org...",
      DA: "Vælg kildeorganisation...",
      NO: "Velg kildeorganisasjon...",
      FI: "Valitse lähdeorganisaatio...",
      SE: "Välj källorganisation..."
    },
    {
      key: "orgstyle.sourceorg.load",
      EN: "Loading source org",
      DA: "Indlæser kildeorganisation",
      NO: "Laster kildeorganisasjon",
      FI: "Ladataan lähdeorganisaatiota",
      SE: "Laddar källorganisation"
    },
    {
      key: "orgstyle.export",
      EN: "Export",
      DA: "Eksporter",
      NO: "Eksporter",
      FI: "Vie",
      SE: "Exportera"
    },
    {
      key: "orgstyle.import",
      EN: "Import",
      DA: "Importer",
      NO: "Importer",
      FI: "Tuo",
      SE: "Importera"
    },
    {
      key: "orgstyle.importexport.help",
      EN: "Import help",
      DA: "Importvejledning",
      NO: "Importveiledning",
      FI: "Tuontiohje",
      SE: "Importinstruktion"
    },
    {
      key: "orgstyle.load",
      EN: "Load",
      DA: "Indlæs",
      NO: "Last inn",
      FI: "Lataa",
      SE: "Ladda"
    },
    {
      key: "orgstyle.export.help",
      EN: "Export help",
      DA: "Eksportvejledning",
      NO: "Eksportveiledning",
      FI: "Vientiohje",
      SE: "Exportinstruktion"
    },
    {
      key: "orgstyle.import.help",
      EN: "Import help",
      DA: "Importvejledning",
      NO: "Importveiledning",
      FI: "Tuontiohje",
      SE: "Importinstruktion"
    },
    {
      key: "orgstyle.merge.help",
      EN: "Merge help",
      DA: "Flettevejledning",
      NO: "Fletteveiledning",
      FI: "Yhdistysohje",
      SE: "Sammanfogningsinstruktion"
    },
    {
      key: "orgstyle.previewchanges",
      EN: "Preview changes",
      DA: "Forhåndsvis ændringer",
      NO: "Forhåndsvis endringer",
      FI: "Esikatsele muutokset",
      SE: "Förhandsgranska ändringar"
    },
    {
      key: "orgstyle.previewchanges.desc",
      EN: "Preview changes desc",
      DA: "Se ændringerne, før de anvendes",
      NO: "Se endringene før de brukes",
      FI: "Näe muutokset ennen niiden käyttöönottoa",
      SE: "Se ändringarna innan de tillämpas"
    },
    {
      key: "orgstyle.apply.replace",
      EN: "Replace",
      DA: "Erstat",
      NO: "Erstatt",
      FI: "Korvaa",
      SE: "Ersätt"
    },
    {
      key: "orgstyle.apply.merge",
      EN: "Merge",
      DA: "Flet",
      NO: "Flett",
      FI: "Yhdistä",
      SE: "Sammanfoga"
    },
    {
      key: "orgstyle.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "orgstyle.apply",
      EN: "Apply",
      DA: "Anvend",
      NO: "Bruk",
      FI: "Käytä",
      SE: "Tillämpa"
    },















    {
      key: "orguseradd.header",
      EN: "Create person",
      DA: "Opret person",
      NO: "Opprett person",
      FI: "Luo henkilö",
      SE: "Skapa person"
    },
    {
      key: "orguseradd.loadconfirmcreate",
      EN: "Creating user...",
      DA: "Opretter bruger...",
      NO: "Oppretter bruker...",
      FI: "Luodaan käyttäjä...",
      SE: "Skapar användare..."
    },
    {
      key: "projecttimeshift.loadconfirmmove",
      EN: "Moving your tasks...",
      DA: "Flytter dine opgaver...",
      NO: "Flytter oppgavene dine...",
      FI: "Siirretään tehtäviäsi...",
      SE: "Flyttar dina uppgifter..."
    },
    {
      key: "projectstage.choose",
      EN: "Choose...",
      DA: "Vælg...",
      NO: "Velg ...",
      FI: "Valitse...",
      SE: "Välj..."
    },
    {
      key: "projectstage.linkurl",
      EN: "Link url",
      DA: "Link-url",
      NO: "Lenke-url",
      FI: "Linkki-url",
      SE: "Länk-url"
    },
    {
      key: "projectstage.linktext",
      EN: "Link text",
      DA: "Linktekst",
      NO: "Lenketekst",
      FI: "Linkkiteksti",
      SE: "Länktext"
    },
    {
      key: "projectstage.link",
      EN: "Link",
      DA: "Link",
      NO: "Lenke",
      FI: "Linkki",
      SE: "Länk"
    },
    {
      key: "projectstage.loadconfirmcreate",
      EN: "Creating task...",
      DA: "Opretter opgave...",
      NO: "Oppretter oppgave...",
      FI: "Luodaan tehtävää...",
      SE: "Skapar uppgift..."
    },
    {
      key: "projecttask.loadconfirmsave",
      EN: "Saving your changes...",
      DA: "Gemmer dine ændringer...",
      NO: "Lagrer endringene dine...",
      FI: "Tallennetaan muutoksiasi...",
      SE: "Sparar dina ändringar..."
    },
    {
      key: "projecttask.loadconfirmform",
      EN: "Loading forms...",
      DA: "Indlæser formularer...",
      NO: "Laster inn skjemaer...",
      FI: "Ladataan lomakkeita...",
      SE: "Laddar formulär..."
    },
    {
      key: "projecttask.showfiles",
      EN: "Show files",
      DA: "Vis filer",
      NO: "Vis filer",
      FI: "Näytä tiedostot",
      SE: "Visa filer"
    },
    {
      key: "projecttask.hidefiles",
      EN: "Hide files",
      DA: "Skjul filer",
      NO: "Skjul filer",
      FI: "Piilota tiedostot",
      SE: "Dölj filer"
    },
    {
      key: "projecttask.hourslogged",
      EN: "Hours logged",
      DA: "Timer logget",
      NO: "Timer logget",
      FI: "Kirjatut tunnit",
      SE: "Timmar loggade"
    },
    {
      key: "orguseradd.usercreationcomplete",
      EN: "User creation complete, email has been sent.",
      DA: "Brugeroprettelse fuldført, email er sendt.",
      NO: "Brukeroppretting fullført, e-post er sendt.",
      FI: "Käyttäjän luonti valmis, sähköposti on lähetetty.",
      SE: "Användarskapande slutfört, e-post har skickats."
    },
    {
      key: "Username cannot be empty",
      EN: "Username cannot be empty",
      DA: "Brugernavn kan ikke være tomt",
      NO: "Brukernavn kan ikke være tomt",
      FI: "Käyttäjänimi ei voi olla tyhjä",
      SE: "Användarnamn kan inte vara tomt"
    },
    {
      key: "orguseradd.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "orguseradd.jobtitle",
      EN: "Job title",
      DA: "Jobtitel",
      NO: "Stillingstittel",
      FI: "Työnimike",
      SE: "Jobbtitel"
    },
    {
      key: "orguseradd.email",
      EN: "Email",
      DA: "Email",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "orguseradd.username",
      EN: "User name",
      DA: "Brugernavn",
      NO: "Brukernavn",
      FI: "Käyttäjänimi",
      SE: "Användarnamn"
    },
    {
      key: "orguseradd.usernamealert",
      EN: "Please choose a username consisting of only small letters [a-z], capital letters [A-Z] and numbers [0-9]",
      DA: "Vælg venligst et brugernavn bestående af kun små bogstaver [a-z], store bogstaver [A-Z] og tal [0-9]",
      NO: "Vennligst velg et brukernavn bestående av små bokstaver [a-z], store bokstaver [A-Z] og tall [0-9]",
      FI: "Valitse käyttäjänimi, joka sisältää vain pieniä kirjaimia [a-z], isoja kirjaimia [A-Z] ja numeroita [0-9]",
      SE: "Vänligen välj ett användarnamn som endast består av små bokstäver [a-z], stora bokstäver [A-Z] och siffror [0-9]"
    },
    {
      key: "orguseradd.sendemailinvitation",
      EN: "Send email invitation",
      DA: "Send email invitation",
      NO: "Send e-postinvitasjon",
      FI: "Lähetä sähköpostikutsu",
      SE: "Skicka e-postinbjudan"
    },
    {
      key: "orguseradd.createuser",
      EN: "Create user",
      DA: "Opret bruger",
      NO: "Opprett bruker",
      FI: "Luo käyttäjä",
      SE: "Skapa användare"
    },
    {
      key: "orguseradd.createusersendemailalert",
      EN: "If left unchecked the user will not receive login credentials.",
      DA: "Hvis dette felt ikke er markeret, vil brugeren ikke modtage loginoplysninger.",
      NO: "Hvis dette ikke er merket av, vil brukeren ikke motta innloggingsinformasjon.",
      FI: "Jos tätä ei valita, käyttäjä ei saa kirjautumistietoja.",
      SE: "Om detta inte är markerat kommer användaren inte att få inloggningsuppgifter."
    },
    {
      key: "orguseradd.createusersendemailalert2",
      EN: "The user will receive login credentials.",
      DA: "Brugeren vil modtage loginoplysninger.",
      NO: "Brukeren vil motta innloggingsinformasjon.",
      FI: "Käyttäjä saa kirjautumistiedot.",
      SE: "Användaren kommer att få inloggningsuppgifter."
    },
    {
      key: "orgnotificationsetting.newprojectcreated",
      EN: "New project created",
      DA: "Nyt projekt oprettet",
      NO: "Nytt prosjekt opprettet",
      FI: "Uusi projekti luotu",
      SE: "Nytt projekt skapat"
    },
    {
      key: "orgnotificationsetting.notificationsettings",
      EN: "Notification settings",
      DA: "Notifikationsindstillinger",
      NO: "Varslingsinnstillinger",
      FI: "Ilmoitusasetukset",
      SE: "Meddelandeinställningar"
    },
    {
      key: "orgnotificationsetting.organisationnotifications",
      EN: "Organisation notifications",
      DA: "Organisationsnotifikationer",
      NO: "Organisasjonsvarsler",
      FI: "Organisaation ilmoitukset",
      SE: "Organisationsmeddelanden"
    },
    {
      key: "customeruser.organisationnotifications",
      EN: "Customer user notifications",
      DA: "Kundebruger notifikationer",
      NO: "Kundebruker varsler",
      FI: "Asiakaskäyttäjän ilmoitukset",
      SE: "Kundanvändarens aviseringar"
    },
    {
      key: "orgnotificationsetting.changenotificationpreferenceses",
      EN: "This will change notification preferences for all projects that relate to your organisation.",
      DA: "Dette vil ændre notifikationsindstillinger for alle projekter, der er relateret til din organisation.",
      NO: "Dette vil endre varslingsinnstillingene for alle prosjekter som er relatert til organisasjonen din.",
      FI: "Tämä muuttaa ilmoitusasetuksia kaikissa organisaation projekteissa.",
      SE: "Detta kommer att ändra meddelandeinställningarna för alla projekt som är kopplade till din organisation."
    },
    {
      key: "customerusernot.changenotificationpreferenceses",
      EN: "This will change notification preferences for all customer users.",
      DA: "Dette vil ændre notifikationsindstillinger for alle kundebrugere.",
      NO: "Dette vil endre varslingsinnstillingene for alle kundebrukere.",
      FI: "Tämä muuttaa ilmoitusasetukset kaikille asiakaskäyttäjille.",
      SE: "Detta kommer att ändra meddelandeinställningarna för alla kundanvändare."
    },
    {
      key: "orgnotificationsetting.selectall",
      EN: "Select all",
      DA: "Vælg alle",
      NO: "Velg alle",
      FI: "Valitse kaikki",
      SE: "Välj alla"
    },
    {
      key: "orgnotificationsetting.unselectall",
      EN: "Unselect all",
      DA: "Fravælg alle",
      NO: "Fjern alle valg",
      FI: "Poista valinnat kaikista",
      SE: "Avmarkera alla"
    },
    {
      key: "orgnotificationsetting.thisisarethesettingsforthecurrentorganization",
      EN: "These are the settings for the current organization.",
      DA: "Dette er indstillingerne for den nuværende organisation.",
      NO: "Dette er innstillingene for den nåværende organisasjonen.",
      FI: "Nämä ovat nykyisen organisaation asetukset.",
      SE: "Detta är inställningarna för den nuvarande organisationen."
    },
    {
      key: "orgnotificationsettingcustomeruser.thisisarethesettingsforthecurrentorganization",
      EN: "These are the settings for the current organization's new customer users.",
      DA: "Dette er indstillingerne for den nuværende organisations nye kundebrugere.",
      NO: "Dette er innstillingene for den nåværende organisasjonens nye kundebrukere.",
      FI: "Nämä ovat nykyisen organisaation uusien asiakaskäyttäjien asetukset.",
      SE: "Detta är inställningarna för den nuvarande organisationens nya kundanvändare."
    },
    {
      key: "orgnotificationsetting.projectturnsoverdue",
      EN: "Project turns overdue",
      DA: "Projektet bliver forfaldent",
      NO: "Prosjektet er forsinket",
      FI: "Projekti erääntyy",
      SE: "Projektet blir försenat"
    },
    {
      key: "orgnotificationsetting.memberisfarbehindschedule",
      EN: "Member is far behind schedule",
      DA: "Medlem er langt bag tidsplanen",
      NO: "Medlemmet er langt bak skjema",
      FI: "Jäsen on paljon jäljessä aikataulusta",
      SE: "Medlem är långt efter schemat"
    },
    {
      key: "orgnotificationsetting.newdealcreated",
      EN: "New deal created",
      DA: "Ny aftale oprettet",
      NO: "Ny avtale opprettet",
      FI: "Uusi sopimus luotu",
      SE: "Ny affär skapad"
    },
    {
      key: "orgnotificationsetting.projectdisabled",
      EN: "Project disabled",
      DA: "Projekt deaktiveret",
      NO: "Prosjekt deaktivert",
      FI: "Projekti poistettu käytöstä",
      SE: "Projekt inaktiverat"
    },
    {
      key: "orgnotificationsetting.projectre-enabled",
      EN: "Project re-enabled",
      DA: "Projekt genaktiveret",
      NO: "Prosjekt aktivert på nytt",
      FI: "Projekti otettu uudelleen käyttöön",
      SE: "Projekt återaktiverat"
    },
    {
      key: "orgnotificationsetting.projectdeleted",
      EN: "Project deleted",
      DA: "Projekt slettet",
      NO: "Prosjekt slettet",
      FI: "Projekti poistettu",
      SE: "Projekt borttaget"
    },
    {
      key: "orgnotificationsetting.projectdeleted",
      EN: "Project deleted",
      DA: "Projekt slettet",
      NO: "Prosjekt slettet",
      FI: "Projekti poistettu",
      SE: "Projekt borttaget"
    },
    {
      key: "customerportalcontrol.projects",
      EN: "Projects",
      DA: "Projekter",
      NO: "Prosjekter",
      FI: "Projektit",
      SE: "Projekt"
    },
    {
      key: "customerportalcontrol.projectslisted",
      EN: "All your projects are listed here.",
      DA: "Alle dine projekter er listet her.",
      NO: "Alle prosjektene dine er oppført her.",
      FI: "Kaikki projektisi on listattu tähän.",
      SE: "Alla dina projekt listas här."
    },
    {
      key: "customerportalcontrol.files",
      EN: "Files",
      DA: "Filer",
      NO: "Filer",
      FI: "Tiedostot",
      SE: "Filer"
    },
    {
      key: "refreshsession.title",
      EN: "Away from keyboard?",
      DA: "Væk fra tastaturet?",
      NO: "Borte fra tastaturet?",
      FI: "Poissa näppäimistöltä?",
      SE: "Borta från tangentbordet?"
    },
    {
      key: "refreshsession.message",
      EN: "You have been inactive for a while, do you want to keep working or log out?",
      DA: "Du har været inaktiv i et stykke tid, vil du fortsætte med at arbejde eller logge ud?",
      NO: "Du har vært inaktiv en stund, vil du fortsette å jobbe eller logge ut?",
      FI: "Olet ollut epäaktiivinen jonkin aikaa, haluatko jatkaa työskentelyä vai kirjautua ulos?",
      SE: "Du har varit inaktiv ett tag, vill du fortsätta arbeta eller logga ut?"
    },
    {
      key: "refreshsession.cancel",
      EN: "Sign out",
      DA: "Log ud",
      NO: "Logg ut",
      FI: "Kirjaudu ulos",
      SE: "Logga ut"
    },
    {
      key: "refreshsession.ok",
      EN: "OK",
      DA: "OK",
      NO: "OK",
      FI: "OK",
      SE: "OK"
    },
    {
      key: "customerusercreate.title",
      EN: "Create customer user",
      DA: "Opret kundebruger",
      NO: "Opprett kundebruker",
      FI: "Luo asiakaskäyttäjä",
      SE: "Skapa kundanvändare"
    },
    {
      key: "customerusercreate.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customerusercreate.jobtitle",
      EN: "Job title",
      DA: "Jobtitel",
      NO: "Stillingstittel",
      FI: "Työnimike",
      SE: "Jobbtitel"
    },
    {
      key: "customerusercreate.email",
      EN: "Email",
      DA: "Email",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "customerusercreate.username",
      EN: "User name",
      DA: "Brugernavn",
      NO: "Brukernavn",
      FI: "Käyttäjänimi",
      SE: "Användarnamn"
    },
    {
      key: "customerusercreate.sendinvitationemail",
      EN: "Send Invitation Email",
      DA: "Send invitations-email",
      NO: "Send invitasjonsepost",
      FI: "Lähetä kutsusähköposti",
      SE: "Skicka inbjudningsmejl"
    },
    {
      key: "customerusercreate.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "customerusercreate.createcustomeruser",
      EN: "Create customer user",
      DA: "Opret kundebruger",
      NO: "Opprett kundebruker",
      FI: "Luo asiakaskäyttäjä",
      SE: "Skapa kundanvändare"
    },
    {
      key: "footer.message",
      EN: "Type your message here...",
      DA: "Skriv din besked her...",
      NO: "Skriv meldingen din her...",
      FI: "Kirjoita viestisi tähän...",
      SE: "Skriv ditt meddelande här..."
    },
    {
      key: "footer.reply",
      EN: "Type your reply here...",
      DA: "Skriv dit svar her...",
      NO: "Skriv svaret ditt her...",
      FI: "Kirjoita vastauksesi tähän...",
      SE: "Skriv ditt svar här..."
    },
    {
      key: "footer.viewreplys",
      EN: "View replies",
      DA: "Se svar",
      NO: "Se svar",
      FI: "Näytä vastaukset",
      SE: "Visa svar"
    },
    {
      key: "footer.closereplys",
      EN: "Close replies",
      DA: "Luk svar",
      NO: "Lukk svar",
      FI: "Sulje vastaukset",
      SE: "Stäng svar"
    },
    {
      key: "footer.startdate",
      EN: "Start date",
      DA: "Start dato",
      NO: "Startdato",
      FI: "Aloituspäivä",
      SE: "Startdatum"
    },
    {
      key: "footer.duedate",
      EN: "Due date",
      DA: "Forfaldsdato",
      NO: "Forfallsdato",
      FI: "Eräpäivä",
      SE: "Förfallodatum"
    },
    {
      key: "footer.responsible",
      EN: "Responsible",
      DA: "Ansvarlig",
      NO: "Ansvarlig",
      FI: "Vastuullinen",
      SE: "Ansvarig"
    },
    {
      key: "customerlogo.logo",
      EN: "Logo",
      DA: "Logo",
      NO: "Logo",
      FI: "Logo",
      SE: "Logotyp"
    },
    {
      key: "customerlogo.logolabel",
      EN: "Choose file...",
      DA: "Vælg fil...",
      NO: "Velg fil...",
      FI: "Valitse tiedosto...",
      SE: "Välj fil..."
    },
    {
      key: "customerlogo.cropimagehelp",
      EN: "Here you can crop your image to fit",
      DA: "Her kan du beskære dit billede, så det passer",
      NO: "Her kan du beskjære bildet ditt for å passe",
      FI: "Täällä voit rajata kuvasi sopivaksi",
      SE: "Här kan du beskära din bild för att passa"
    },
    {
      key: "customerlogo.croppreviewhelp",
      EN: "This is your preview of your crop",
      DA: "Dette er din forhåndsvisning af din beskæring",
      NO: "Dette er forhåndsvisningen av beskjæringen din",
      FI: "Tässä on rajauksen esikatselu",
      SE: "Detta är en förhandsvisning av din beskärning"
    },
    {
      key: "customerlogo.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "customerlogo.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "customertasklist.mytasks",
      EN: "My Tasks",
      DA: "Mine opgaver",
      NO: "Mine oppgaver",
      FI: "Minun tehtäväni",
      SE: "Mina uppgifter"
    },
    {
      key: "customertasklist.alltasks",
      EN: "All Tasks",
      DA: "Alle opgaver",
      NO: "Alle oppgaver",
      FI: "Kaikki tehtävät",
      SE: "Alla uppgifter"
    },
    {
      key: "customertasklist.noassigned",
      EN: "You have no assigned tasks at this moment",
      DA: "Du har ingen tildelte opgaver i øjeblikket",
      NO: "Du har ingen tildelte oppgaver for øyeblikket",
      FI: "Sinulle ei ole tällä hetkellä määritetty tehtäviä",
      SE: "Du har inga tilldelade uppgifter just nu"
    },
    {
      key: "filelist.files",
      EN: "Files",
      DA: "Filer",
      NO: "Filer",
      FI: "Tiedostot",
      SE: "Filer"
    },
    {
      key: "filelist.showcustomerproject",
      EN: "Show customer projects",
      DA: "Vis kundeprojekter",
      NO: "Vis kundeprosjekter",
      FI: "Näytä asiakasprojektit",
      SE: "Visa kundprojekt"
    },
    {
      key: "filelist.typetofilter",
      EN: "Type to filter...",
      DA: "Skriv for at filtrere...",
      NO: "Skriv for å filtrere...",
      FI: "Kirjoita suodattaaksesi...",
      SE: "Skriv för att filtrera..."
    },
    {
      key: "filelist.projectslist",
      EN: "Projects List",
      DA: "Projektliste",
      NO: "Prosjektliste",
      FI: "Projektien lista",
      SE: "Projektlista"
    },
    {
      key: "filelist.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "filelist.project",
      EN: "Project",
      DA: "Projekt",
      NO: "Prosjekt",
      FI: "Projekti",
      SE: "Projekt"
    },
    {
      key: "filelist.uploaded",
      EN: "Uploaded",
      DA: "Uploadet",
      NO: "Lastet opp",
      FI: "Ladattu",
      SE: "Uppladdad"
    },
    {
      key: "filelist.actions",
      EN: "Actions",
      DA: "Handlinger",
      NO: "Handlinger",
      FI: "Toiminnot",
      SE: "Åtgärder"
    },
    {
      key: "filelist.nofilesavailable",
      EN: "You have no files available...",
      DA: "Du har ingen filer tilgængelige...",
      NO: "Du har ingen filer tilgjengelige...",
      FI: "Sinulla ei ole tiedostoja saatavilla...",
      SE: "Du har inga filer tillgängliga..."
    },
    {
      key: "filelist.goback",
      EN: "Go back",
      DA: "Gå tilbage",
      NO: "Gå tilbake",
      FI: "Palaa takaisin",
      SE: "Gå tillbaka"
    },
    {
      key: "filelist.deletefile",
      EN: "Delete file",
      DA: "Slet fil",
      NO: "Slett fil",
      FI: "Poista tiedosto",
      SE: "Radera fil"
    },
    {
      key: "filelist.downloadfile",
      EN: "Download file",
      DA: "Download fil",
      NO: "Last ned fil",
      FI: "Lataa tiedosto",
      SE: "Ladda ner fil"
    },
    {
      key: "filelist.showinproject",
      EN: "Show in project",
      DA: "Vis i projekt",
      NO: "Vis i prosjekt",
      FI: "Näytä projektissa",
      SE: "Visa i projekt"
    },
    {
      key: "filelist.pleaseconfirm",
      EN: "Please confirm the permanent removal of",
      DA: "Bekræft venligst permanent fjernelse af",
      NO: "Bekreft permanent fjerning av",
      FI: "Vahvista pysyvä poistaminen",
      SE: "Vänligen bekräfta permanent borttagning av"
    },
    {
      key: "filelist.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "filelist.confirmdelete",
      EN: "Confirm Delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poisto",
      SE: "Bekräfta borttagning"
    },
    {
      key: "filelist.activefilter",
      EN: "Active Filters",
      DA: "Aktive filtre",
      NO: "Aktive filtre",
      FI: "Aktiiviset suodattimet",
      SE: "Aktiva filter"
    },
    {
      key: "filelist.download",
      EN: "Download",
      DA: "Hent",
      NO: "Last ned",
      FI: "Lataa",
      SE: "Ladda ner"
    },
    {
      key: "filelist.confirm",
      EN: "Confirm delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poistaminen",
      SE: "Bekräfta borttagning"
    },
    {
      key: "filelist.cancel",
      EN: "Cancel delete",
      DA: "Annuller sletning",
      NO: "Avbryt sletting",
      FI: "Peruuta poistaminen",
      SE: "Avbryt borttagning"
    },
    {
      key: "fileupload.fileuploaddelete",
      EN: "File deleted",
      DA: "Fil slettet",
      NO: "Fil slettet",
      FI: "Tiedosto poistettu",
      SE: "Fil borttagen"
    },
    {
      key: "fileupload.fileuploadsuccess",
      EN: "File uploaded",
      DA: "Fil uploadet",
      NO: "Fil lastet opp",
      FI: "Tiedosto ladattu",
      SE: "Fil uppladdad"
    },
    {
      key: "fileupload.fileupload",
      EN: "File upload",
      DA: "Fil upload",
      NO: "Filopplasting",
      FI: "Tiedoston lataus",
      SE: "Filuppladdning"
    },
    {
      key: "fileupload.fileuploadhelp",
      EN: "Choose file...",
      DA: "Vælg fil...",
      NO: "Velg fil...",
      FI: "Valitse tiedosto...",
      SE: "Välj fil..."
    },
    {
      key: "fileupload.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "fileupload.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "imageupload.title",
      EN: "Image upload",
      DA: "Billede upload",
      NO: "Bildeopplasting",
      FI: "Kuvan lataus",
      SE: "Bilduppladdning"
    },
    {
      key: "footer.gotoprojectlisttop",
      EN: "Go to project list",
      DA: "Gå til projektliste",
      NO: "Gå til prosjektliste",
      FI: "Siirry projektilistaan",
      SE: "Gå till projektlista"
    },
    {
      key: "footer.yourprojects",
      EN: "Your Projects",
      DA: "Dine projekter",
      NO: "Dine prosjekter",
      FI: "Omat projektisi",
      SE: "Dina projekt"
    },
    {
      key: "footer.notifications",
      EN: "Notifications",
      DA: "Notifikationer",
      NO: "Varsler",
      FI: "Ilmoitukset",
      SE: "Meddelanden"
    },
    {
      key: "footer.viewtaskrelatedcomments",
      EN: "View task related comments",
      DA: "Se opgavetilknyttede kommentarer",
      NO: "Vis oppgaverelaterte kommentarer",
      FI: "Näytä tehtävään liittyvät kommentit",
      SE: "Visa uppgiftsrelaterade kommentarer"
    },
    {
      key: "footer.confirmdelete",
      EN: "Confirm Delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poisto",
      SE: "Bekräfta borttagning"
    },
    {
      key: "footer.suredelete",
      EN: "Are you sure you want to delete the comment?",
      DA: "Er du sikker på, at du vil slette kommentaren?",
      NO: "Er du sikker på at du vil slette kommentaren?",
      FI: "Oletko varma, että haluat poistaa kommentin?",
      SE: "Är du säker på att du vill ta bort kommentaren?"
    },
    {
      key: "footer.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "footer.confirmdelete",
      EN: "Confirm Delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poisto",
      SE: "Bekräfta borttagning"
    },
    {
      key: "notificationitem.create",
      EN: "Created",
      DA: "Oprettet",
      NO: "Opprettet",
      FI: "Luotu",
      SE: "Skapad"
    },
    {
      key: "notificationitem.read",
      EN: "Read",
      DA: "Læst",
      NO: "Lest",
      FI: "Luettu",
      SE: "Läst"
    },
    {
      key: "orgadd.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "orgadd.namehelp",
      EN: "Enter the Name of your organization",
      DA: "Indtast navnet på din organisation",
      NO: "Skriv navnet på din organisasjon",
      FI: "Anna organisaatiosi nimi",
      SE: "Ange namnet på din organisation"
    },
    {
      key: "orgadd.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "orgadd.descriptionhelp",
      EN: "Enter a description of your organization",
      DA: "Indtast en beskrivelse af din organisation",
      NO: "Skriv en beskrivelse av organisasjonen din",
      FI: "Anna kuvaus organisaatiostasi",
      SE: "Ange en beskrivning av din organisation"
    },
    {
      key: "orgadd.email",
      EN: "Email",
      DA: "Email",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "orgadd.emailhelp",
      EN: "Organization Email",
      DA: "Organisations email",
      NO: "Organisasjonens e-post",
      FI: "Organisaation sähköposti",
      SE: "Organisationens e-post"
    },
    {
      key: "orgadd.website",
      EN: "Website",
      DA: "Hjemmeside",
      NO: "Nettsted",
      FI: "Verkkosivusto",
      SE: "Webbplats"
    },
    {
      key: "orgadd.websitehelp",
      EN: "Organization Website",
      DA: "Organisations hjemmeside",
      NO: "Organisasjonens nettsted",
      FI: "Organisaation verkkosivusto",
      SE: "Organisationens webbplats"
    },
    {
      key: "orgadd.phonenumber",
      EN: "Phone Number",
      DA: "Telefonnummer",
      NO: "Telefonnummer",
      FI: "Puhelinnumero",
      SE: "Telefonnummer"
    },
    {
      key: "orgadd.phonenumberhelp",
      EN: "Organization Phone Number",
      DA: "Organisations telefonnummer",
      NO: "Organisasjonens telefonnummer",
      FI: "Organisaation puhelinnumero",
      SE: "Organisationens telefonnummer"
    },
    {
      key: "orgadd.address",
      EN: "Address",
      DA: "Adresse",
      NO: "Adresse",
      FI: "Osoite",
      SE: "Adress"
    },
    {
      key: "orgadd.addresshelp",
      EN: "Organization First Address Line",
      DA: "Organisations første adresselinje",
      NO: "Organisasjonens første adresselinje",
      FI: "Organisaation ensimmäinen osoiterivi",
      SE: "Organisationens första adressrad"
    },
    {
      key: "orgadd.address2",
      EN: "Address 2",
      DA: "Adresse 2",
      NO: "Adresse 2",
      FI: "Osoite 2",
      SE: "Adress 2"
    },
    {
      key: "orgadd.address2help",
      EN: "Organization Second Address Line",
      DA: "Organisations anden adresselinje",
      NO: "Organisasjonens andre adresselinje",
      FI: "Organisaation toinen osoiterivi",
      SE: "Organisationens andra adressrad"
    },
    {
      key: "orgadd.zip",
      EN: "Zip Code",
      DA: "Postnummer",
      NO: "Postnummer",
      FI: "Postinumero",
      SE: "Postnummer"
    },
    {
      key: "orgadd.ziphelp",
      EN: "Organization Zip Code",
      DA: "Organisations postnummer",
      NO: "Organisasjonens postnummer",
      FI: "Organisaation postinumero",
      SE: "Organisationens postnummer"
    },
    {
      key: "orgadd.city",
      EN: "City",
      DA: "By",
      NO: "By",
      FI: "Kaupunki",
      SE: "Stad"
    },
    {
      key: "orgadd.cityhelp",
      EN: "Organization City",
      DA: "Organisations by",
      NO: "Organisasjonens by",
      FI: "Organisaation kaupunki",
      SE: "Organisationens stad"
    },
    {
      key: "orgadd.country",
      EN: "Country",
      DA: "Land",
      NO: "Land",
      FI: "Maa",
      SE: "Land"
    },
    {
      key: "orgadd.countryhelp",
      EN: "Organization Country",
      DA: "Organisations land",
      NO: "Organisasjonens land",
      FI: "Organisaation maa",
      SE: "Organisationens land"
    },
    {
      key: "orgadd.modules",
      EN: "Worktrest modules",
      DA: "Worktrest-moduler",
      NO: "Worktrest-moduler",
      FI: "Worktrest-moduulit",
      SE: "Worktrest-moduler"
    },
    {
      key: "orgadd.moduleshelp",
      EN: "Values can be none, one or more of these:",
      DA: "Værdier kan være ingen, én eller flere af disse: ",
      NO: "Verdier kan være ingen, én eller flere av disse: ",
      FI: "Arvot voivat olla ei mitään, yksi tai useampi näistä: ",
      SE: "Värden kan vara inga, ett eller flera av dessa: "
    },
    {
      key: "orgadd.createorg",
      EN: "Create Organization",
      DA: "Opret organisation",
      NO: "Opprett organisasjon",
      FI: "Luo organisaatio",
      SE: "Skapa organisation"
    },
    {
      key: "orgedit.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "orgedit.namehelp",
      EN: "This is how your customers and coworkers will see the org",
      DA: "Sådan vil dine kunder og kolleger se organisationen",
      NO: "Slik vil kundene og kollegene dine se organisasjonen",
      FI: "Tältä organisaatiosi näyttää asiakkaille ja työtovereille",
      SE: "Så här kommer dina kunder och kollegor att se organisationen"
    },
    {
      key: "orgedit.email",
      EN: "Email",
      DA: "Email",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "orgedit.emailhelp",
      EN: "This is the email your customers and coworkers will see",
      DA: "Dette er den email, dine kunder og kolleger vil se",
      NO: "Dette er e-posten som kundene og kollegene dine vil se",
      FI: "Tämä on sähköposti, jonka asiakkaasi ja työtoverisi näkevät",
      SE: "Detta är e-posten som dina kunder och kollegor kommer att se"
    },
    {
      key: "orgedit.phone",
      EN: "Phone Number",
      DA: "Telefonnummer",
      NO: "Telefonnummer",
      FI: "Puhelinnumero",
      SE: "Telefonnummer"
    },
    {
      key: "orgedit.phonehelp",
      EN: "This is the number your customers and coworkers will see",
      DA: "Dette er nummeret, dine kunder og kolleger vil se",
      NO: "Dette er nummeret som kundene og kollegene dine vil se",
      FI: "Tämä on numero, jonka asiakkaasi ja työtoverisi näkevät",
      SE: "Detta är numret som dina kunder och kollegor kommer att se"
    },
    {
      key: "orgedit.website",
      EN: "Website",
      DA: "Hjemmeside",
      NO: "Nettsted",
      FI: "Verkkosivusto",
      SE: "Webbplats"
    },
    {
      key: "orgedit.websitehelp",
      EN: "This is your organisation's website",
      DA: "Dette er din organisations hjemmeside",
      NO: "Dette er organisasjonens nettsted",
      FI: "Tämä on organisaatiosi verkkosivusto",
      SE: "Detta är organisationens webbplats"
    },
    {
      key: "orgedit.address",
      EN: "Address",
      DA: "Adresse",
      NO: "Adresse",
      FI: "Osoite",
      SE: "Adress"
    },
    {
      key: "orgedit.addresshelp",
      EN: "This is your organisation's address available to customers and coworkers",
      DA: "Dette er din organisations adresse tilgængelig for kunder og kolleger",
      NO: "Dette er organisasjonens adresse som er tilgjengelig for kunder og kolleger",
      FI: "Tämä on organisaatiosi osoite, joka on saatavilla asiakkaille ja työtovereille",
      SE: "Detta är din organisations adress som är tillgänglig för kunder och kollegor"
    },
    {
      key: "orgedit.address2",
      EN: "Address 2",
      DA: "Adresse 2",
      NO: "Adresse 2",
      FI: "Osoite 2",
      SE: "Adress 2"
    },
    {
      key: "orgedit.address2help",
      EN: "This is your organisation's second address available to customers and coworkers",
      DA: "Dette er din organisations anden adresse tilgængelig for kunder og kolleger",
      NO: "Dette er organisasjonens andre adresse som er tilgjengelig for kunder og kolleger",
      FI: "Tämä on organisaatiosi toinen osoite, joka on saatavilla asiakkaille ja työtovereille",
      SE: "Detta är din organisations andra adress som är tillgänglig för kunder och kollegor"
    },
    {
      key: "orgedit.zip",
      EN: "Zip",
      DA: "Postnummer",
      NO: "Postnummer",
      FI: "Postinumero",
      SE: "Postnummer"
    },
    {
      key: "orgedit.ziphelp",
      EN: "This is how your customers and coworkers will see the org",
      DA: "Sådan vil dine kunder og kolleger se organisationen",
      NO: "Slik vil kundene og kollegene dine se organisasjonen",
      FI: "Tältä organisaatiosi näyttää asiakkaille ja työtovereille",
      SE: "Så här kommer dina kunder och kollegor att se organisationen"
    },
    {
      key: "orgedit.country",
      EN: "Country",
      DA: "Land",
      NO: "Land",
      FI: "Maa",
      SE: "Land"
    },
    {
      key: "orgedit.countryhelp",
      EN: "This is how your customers and coworkers will see the org",
      DA: "Sådan vil dine kunder og kolleger se organisationen",
      NO: "Slik vil kundene og kollegene dine se organisasjonen",
      FI: "Tältä organisaatiosi näyttää asiakkaille ja työtovereille",
      SE: "Så här kommer dina kunder och kollegor att se organisationen"
    },
    {
      key: "orgedit.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "orgedit.descriptionhelp",
      EN: "This is your organizational description",
      DA: "Dette er din organisationsbeskrivelse",
      NO: "Dette er din organisasjonsbeskrivelse",
      FI: "Tämä on organisaatiosi kuvaus",
      SE: "Detta är din organisationsbeskrivning"
    },
    {
      key: "orgedit.clearrampmodules",
      EN: "ClearRamp modules",
      DA: "ClearRamp-moduler",
      NO: "ClearRamp-moduler",
      FI: "ClearRamp-moduulit",
      SE: "ClearRamp-moduler"
    },
    {
      key: "orgedit.clearrampmoduleshelp",
      EN: "List of modules enabled for this organization. Possible values are:",
      DA: "Liste over moduler aktiveret for denne organisation. Mulige værdier er:",
      NO: "Liste over moduler aktivert for denne organisasjonen. Mulige verdier er:",
      FI: "Luettelo moduuleista, jotka on otettu käyttöön tässä organisaatiossa. Mahdolliset arvot ovat:",
      SE: "Lista över moduler som är aktiverade för denna organisation. Möjliga värden är:"
    },
    {
      key: "orgmemberlist.orgmembers",
      EN: "Organization Members",
      DA: "Organisationsmedlemmer",
      NO: "Organisasjonsmedlemmer",
      FI: "Organisaation jäsenet",
      SE: "Organisationsmedlemmar"
    },
    {
      key: "orgmemberlist.orgmemberssub",
      EN: "Your organization members are listed here",
      DA: "Dine organisationsmedlemmer er listet her",
      NO: "Dine organisasjonsmedlemmer er listet her",
      FI: "Organisaatiosi jäsenet on listattu tähän",
      SE: "Dina organisationsmedlemmar listas här"
    },
    {
      key: "orgmemberlist.createusertip",
      EN: "Create new user",
      DA: "Opret ny bruger",
      NO: "Opprett ny bruker",
      FI: "Luo uusi käyttäjä",
      SE: "Skapa ny användare"
    },
    {
      key: "orgmemberlist.joined",
      EN: "Joined",
      DA: "Tilmeldt",
      NO: "Ble med",
      FI: "Liittynyt",
      SE: "Gick med"
    },
    {
      key: "orgmemberlist.showdetails",
      EN: "Show details of",
      DA: "Vis detaljer om",
      NO: "Vis detaljer om",
      FI: "Näytä tiedot",
      SE: "Visa detaljer om"
    },
    {
      key: "orgprojectlist.title",
      EN: "Your Organization Projects",
      DA: "Dine organisationsprojekter",
      NO: "Dine organisasjonsprosjekter",
      FI: "Organisaatiosi projektit",
      SE: "Dina organisationsprojekt"
    },
    {
      key: "orgprojectlist.titlesub",
      EN: "Your projects are listed here",
      DA: "Dine projekter er listet her",
      NO: "Dine prosjekter er listet her",
      FI: "Projektisi on listattu tähän",
      SE: "Dina projekt listas här"
    },
    {
      key: "orgprojectlist.crateanewproject",
      EN: "Create a new project",
      DA: "Opret et nyt projekt",
      NO: "Opprett et nytt prosjekt",
      FI: "Luo uusi projekti",
      SE: "Skapa ett nytt projekt"
    },
    {
      key: "orgprojectlist.createcustomer",
      EN: "Create customer",
      DA: "Opret kunde",
      NO: "Opprett kunde",
      FI: "Luo asiakas",
      SE: "Skapa kund"
    },
    {
      key: "orgprojectlist.fromtemplate",
      EN: "From template",
      DA: "Fra skabelon",
      NO: "Fra mal",
      FI: "Mallista",
      SE: "Från mall"
    },
    {
      key: "orgprojectlist.fromtemplatetip",
      EN: "Create from template",
      DA: "Opret fra skabelon",
      NO: "Opprett fra mal",
      FI: "Luo mallista",
      SE: "Skapa från mall"
    },
    {
      key: "orgprojectlist.fromblank",
      EN: "From blank",
      DA: "Fra blank",
      NO: "Fra tomt",
      FI: "Tyhjästä",
      SE: "Från tomt"
    },
    {
      key: "orgprojectlist.createblank",
      EN: "Create blank",
      DA: "Opret tomt",
      NO: "Opprett tomt",
      FI: "Luo tyhjä",
      SE: "Skapa tomt"
    },
    {
      key: "orgprojectlist.togglevisibility",
      EN: "Toggle visibility",
      DA: "Skift synlighed",
      NO: "Endre synlighet",
      FI: "Vaihda näkyvyys",
      SE: "Ändra synlighet"
    },
    {
      key: "orgprojectlist.togglevisibilitytip",
      EN: "Toggle project visibility",
      DA: "Skift projektets synlighed",
      NO: "Endre prosjektets synlighet",
      FI: "Vaihda projektin näkyvyys",
      SE: "Ändra projektets synlighet"
    },
    {
      key: "orgprojectlist.showdetailsof",
      EN: "Show details of",
      DA: "Vis detaljer om",
      NO: "Vis detaljer om",
      FI: "Näytä tiedot",
      SE: "Visa detaljer om"
    },
    {
      key: "orgprojectlist.created",
      EN: "Created",
      DA: "Oprettet",
      NO: "Opprettet",
      FI: "Luotu",
      SE: "Skapad"
    },
    {
      key: "orgprojectlist.editprojecttip",
      EN: "Edit Project",
      DA: "Rediger projekt",
      NO: "Rediger prosjekt",
      FI: "Muokkaa projektia",
      SE: "Redigera projekt"
    },
    {
      key: "orgprojectlist.projectdescription",
      EN: "Project Description",
      DA: "Projektbeskrivelse",
      NO: "Prosjektbeskrivelse",
      FI: "Projektin kuvaus",
      SE: "Projekbeskrivning"
    },
    {
      key: "orgprojectlist.assignpeopletoproject",
      EN: "Assign People to project",
      DA: "Tildel personer til projekt",
      NO: "Tildel personer til prosjekt",
      FI: "Määritä henkilöitä projektiin",
      SE: "Tilldela personer till projektet"
    },
    {
      key: "orgprojectlist.deleteprojecttip",
      EN: "Delete Project",
      DA: "Slet projekt",
      NO: "Slett prosjekt",
      FI: "Poista projekti",
      SE: "Radera projekt"
    },
    {
      key: "orgprojectlist.disableorenableproject",
      EN: "Disable or Enable Project",
      DA: "Deaktiver eller aktiver projekt",
      NO: "Deaktiver eller aktiver prosjekt",
      FI: "Poista käytöstä tai ota projekti käyttöön",
      SE: "Inaktivera eller aktivera projekt"
    },
    {
      key: "orgprojectlist.deleteprojectmodal",
      EN: "Delete Project",
      DA: "Slet projekt",
      NO: "Slett prosjekt",
      FI: "Poista projekti",
      SE: "Radera projekt"
    },
    {
      key: "orgprojectlist.deleteprojectmodalwarning",
      EN: "Important: This action removes the project permanently, to keep project use disable icon!",
      DA: "Vigtigt: Denne handling fjerner projektet permanent, for at bevare projektet brug deaktiveringsikonet!",
      NO: "Viktig: Denne handlingen fjerner prosjektet permanent, for å beholde prosjektet, bruk deaktiveringsikonet!",
      FI: "Tärkeää: Tämä toiminto poistaa projektin pysyvästi, säilyttääksesi projektin käytä poistopainiketta!",
      SE: "Viktigt: Denna åtgärd tar bort projektet permanent, använd inaktiveringsikonen för att behålla projektet!"
    },
    {
      key: "orgprojectlist.deleteprojectmodalconfirm",
      EN: "Please Confirm your action by choosing an option below.",
      DA: "Bekræft venligst din handling ved at vælge en mulighed nedenfor.",
      NO: "Vennligst bekreft handlingen din ved å velge et alternativ nedenfor.",
      FI: "Vahvista toimintosi valitsemalla vaihtoehto alla.",
      SE: "Bekräfta din åtgärd genom att välja ett alternativ nedan."
    },
    {
      key: "orgprojectlist.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "orgprojectlist.confirmdelete",
      EN: "Confirm Delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poisto",
      SE: "Bekräfta borttagning"
    },
    {
      key: "orgprojectlist.disableproject",
      EN: "Disable Project",
      DA: "Deaktiver projekt",
      NO: "Deaktiver prosjekt",
      FI: "Poista projekti käytöstä",
      SE: "Inaktivera projekt"
    },
    {
      key: "orgprojectlist.enableproject",
      EN: "Enable Project",
      DA: "Aktiver projekt",
      NO: "Aktiver prosjekt",
      FI: "Ota projekti käyttöön",
      SE: "Aktivera projekt"
    },
    {
      key: "orgprojectlist.managetags",
      EN: "Manage tags",
      DA: "Administrer tags",
      NO: "Administrer merkelapper",
      FI: "Hallinnoi tunnisteita",
      SE: "Hantera etiketter"
    },
    {
      key: "orgprojectlist.managetagshelp",
      EN: "Here you can create new tags or remove existing tags.",
      DA: "Her kan du oprette nye tags eller fjerne eksisterende tags.",
      NO: "Her kan du opprette nye merkelapper eller fjerne eksisterende.",
      FI: "Täällä voit luoda uusia tunnisteita tai poistaa olemassa olevia.",
      SE: "Här kan du skapa nya etiketter eller ta bort befintliga."
    },
    {
      key: "orgprojectlist.assigntags",
      EN: "Assign tags",
      DA: "Tildel tags",
      NO: "Tildel merkelapper",
      FI: "Määritä tunnisteita",
      SE: "Tilldela etiketter"
    },
    {
      key: "orgprojectlist.assigntagshelp",
      EN: "Here you can assign tags to your project.",
      DA: "Her kan du tildele tags til dit projekt.",
      NO: "Her kan du tildele merkelapper til prosjektet ditt.",
      FI: "Täällä voit määrittää tunnisteita projektiisi.",
      SE: "Här kan du tilldela etiketter till ditt projekt."
    },
    {
      key: "orgprojectlist.create",
      EN: "Create",
      DA: "Opret",
      NO: "Opprett",
      FI: "Luo",
      SE: "Skapa"
    },
    {
      key: "orgprojectmemberlist.title",
      EN: "Project Members",
      DA: "Projektmedlemmer",
      NO: "Prosjektmedlemmer",
      FI: "Projektin jäsenet",
      SE: "Projektmedlemmar"
    },
    {
      key: "orgprojectmemberlist.subtitle",
      EN: "Project members are listed here",
      DA: "Projektmedlemmer er listet her",
      NO: "Prosjektmedlemmer er listet her",
      FI: "Projektin jäsenet on listattu tähän",
      SE: "Projektmedlemmar listas här"
    },
    {
      key: "orgprojectmemberlist.showdetailsof",
      EN: "Show details of",
      DA: "Vis detaljer om",
      NO: "Vis detaljer om",
      FI: "Näytä tiedot",
      SE: "Visa detaljer om"
    },
    {
      key: "orgprojectmemberlist.joined",
      EN: "Joined",
      DA: "Tilmeldt",
      NO: "Ble med",
      FI: "Liittynyt",
      SE: "Gick med"
    },
    {
      key: "orgprojectmemberlist.edituserrole",
      EN: "Edit User Role",
      DA: "Rediger brugerrolle",
      NO: "Rediger brukerrolle",
      FI: "Muokkaa käyttäjän roolia",
      SE: "Redigera användarroll"
    },
    {
      key: "orgprojectmemberlist.enteruserroleplace",
      EN: "Enter User Role...",
      DA: "Indtast brugerrolle...",
      NO: "Skriv inn brukerrolle...",
      FI: "Syötä käyttäjän rooli...",
      SE: "Ange användarroll..."
    },
    {
      key: "orgprojectmemberlist.enteruserrolehelp",
      EN: "Don't forget to assign the correct roles.",
      DA: "Glem ikke at tildele de korrekte roller.",
      NO: "Ikke glem å tildele de riktige rollene.",
      FI: "Älä unohda määrittää oikeita rooleja.",
      SE: "Glöm inte att tilldela rätt roller."
    },
    {
      key: "orgprojectmemberlist.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "orgprojectmemberlist.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "orgprojectmemberlist.confirmuserremoveval",
      EN: "Confirm User Removal",
      DA: "Bekræft fjernelse af bruger",
      NO: "Bekreft fjerning av bruker",
      FI: "Vahvista käyttäjän poistaminen",
      SE: "Bekräfta borttagning av användare"
    },
    {
      key: "orgprojectmemberlist.confirmuserremovevalmsg",
      EN: "Are you sure you want to remove the user?",
      DA: "Er du sikker på, at du vil fjerne brugeren?",
      NO: "Er du sikker på at du vil fjerne brukeren?",
      FI: "Oletko varma, että haluat poistaa käyttäjän?",
      SE: "Är du säker på att du vill ta bort användaren?"
    },
    {
      key: "orgprojectmemberlist.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "orgprojectmemberlist.removeuser",
      EN: "Remove User",
      DA: "Fjern bruger",
      NO: "Fjern bruker",
      FI: "Poista käyttäjä",
      SE: "Ta bort användare"
    },
    {
      key: "orgprojectpendingjoinerlist.title",
      EN: "Pending Joiners",
      DA: "Ventende deltagere",
      NO: "Ventende deltakere",
      FI: "Odotettavat liittyjät",
      SE: "Väntande deltagare"
    },
    {
      key: "orgprojectpendingjoinerlist.subtitle",
      EN: "Pending joiners are listed here",
      DA: "Ventende deltagere er listet her",
      NO: "Ventende deltakere er listet her",
      FI: "Odotettavat liittyjät on listattu tähän",
      SE: "Väntande deltagare listas här"
    },
    {
      key: "orgprojectpendingjoinerlist.showdetailsof",
      EN: "Show details of",
      DA: "Vis detaljer om",
      NO: "Vis detaljer om",
      FI: "Näytä tiedot",
      SE: "Visa detaljer om"
    },
    {
      key: "orgprojectpendingjoinerlist.accept",
      EN: "Accept",
      DA: "Accepter",
      NO: "Aksepter",
      FI: "Hyväksy",
      SE: "Acceptera"
    },
    {
      key: "orgprojectpendingjoinerlist.decline",
      EN: "Decline",
      DA: "Afvis",
      NO: "Avslå",
      FI: "Hylkää",
      SE: "Avböj"
    },
    {
      key: "orgsettings.title",
      EN: "Org Settings",
      DA: "Organisationsindstillinger",
      NO: "Organisasjonsinnstillinger",
      FI: "Organisaation asetukset",
      SE: "Organisationsinställningar"
    },
    {
      key: "orgsettings.settingsloader",
      EN: "Saving changes....",
      DA: "Gemmer ændringer....",
      NO: "Lagrer endringer....",
      FI: "Tallennetaan muutoksia....",
      SE: "Sparar ändringar...."
    },
    {
      key: "orgsettings.updated",
      EN: "Settings updated!",
      DA: "Indstillinger opdateret!",
      NO: "Innstillinger oppdatert!",
      FI: "Asetukset päivitetty!",
      SE: "Inställningar uppdaterade!"
    },
    {
      key: "orgsettings.systemlanguage",
      EN: "System Language",
      DA: "Systemets sprog",
      NO: "Systemspråk",
      FI: "Järjestelmän kieli",
      SE: "Systemspråk"
    },
    {
      key: "orgsettings.english",
      EN: "English",
      DA: "Engelsk",
      NO: "Engelsk",
      FI: "Englanti",
      SE: "Engelska"
    },
    {
      key: "orgsettings.danish",
      EN: "Danish",
      DA: "Dansk",
      NO: "Dansk",
      FI: "Tanska",
      SE: "Danska"
    },
    {
      key: "orgsettings.swedish",
      EN: "Swedish",
      DA: "Svensk",
      NO: "Svensk",
      FI: "Ruotsi",
      SE: "Svenska"
    },
    {
      key: "orgsettings.norwegian",
      EN: "Norwegian",
      DA: "Norsk",
      NO: "Norsk",
      FI: "Norja",
      SE: "Norska"
    },
    {
      key: "orgsettings.finnish",
      EN: "Finnish",
      DA: "Finsk",
      NO: "Finsk",
      FI: "Suomi",
      SE: "Finska"
    },
    {
      key: "orgsettings.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "orgsettings.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "orgview.title",
      EN: "Edit Your Information",
      DA: "Rediger dine oplysninger",
      NO: "Rediger informasjonen din",
      FI: "Muokkaa tietojasi",
      SE: "Redigera din information"
    },
    {
      key: "orglogo.fileplace",
      EN: "Choose file...",
      DA: "Vælg fil...",
      NO: "Velg fil...",
      FI: "Valitse tiedosto...",
      SE: "Välj fil..."
    },
    {
      key: "orglogo.croptofit",
      EN: "Here you can crop your image to fit",
      DA: "Her kan du beskære dit billede, så det passer",
      NO: "Her kan du beskjære bildet ditt så det passer",
      FI: "Tässä voit rajata kuvasi sopivaksi",
      SE: "Här kan du beskära din bild för att passa"
    },
    {
      key: "orglogo.previewcrop",
      EN: "This is your preview of your crop",
      DA: "Dette er din forhåndsvisning af din beskæring",
      NO: "Dette er forhåndsvisningen av beskjæringen din",
      FI: "Tässä on esikatselu rajaamastasi kuvasta",
      SE: "Detta är din förhandsvisning av beskärningen"
    },
    {
      key: "orglogo.save",
      EN: "Save",
      DA: "Gem",
      NO: "Lagre",
      FI: "Tallenna",
      SE: "Spara"
    },
    {
      key: "customercontrol.nomatch",
      EN: "No matching projects, try changing your filters",
      DA: "Ingen matchende projekter, prøv at ændre dine filtre",
      NO: "Ingen samsvarende prosjekter, prøv å endre filtrene dine",
      FI: "Ei vastaavia projekteja, kokeile muuttaa suodattimia",
      SE: "Inga matchande projekt, försök ändra dina filter"
    },
    {
      key: "customercontrol.nocustomers",
      EN: "You have no customers, create your first here!",
      DA: "Du har ingen kunder, opret din første her!",
      NO: "Du har ingen kunder, opprett din første her!",
      FI: "Sinulla ei ole asiakkaita, luo ensimmäinen tästä!",
      SE: "Du har inga kunder, skapa din första här!"
    },
    {
      key: "customercontrol.title",
      EN: "Customers",
      DA: "Kunder",
      NO: "Kunder",
      FI: "Asiakkaat",
      SE: "Kunder"
    },
    {
      key: "customercontrol.subtitle",
      EN: "Your customers are listed here",
      DA: "Dine kunder er listet her",
      NO: "Dine kunder er listet her",
      FI: "Asiakkaasi on listattu tähän",
      SE: "Dina kunder listas här"
    },
    {
      key: "customercontrol.createnewcustomertip",
      EN: "Create new customer",
      DA: "Opret ny kunde",
      NO: "Opprett ny kunde",
      FI: "Luo uusi asiakas",
      SE: "Skapa ny kund"
    },
    {
      key: "customercontrol.deals",
      EN: "Deals:",
      DA: "Aftaler:",
      NO: "Avtaler:",
      FI: "Sopimukset:",
      SE: "Avtal:"
    },
    {
      key: "customercontrol.createcustomer",
      EN: "Create Customer",
      DA: "Opret kunde",
      NO: "Opprett kunde",
      FI: "Luo asiakas",
      SE: "Skapa kund"
    },
    {
      key: "customercontrol.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customercontrol.nameplace",
      EN: "Customer Name Here...",
      DA: "Kundens navn her...",
      NO: "Kundens navn her...",
      FI: "Asiakkaan nimi tähän...",
      SE: "Kundens namn här..."
    },
    {
      key: "customercontrol.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "customercontrol.descriptionplace",
      EN: "Enter task description",
      DA: "Indtast opgavebeskrivelse",
      NO: "Skriv inn oppgavebeskrivelse",
      FI: "Anna tehtävän kuvaus",
      SE: "Ange uppgiftsbeskrivning"
    },
    {
      key: "customercontrol.website",
      EN: "Website",
      DA: "Hjemmeside",
      NO: "Nettsted",
      FI: "Verkkosivusto",
      SE: "Webbplats"
    },
    {
      key: "customercontrol.websitenplace",
      EN: "Customer Website Here...",
      DA: "Kundens hjemmeside her...",
      NO: "Kundens nettsted her...",
      FI: "Asiakkaan verkkosivusto tähän...",
      SE: "Kundens webbplats här..."
    },
    {
      key: "customercontrol.address",
      EN: "Address",
      DA: "Adresse",
      NO: "Adresse",
      FI: "Osoite",
      SE: "Adress"
    },
    {
      key: "customercontrol.addressplace",
      EN: "Customer Address Here...",
      DA: "Kundens adresse her...",
      NO: "Kundens adresse her...",
      FI: "Asiakkaan osoite tähän...",
      SE: "Kundens adress här..."
    },
    {
      key: "customercontrol.address2",
      EN: "Address 2",
      DA: "Adresse 2",
      NO: "Adresse 2",
      FI: "Osoite 2",
      SE: "Adress 2"
    },
    {
      key: "customercontrol.address2place",
      EN: "Customer Address Second Here...",
      DA: "Kundens anden adresse her...",
      NO: "Kundens andre adresse her...",
      FI: "Asiakkaan toinen osoite tähän...",
      SE: "Kundens andra adress här..."
    },
    {
      key: "customercontrol.city",
      EN: "City",
      DA: "By",
      NO: "By",
      FI: "Kaupunki",
      SE: "Stad"
    },
    {
      key: "customercontrol.cityplace",
      EN: "Customer City Here...",
      DA: "Kundens by her...",
      NO: "Kundens by her...",
      FI: "Asiakkaan kaupunki tähän...",
      SE: "Kundens stad här..."
    },
    {
      key: "customercontrol.zip",
      EN: "Zip",
      DA: "Postnummer",
      NO: "Postnummer",
      FI: "Postinumero",
      SE: "Postnummer"
    },
    {
      key: "customercontrol.zipplace",
      EN: "Customer Zip Here...",
      DA: "Kundens postnummer her...",
      NO: "Kundens postnummer her...",
      FI: "Asiakkaan postinumero tähän...",
      SE: "Kundens postnummer här..."
    },
    {
      key: "customercontrol.maincontact",
      EN: "Main Contact",
      DA: "Hovedkontakt",
      NO: "Hovedkontakt",
      FI: "Pääyhteyshenkilö",
      SE: "Huvudkontakt"
    },
    {
      key: "customercontrol.maincontactplace",
      EN: "Customer Main Contact Here...",
      DA: "Kundens hovedkontakt her...",
      NO: "Kundens hovedkontakt her...",
      FI: "Asiakkaan pääyhteyshenkilö tähän...",
      SE: "Kundens huvudkontakt här..."
    },
    {
      key: "customercontrol.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "customercontrol.createyourcustomer",
      EN: "Create your customer",
      DA: "Opret din kunde",
      NO: "Opprett din kunde",
      FI: "Luo asiakkaasi",
      SE: "Skapa din kund"
    },
    {
      key: "customerdeal.title",
      EN: "Deal information",
      DA: "Aftaleoplysninger",
      NO: "Avtaleinformasjon",
      FI: "Sopimustiedot",
      SE: "Affärsinformation"
    },
    {
      key: "customerdeal.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customerdeal.owner",
      EN: "Owner",
      DA: "Ejer",
      NO: "Eier",
      FI: "Omistaja",
      SE: "Ägare"
    },
    {
      key: "customerdeal.dealdate",
      EN: "Deal date",
      DA: "Aftaledato",
      NO: "Avtaledato",
      FI: "Sopimuspäivämäärä",
      SE: "Affärsdatum"
    },
    {
      key: "customerdeal.status",
      EN: "Status",
      DA: "Status",
      NO: "Status",
      FI: "Tila",
      SE: "Status"
    },
    {
      key: "customerdeal.relatedprojects",
      EN: "Related projects",
      DA: "Relaterede projekter",
      NO: "Relaterte prosjekter",
      FI: "Liittyvät projektit",
      SE: "Relaterade projekt"
    },
    {
      key: "customerdeal.startdate",
      EN: "Start date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivämäärä",
      SE: "Startdatum"
    },
    {
      key: "customerdeal.duedate",
      EN: "Due date",
      DA: "Forfaldsdato",
      NO: "Forfallsdato",
      FI: "Eräpäivä",
      SE: "Förfallodatum"
    },
    {
      key: "customerdeallist.title",
      EN: "Deal",
      DA: "Aftaler",
      NO: "Avtaler",
      FI: "Sopimukset",
      SE: "Avtal"
    },
    {
      key: "customerdeallist.createdealtip",
      EN: "Create deal",
      DA: "Opret aftale",
      NO: "Opprett avtale",
      FI: "Luo sopimus",
      SE: "Skapa avtal"
    },
    {
      key: "customerdeallist.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customerdeallist.owner",
      EN: "Owner",
      DA: "Ejer",
      NO: "Eier",
      FI: "Omistaja",
      SE: "Ägare"
    },
    {
      key: "customerdeallist.closingdate",
      EN: "Closing Date",
      DA: "Lukkedato",
      NO: "Lukkedato",
      FI: "Päättymispäivä",
      SE: "Stängningsdatum"
    },
    {
      key: "customerdeallist.status",
      EN: "Status",
      DA: "Status",
      NO: "Status",
      FI: "Tila",
      SE: "Status"
    },
    {
      key: "customerdeallist.projects",
      EN: "Projects",
      DA: "Projekter",
      NO: "Prosjekter",
      FI: "Projektit",
      SE: "Projekt"
    },
    {
      key: "customerdeallist.editdealtip",
      EN: "Edit deal",
      DA: "Rediger aftale",
      NO: "Rediger avtale",
      FI: "Muokkaa sopimusta",
      SE: "Redigera avtal"
    },
    {
      key: "customerdeallist.deletedealtip",
      EN: "Delete deal",
      DA: "Slet aftale",
      NO: "Slett avtale",
      FI: "Poista sopimus",
      SE: "Ta bort avtal"
    },
    {
      key: "customerdeallist.dealcreation",
      EN: "Deal Creation",
      DA: "Oprettelse af aftale",
      NO: "Opprettelse av avtale",
      FI: "Sopimuksen luonti",
      SE: "Skapande av avtal"
    },
    {
      key: "customerdeallist.dealname",
      EN: "Deal name",
      DA: "Aftalenavn",
      NO: "Avtalenavn",
      FI: "Sopimuksen nimi",
      SE: "Avtalsnamn"
    },
    {
      key: "customerdeallist.dealnameplace",
      EN: "Your Deal Name here....",
      DA: "Dit aftalenavn her....",
      NO: "Ditt avtalenavn her....",
      FI: "Sopimuksesi nimi tähän....",
      SE: "Ditt avtalsnamn här...."
    },
    {
      key: "customerdeallist.owner",
      EN: "Owner",
      DA: "Ejer",
      NO: "Eier",
      FI: "Omistaja",
      SE: "Ägare"
    },
    {
      key: "customerdeallist.ownerplace",
      EN: "Your Deal Owner Name here....",
      DA: "Dit aftaleejers navn her....",
      NO: "Navnet på avtaleeieren din her....",
      FI: "Sopimuksen omistajan nimi tähän....",
      SE: "Ditt avtalsägarnamn här...."
    },
    {
      key: "customerdeallist.details",
      EN: "Details",
      DA: "Detaljer",
      NO: "Detaljer",
      FI: "Yksityiskohdat",
      SE: "Detaljer"
    },
    {
      key: "customerdeallist.detailsplace",
      EN: "Your Deal details here....",
      DA: "Dine aftaledetaljer her....",
      NO: "Avtaledetaljene dine her....",
      FI: "Sopimuksesi yksityiskohdat tähän....",
      SE: "Dina avtalsdetaljer här...."
    },
    {
      key: "customerdeallist.dealdate",
      DA: "Aftale dato",
      NO: "Avtaledato",
      FI: "Sopimuksen päivämäärä",
      SE: "Avtalsdatum"
    },
    {
      key: "customerdeallist.dealcrmid",
      DA: "Aftale CRM-id",
      NO: "Avtalets CRM-id",
      FI: "Sopimuksen CRM-tunnus",
      SE: "Avtalets CRM-ID"
    },
    {
      key: "customerdeallist.status",
      EN: "Status",
      DA: "Status",
      NO: "Status",
      FI: "Tila",
      SE: "Status"
    },
    {
      key: "customerdeallist.choosedealstatus",
      EN: "Choose deal status",
      DA: "Vælg aftalestatus",
      NO: "Velg avtale status",
      FI: "Valitse sopimuksen tila",
      SE: "Välj avtalsstatus"
    },
    {
      key: "customerdeallist.new",
      EN: "New",
      DA: "Ny",
      NO: "Ny",
      FI: "Uusi",
      SE: "Ny"
    },
    {
      key: "customerdeallist.handled",
      EN: "Handled",
      DA: "Håndteret",
      NO: "Behandlet",
      FI: "Käsitelty",
      SE: "Hanterad"
    },
    {
      key: "customerdeallist.done",
      EN: "Done",
      DA: "Udført",
      NO: "Utført",
      FI: "Valmis",
      SE: "Klar"
    },
    {
      key: "customerdeallist.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "customerdeallist.createdeal",
      EN: "Create Deal",
      DA: "Opret aftale",
      NO: "Opprett avtale",
      FI: "Luo sopimus",
      SE: "Skapa avtal"
    },
    {
      key: "customerdeallist.updatedeal",
      EN: "Update Deal",
      DA: "Opdater aftale",
      NO: "Oppdater avtale",
      FI: "Päivitä sopimus",
      SE: "Uppdatera avtal"
    },
    {
      key: "customerdeallist.confirmdealdeletion",
      EN: "Confirm Deal Deletion",
      DA: "Bekræft sletning af aftale",
      NO: "Bekreft sletting av avtale",
      FI: "Vahvista sopimuksen poistaminen",
      SE: "Bekräfta borttagning av avtal"
    },
    {
      key: "customerdeallist.confirmdealdeletionmsg",
      EN: "Are you sure you want to delete the deal?",
      DA: "Er du sikker på, at du vil slette aftalen?",
      NO: "Er du sikker på at du vil slette avtalen?",
      FI: "Oletko varma, että haluat poistaa sopimuksen?",
      SE: "Är du säker på att du vill ta bort avtalet?"
    },
    {
      key: "customerdeallist.deletedeal",
      EN: "Delete deal",
      DA: "Slet aftale",
      NO: "Slett avtale",
      FI: "Poista sopimus",
      SE: "Ta bort avtal"
    },
    {
      key: "customerpage.view",
      EN: "View",
      DA: "Vis",
      NO: "Vis",
      FI: "Näytä",
      SE: "Visa"
    },
    {
      key: "customerpage.customerType",
      EN: "Customer type",
      DA: "Kundetype",
      NO: "Kundetype",
      FI: "Asiakastyyppi",
      SE: "Kundtyp"
    },
    {
      key: "customerpage.viewtip",
      EN: "Show customer view",
      DA: "Vis kundens visning",
      NO: "Vis kundevisning",
      FI: "Näytä asiakkaan näkymä",
      SE: "Visa kundens vy"
    },
    {
      key: "customerpage.customerwelcome",
      EN: "Customer Welcome",
      DA: "Kundens velkomst",
      NO: "Kundens velkomst",
      FI: "Asiakkaan tervetulotoivotus",
      SE: "Kundens välkomst"
    },
    {
      key: "customerpage.customerwelcometip",
      EN: "Show customer view",
      DA: "Vis kundens visning",
      NO: "Vis kundevisning",
      FI: "Näytä asiakkaan näkymä",
      SE: "Visa kundens vy"
    },
    {
      key: "customerpage.delete",
      EN: "Delete",
      DA: "Slet",
      NO: "Slett",
      FI: "Poista",
      SE: "Ta bort"
    },
    {
      key: "customerpage.deletetip",
      EN: "Delete Customer",
      DA: "Slet kunde",
      NO: "Slett kunde",
      FI: "Poista asiakas",
      SE: "Ta bort kund"
    },
    {
      key: "customerpage.logo",
      EN: "Logo",
      DA: "Logo",
      NO: "Logo",
      FI: "Logo",
      SE: "Logotyp"
    },
    {
      key: "customerpage.logotip",
      EN: "Edit Customer Image",
      DA: "Rediger kundebillede",
      NO: "Rediger kundebilde",
      FI: "Muokkaa asiakaskuvaa",
      SE: "Redigera kundbild"
    },
    {
      key: "customerpage.edit",
      EN: "Edit",
      DA: "Rediger",
      NO: "Rediger",
      FI: "Muokkaa",
      SE: "Redigera"
    },
    {
      key: "customerpage.edittip",
      EN: "Edit Customer",
      DA: "Rediger kunde",
      NO: "Rediger kunde",
      FI: "Muokkaa asiakasta",
      SE: "Redigera kund"
    },
    {
      key: "customerpage.intro",
      EN: "Intro",
      DA: "Introduktion",
      NO: "Introduksjon",
      FI: "Esittely",
      SE: "Introduktion"
    },
    {
      key: "customerpage.introtip",
      EN: "Change intro info",
      DA: "Rediger introduktionsinfo",
      NO: "Endre introduksjonsinfo",
      FI: "Muokkaa esittelytietoja",
      SE: "Ändra introduktionsinfo"
    },
    {
      key: "customerpage.showcustomerprojects",
      EN: "Show customer projects",
      DA: "Vis kundens projekter",
      NO: "Vis kundens prosjekter",
      FI: "Näytä asiakkaan projektit",
      SE: "Visa kundens projekt"
    },
    {
      key: "customerpage.showcustomerfiles",
      EN: "Show customer files",
      DA: "Vis kundens filer",
      NO: "Vis kundens filer",
      FI: "Näytä asiakkaan tiedostot",
      SE: "Visa kundens filer"
    },
    {
      key: "customerpage.editcustomerinformation",
      EN: "Edit customer information",
      DA: "Rediger kundeoplysninger",
      NO: "Rediger kundeinformasjon",
      FI: "Muokkaa asiakastietoja",
      SE: "Redigera kundinformation"
    },
    {
      key: "customerpage.customertitle",
      EN: "Customer Title",
      DA: "Kundetitel",
      NO: "Kundetittel",
      FI: "Asiakkaan otsikko",
      SE: "Kundtitel"
    },
    {
      key: "customerpage.description",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "customerpage.descriptionplace",
      EN: "Enter task description...",
      DA: "Indtast opgavebeskrivelse...",
      NO: "Skriv oppgavebeskrivelse...",
      FI: "Anna tehtävän kuvaus...",
      SE: "Ange uppgiftsbeskrivning..."
    },
    {
      key: "customerpage.address",
      EN: "Address",
      DA: "Adresse",
      NO: "Adresse",
      FI: "Osoite",
      SE: "Adress"
    },
    {
      key: "customerpage.address2",
      EN: "Address 2",
      DA: "Adresse 2",
      NO: "Adresse 2",
      FI: "Osoite 2",
      SE: "Adress 2"
    },
    {
      key: "customerpage.city",
      EN: "City",
      DA: "By",
      NO: "By",
      FI: "Kaupunki",
      SE: "Stad"
    },
    {
      key: "customerpage.website",
      EN: "Website",
      DA: "Hjemmeside",
      NO: "Nettsted",
      FI: "Verkkosivusto",
      SE: "Webbplats"
    },
    {
      key: "customerpage.zip",
      EN: "Zip",
      DA: "Postnummer",
      NO: "Postnummer",
      FI: "Postinumero",
      SE: "Postnummer"
    },
    {
      key: "customerpage.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "customerpage.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "customerpage.managecustomerimage",
      EN: "Manage customer image",
      DA: "Administrer kundebillede",
      NO: "Administrer kundebilde",
      FI: "Hallinnoi asiakaskuvaa",
      SE: "Hantera kundbild"
    },
    {
      key: "customerpage.deletemsg",
      EN: "Please confirm the permanent deletion of the customer",
      DA: "Bekræft venligst den permanente sletning af kunden",
      NO: "Bekreft den permanente slettingen av kunden",
      FI: "Vahvista asiakkaan pysyvä poistaminen",
      SE: "Bekräfta den permanenta borttagningen av kunden"
    },
    {
      key: "customerpage.deletealert",
      EN: "The Customer deletion is PERMANENT! please be careful",
      DA: "Kundesletningen er PERMANENT! vær venligst forsigtig",
      NO: "Kundeslettingen er PERMANENT! vær forsiktig",
      FI: "Asiakkaan poistaminen on PYSYVÄÄ! ole varovainen",
      SE: "Kundborttagningen är PERMANENT! var försiktig"
    },
    {
      key: "customerpage.cancel",
      EN: "Cancel",
      DA: "Annuller",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "customerpage.assigntags",
      EN: "Assign tags",
      DA: "Tildel tags",
      NO: "Tildel tags",
      FI: "Määritä tunnisteita",
      SE: "Tilldela taggar"
    },
    {
      key: "customerpage.assigntagshelp",
      EN: "Here you can assign tags to your project.",
      DA: "Her kan du tildele tags til dit projekt.",
      NO: "Her kan du tildele tags til prosjektet ditt.",
      FI: "Tässä voit määrittää tunnisteita projektiisi.",
      SE: "Här kan du tilldela taggar till ditt projekt."
    },
    {
      key: "customerpage.assigntagsplace",
      EN: "Your tag...",
      DA: "Din tag...",
      NO: "Din tag...",
      FI: "Tunnisteesi...",
      SE: "Din tagg..."
    },
    {
      key: "customerpage.create",
      EN: "Create",
      DA: "Opret",
      NO: "Opprett",
      FI: "Luo",
      SE: "Skapa"
    },
    {
      key: "customerpage.tag1",
      EN: "Tag 1",
      DA: "Tag 1",
      NO: "Tag 1",
      FI: "Tunniste 1",
      SE: "Tagg 1"
    },
    {
      key: "customerprojectlist.title",
      EN: "Projects",
      DA: "Projekter",
      NO: "Prosjekter",
      FI: "Projektit",
      SE: "Projekt"
    },
    {
      key: "customerprojectlist.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customerprojectlist.startdate",
      EN: "Start Date",
      DA: "Startdato",
      NO: "Startdato",
      FI: "Aloituspäivämäärä",
      SE: "Startdatum"
    },
    {
      key: "customerprojectlist.enddate",
      EN: "End Date",
      DA: "Slutdato",
      NO: "Sluttdato",
      FI: "Päättymispäivämäärä",
      SE: "Slutdatum"
    },
    {
      key: "customeruseredit.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customeruseredit.jobtitle",
      EN: "Job title",
      DA: "Jobtitel",
      NO: "Jobbtittel",
      FI: "Työnimike",
      SE: "Jobbtitel"
    },
    {
      key: "customeruseredit.email",
      EN: "Email",
      DA: "Email",
      NO: "E-post",
      FI: "Sähköposti",
      SE: "E-post"
    },
    {
      key: "customeruseredit.username",
      EN: "User name",
      DA: "Brugernavn",
      NO: "Brukernavn",
      FI: "Käyttäjänimi",
      SE: "Användarnamn"
    },
    {
      key: "customeruseredit.sendinvitationemail",
      EN: "Send Invitation Email",
      DA: "Send invitationsemail",
      NO: "Send invitasjonsemail",
      FI: "Lähetä kutsusähköposti",
      SE: "Skicka inbjudan via e-post"
    },
    {
      key: "customeruseredit.activated",
      EN: "Activate",
      DA: "Aktiver",
      NO: "Aktiver",
      FI: "Aktivoi",
      SE: "Aktivera"
    },
    {
      key: "customeruseredit.activatedalert",
      EN: "If left unchecked the customer user will not be able to sign in or receive any notifications.",
      DA: "Hvis dette felt er ikke markeret, vil kunden ikke kunne logge ind eller modtage notifikationer.",
      NO: "Hvis dette ikke er markert, vil kunden ikke kunne logge inn eller motta varsler.",
      FI: "Jos tätä ei valita, asiakas ei voi kirjautua sisään eikä vastaanottaa ilmoituksia.",
      SE: "Om detta inte är markerat kommer kunden inte kunna logga in eller ta emot några notifikationer."
    },
    {
      key: "customeruseredit.sendalert",
      EN: "If left unchecked the customer user will not receive login credentials.",
      DA: "Hvis dette felt ikke er markeret, vil kunden ikke modtage loginoplysninger.",
      NO: "Hvis dette ikke er markert, vil kunden ikke motta innloggingsinformasjon.",
      FI: "Jos tätä ei valita, asiakas ei saa kirjautumistietoja.",
      SE: "Om detta inte är markerat kommer kunden inte att få inloggningsuppgifter."
    },
    {
      key: "customeruseredit.activatedalert2",
      EN: "The customer user will be able to sign in and receive notifications.",
      DA: "Kunden vil nu kunne logge ind og modtage notifikationer.",
      NO: "Kunden vil nå kunne logge inn og motta varsler.",
      FI: "Asiakas voi nyt kirjautua sisään ja vastaanottaa ilmoituksia.",
      SE: "Kunden kan nu logga in och ta emot notifikationer."
    },
    {
      key: "customeruseredit.sendalert2",
      EN: "The customer user will receive login credentials.",
      DA: "Kunden vil nu modtage loginoplysninger.",
      NO: "Kunden vil nå motta innloggingsinformasjon.",
      FI: "Asiakas saa nyt kirjautumistiedot.",
      SE: "Kunden kommer nu att få inloggningsuppgifter."
    },
    {
      key: "customeruseredit.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "customeruseredit.savechanges",
      EN: "Save changes",
      DA: "Gem ændringer",
      NO: "Lagre endringer",
      FI: "Tallenna muutokset",
      SE: "Spara ändringar"
    },
    {
      key: "customeruserlist.title",
      EN: "Customer Users",
      DA: "Kunde brugere",
      NO: "Kunde brukere",
      FI: "Asiakas käyttäjät",
      SE: "Kundanvändare"
    },
    {
      key: "customeruserlist.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "customeruserlist.userstate",
      EN: "User State",
      DA: "Bruger status",
      NO: "Brukerstatus",
      FI: "Käyttäjän tila",
      SE: "Användarstatus"
    },
    {
      key: "customeruserlist.username",
      EN: "Username",
      DA: "Brugernavn",
      NO: "Brukernavn",
      FI: "Käyttäjänimi",
      SE: "Användarnamn"
    },
    {
      key: "customeruserlist.deletecustomeruser",
      EN: "Delete customer user",
      DA: "Slet kunde bruger",
      NO: "Slett kunde bruker",
      FI: "Poista asiakas käyttäjä",
      SE: "Ta bort kundanvändare"
    },
    {
      key: "customeruserlist.deletecustomeruserconfirm",
      EN: "Please confirm the permanent removal of ",
      DA: "Bekræft venligst den permanente fjernelse af ",
      NO: "Vennligst bekreft permanent fjerning av ",
      FI: "Vahvista pysyvä poisto kohteesta ",
      SE: "Bekräfta permanent borttagning av "
    },
    {
      key: "customeruserlist.close",
      EN: "Close",
      DA: "Luk",
      NO: "Lukk",
      FI: "Sulje",
      SE: "Stäng"
    },
    {
      key: "customeruserlist.confirmdelete",
      EN: "Confirm Delete",
      DA: "Bekræft sletning",
      NO: "Bekreft sletting",
      FI: "Vahvista poisto",
      SE: "Bekräfta borttagning"
    },
    {
      key: "customeruserlist.editcustomeruser",
      EN: "Edit customer user",
      DA: "Rediger kunde bruger",
      NO: "Rediger kunde bruker",
      FI: "Muokkaa asiakaskäyttäjää",
      SE: "Redigera kundanvändare"
    },
    {
      key: "compactprojectlist.title",
      EN: "Project list",
      DA: "Projektliste",
      NO: "Prosjektliste",
      FI: "Projektiluettelo",
      SE: "Projektlista"
    },
    {
      key: "modalvalidation.requiredfieldmissing",
      EN: "Please fill out all required fields",
      DA: "Udfyld venligst alle påkrævede felter",
      NO: "Vennligst fyll ut alle påkrevde felt",
      FI: "Täytä kaikki pakolliset kentät",
      SE: "Fyll i alla obligatoriska fält"
    },
    {
      key: "modalvalidation.stageeditwarning",
      EN: "Please note that changing dates and or visibility will affect all tasks under this stage, events will only be affected by a visibility change.",
      DA: "Bemærk, at ændring af datoer og/eller synlighed vil påvirke alle opgaver under dette trin, begivenheder påvirkes kun af ændringer i synlighed.",
      NO: "Vær oppmerksom på at endring av datoer og/eller synlighet vil påvirke alle oppgaver under dette trinnet. Hendelser blir bare påvirket av endringer i synlighet.",
      FI: "Huomaa, että päivämäärien ja/tai näkyvyyden muuttaminen vaikuttaa kaikkiin tämän vaiheen tehtäviin, tapahtumiin vaikuttaa vain näkyvyyden muutos.",
      SE: "Observera att ändring av datum och/eller synlighet påverkar alla uppgifter under detta steg. Händelser påverkas endast av en ändring av synligheten."
    },
    {
      key: "notificationitem.navigate",
      EN: "Click to navigate to project",
      DA: "Klik for at navigere til projekt",
      NO: "Klikk for å navigere til prosjektet",
      FI: "Napsauta siirtyäksesi projektiin",
      SE: "Klicka för att navigera till projektet"
    },
    {
      key: "tagfilter.clickremove",
      EN: "Remove tag",
      DA: "Klik for at fjerne tag",
      NO: "Klikk for å fjerne taggen",
      FI: "Napsauta poistaaksesi tunnisteen",
      SE: "Klicka för att ta bort taggen"
    },
    {
      key: "tagfilter.loadingtags",
      EN: "Loading filters...",
      DA: "Indlæser filtre...",
      NO: "Laster filtre...",
      FI: "Ladataan suodattimia...",
      SE: "Laddar filter..."
    },
    {
      key: "cpltask.completetask",
      EN: "Finish task",
      DA: "Afslut opgave",
      NO: "Fullfør oppgave",
      FI: "Suorita tehtävä",
      SE: "Slutför uppgift"
    },
    {
      key: "cpltask.completeform",
      EN: "Complete form",
      DA: "Udfyld formular",
      NO: "Fullfør skjema",
      FI: "Täytä lomake",
      SE: "Slutför formulär"
    },
    {
      key: "cplevent.duration",
      EN: "Duration",
      DA: "Varighed",
      NO: "Varighet",
      FI: "Kesto",
      SE: "Varaktighet"
    },
    {
      key: "cpllist.submit",
      EN: "Submit your data",
      DA: "Indsend dine data",
      NO: "Send inn dataene dine",
      FI: "Lähetä tietosi",
      SE: "Skicka in dina data"
    },
    {
      key: "cpllist.completed",
      EN: "Completed",
      DA: "Fuldført",
      NO: "Fullført",
      FI: "Valmis",
      SE: "Slutförd"
    },
    {
      key: "cpllist.datasubmitted",
      EN: "Data submitted",
      DA: "Data indsendt",
      NO: "Data sendt inn",
      FI: "Tiedot lähetetty",
      SE: "Data inskickat"
    },
    {
      key: "cpllist.pending",
      EN: "Pending",
      DA: "Afventer",
      NO: "Avventer",
      FI: "Odottaa",
      SE: "Väntar"
    },
    {
      key: "cpllist.inprogress",
      EN: "In progress",
      DA: "I gang",
      NO: "Pågår",
      FI: "Käynnissä",
      SE: "Pågår"
    },
    {
      key: "cpllist.downloadtemplates",
      EN: "Download templates",
      DA: "Download skabeloner",
      NO: "Last ned maler",
      FI: "Lataa mallipohjat",
      SE: "Ladda ner mallar"
    },
    {
      key: "cpllist.submitbody",
      EN: "Here you can submit the data required for the platform.",
      DA: "Her kan du indsende de data, der er nødvendige for platformen.",
      NO: "Her kan du sende inn dataene som kreves for plattformen.",
      FI: "Tässä voit lähettää alustalle tarvittavat tiedot.",
      SE: "Här kan du skicka in de uppgifter som krävs för plattformen."
    },
    {
      key: "cpllist.downloadbody",
      EN: "Here you can download templates for your data.",
      DA: "Her kan du downloade skabeloner til dine data.",
      NO: "Her kan du laste ned maler for dataene dine.",
      FI: "Tässä voit ladata mallipohjat tiedoillesi.",
      SE: "Här kan du ladda ner mallar för dina data."
    },
    {
      key: "projectautomation.name",
      EN: "Name",
      DA: "Navn",
      NO: "Navn",
      FI: "Nimi",
      SE: "Namn"
    },
    {
      key: "projectautomation.order",
      EN: "Order",
      DA: "Rækkefølge",
      NO: "Rekkefølge",
      FI: "Järjestys",
      SE: "Ordning"
    },
    {
      key: "projectautomation.nameplace",
      EN: "Automation name...",
      DA: "Automatiseringsnavn...",
      NO: "Automatiseringsnavn...",
      FI: "Automaatio nimi...",
      SE: "Automationsnamn..."
    },
    {
      key: "projectautomation.desc",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "projectautomation.descplace",
      EN: "Automation description...",
      DA: "Automatiseringsbeskrivelse...",
      NO: "Automatiseringsbeskrivelse...",
      FI: "Automaatio kuvaus...",
      SE: "Automationsbeskrivning..."
    },
    {
      key: "projectautomation.action",
      EN: "Action",
      DA: "Handling",
      NO: "Handling",
      FI: "Toiminto",
      SE: "Åtgärd"
    },
    {
      key: "projectautomation.trigger",
      EN: "Trigger",
      DA: "Udløser",
      NO: "Trigger",
      FI: "Laukaisin",
      SE: "Utlösare"
    },
    {
      key: "projectautomation.confirmdelete",
      EN: "Are you sure you want to delete",
      DA: "Er du sikker på, at du vil slette",
      NO: "Er du sikker på at du vil slette",
      FI: "Haluatko varmasti poistaa",
      SE: "Är du säker på att du vill ta bort"
    },
    {
      key: "projectautomation.subheader",
      EN: "Here you can manage your project automations.",
      DA: "Her kan du administrere dine projekt-automatiseringer.",
      NO: "Her kan du administrere prosjektautomatiseringene dine.",
      FI: "Täällä voit hallita projektisi automaatioita.",
      SE: "Här kan du hantera dina projektautomationer."
    },
    {
      key: "projectautomation.createautomation",
      EN: "Create automation",
      DA: "Opret automatisering",
      NO: "Opprett automatisering",
      FI: "Luo automaatio",
      SE: "Skapa automation"
    },
    {
      key: "projectautomation.type",
      EN: "Type",
      DA: "Type",
      NO: "Type",
      FI: "Tyyppi",
      SE: "Typ"
    },
    {
      key: "projectautomationaction.urlplace",
      EN: "URL here....",
      DA: "URL her....",
      NO: "URL her....",
      FI: "URL tähän....",
      SE: "URL här...."
    },
    {
      key: "projectautomationaction.headersplace",
      EN: "Header here...",
      DA: "Header her...",
      NO: "Header her...",
      FI: "Otsake tähän...",
      SE: "Rubrik här..."
    },
    {
      key: "projectautomationaction.bodyplace",
      EN: "Body here...",
      DA: "Body her...",
      NO: "Body her...",
      FI: "Sisältö tähän...",
      SE: "Innehåll här..."
    },
    {
      key: "projectautomationaction.loadauto",
      EN: "Loading Automations...",
      DA: "Indlæser automatiseringer...",
      NO: "Laster automatiseringer...",
      FI: "Ladataan automaatioita...",
      SE: "Laddar automationer..."
    },
    {
      key: "projectautomationaction.deletemodalwarning",
      EN: "Important: This action removes the automation permanently!",
      DA: "Vigtigt: Denne handling fjerner automatiseringen permanent!",
      NO: "Viktig: Denne handlingen fjerner automatiseringen permanent!",
      FI: "Tärkeää: Tämä toiminto poistaa automaation pysyvästi!",
      SE: "Viktigt: Denna åtgärd tar bort automationen permanent!"
    },
    {
      key: "forms.title",
      EN: "Form Templates",
      DA: "Formular skabeloner",
      NO: "Skjemamaler",
      FI: "Lomakemallit",
      SE: "Formulärmallar"
    },
    {
      key: "forms.search.placeholder",
      EN: "Search forms...",
      DA: "Søg formularer...",
      NO: "Søk skjemaer...",
      FI: "Etsi lomakkeita...",
      SE: "Sök formulär..."
    },
    {
      key: "forms.filter.all",
      EN: "All Statuses",
      DA: "Alle statusser",
      NO: "Alle statuser",
      FI: "Kaikki tilat",
      SE: "Alla statusar"
    },
    {
      key: "forms.status.draft",
      EN: "Draft",
      DA: "Kladde",
      NO: "Utkast",
      FI: "Luonnos",
      SE: "Utkast"
    },
    {
      key: "forms.status.published",
      EN: "Published",
      DA: "Udgivet",
      NO: "Publisert",
      FI: "Julkaistu",
      SE: "Publicerad"
    },
    {
      key: "forms.status.archived",
      EN: "Archived",
      DA: "Arkiveret",
      NO: "Arkivert",
      FI: "Arkistoitu",
      SE: "Arkiverad"
    },
    {
      key: "forms.create.new",
      EN: "New Form",
      DA: "Ny formular",
      NO: "Nytt skjema",
      FI: "Uusi lomake",
      SE: "Nytt formulär"
    },
    {
      key: "forms.create.first",
      EN: "Create First Form",
      DA: "Opret første formular",
      NO: "Opprett første skjema",
      FI: "Luo ensimmäinen lomake",
      SE: "Skapa första formulär"
    },
    {
      key: "forms.loading",
      EN: "Loading forms...",
      DA: "Indlæser formularer...",
      NO: "Laster skjemaer...",
      FI: "Ladataan lomakkeita...",
      SE: "Laddar formulär..."
    },
    {
      key: "forms.empty.message",
      EN: "No form templates found.",
      DA: "Ingen formular skabeloner fundet.",
      NO: "Ingen skjemamaler funnet.",
      FI: "Lomakemalleja ei löytynyt.",
      SE: "Inga formulärmallar hittades."
    },
    {
      key: "forms.fields",
      EN: "fields",
      DA: "felter",
      NO: "felter",
      FI: "kentät",
      SE: "fält"
    },
    {
      key: "forms.version",
      EN: "Version",
      DA: "Version",
      NO: "Versjon",
      FI: "Versio",
      SE: "Version"
    },
    {
      key: "forms.action.edit",
      EN: "Edit",
      DA: "Rediger",
      NO: "Rediger",
      FI: "Muokkaa",
      SE: "Redigera"
    },
    {
      key: "forms.action.archive",
      EN: "Archive",
      DA: "Arkiver",
      NO: "Arkiver",
      FI: "Arkistoi",
      SE: "Arkivera"
    },
    {
      key: "forms.action.restore",
      EN: "Restore",
      DA: "Gendan",
      NO: "Gjenopprett",
      FI: "Palauta",
      SE: "Återställ"
    },
    {
      key: "forms.action.duplicate",
      EN: "Duplicate",
      DA: "Duplikér",
      NO: "Dupliser",
      FI: "Kopioi",
      SE: "Duplicera"
    },
    {
      key: "forms.action.more",
      EN: "More options",
      DA: "Flere muligheder",
      NO: "Flere alternativer",
      FI: "Lisää vaihtoehtoja",
      SE: "Fler alternativ"
    },
    {
      key: "forms.builder.edit",
      EN: "Edit Form",
      DA: "Rediger formular",
      NO: "Rediger skjema",
      FI: "Muokkaa lomaketta",
      SE: "Redigera formulär"
    },
    {
      key: "forms.builder.create",
      EN: "Create New Form",
      DA: "Opret ny formular",
      NO: "Opprett nytt skjema",
      FI: "Luo uusi lomake",
      SE: "Skapa nytt formulär"
    },
    {
      key: "forms.builder.showPreview",
      EN: "Show Preview",
      DA: "Vis forhåndsvisning",
      NO: "Vis forhåndsvisning",
      FI: "Näytä esikatselu",
      SE: "Visa förhandsgranskning"
    },
    {
      key: "forms.builder.hidePreview",
      EN: "Hide Preview",
      DA: "Skjul forhåndsvisning",
      NO: "Skjul forhåndsvisning",
      FI: "Piilota esikatselu",
      SE: "Dölj förhandsgranskning"
    },
    {
      key: "forms.builder.previewForm",
      EN: "Preview Form",
      DA: "Forhåndsvisning",
      NO: "Forhåndsvisning",
      FI: "Esikatselu",
      SE: "Förhandsgranska"
    },
    {
      key: "forms.builder.readonly.title",
      EN: "This is a published version and cannot be edited.",
      DA: "Dette er en udgivet version og kan ikke redigeres.",
      NO: "Dette er en publisert versjon og kan ikke redigeres.",
      FI: "Tämä on julkaistu versio, eikä sitä voi muokata.",
      SE: "Detta är en publicerad version och kan inte redigeras."
    },
    {
      key: "forms.builder.readonly.message",
      EN: "Published versions are immutable. To make changes, create a new draft version.",
      DA: "Udgivne versioner er uforanderlige. For at foretage ændringer skal du oprette en ny kladdeversion.",
      NO: "Publiserte versjoner er uforanderlige. For å gjøre endringer, opprett en ny utkastversjon.",
      FI: "Julkaistuja versioita ei voi muuttaa. Tee muutoksia luomalla uusi luonnosversio.",
      SE: "Publicerade versioner är oföränderliga. För att göra ändringar, skapa en ny utkastversion."
    },
    {
      key: "forms.builder.archived.title",
      EN: "This form has been archived.",
      DA: "Denne formular er blevet arkiveret.",
      NO: "Dette skjemaet er arkivert.",
      FI: "Tämä lomake on arkistoitu.",
      SE: "Detta formulär har arkiverats."
    },
    {
      key: "forms.builder.archived.message",
      EN: "Archived forms are read-only and cannot be edited or published. They can still be viewed for reference.",
      DA: "Arkiverede formularer er skrivebeskyttede og kan ikke redigeres eller udgives. De kan stadig ses som reference.",
      NO: "Arkiverte skjemaer er skrivebeskyttet og kan ikke redigeres eller publiseres. De kan fortsatt ses som referanse.",
      FI: "Arkistoidut lomakkeet ovat vain luettavissa, eikä niitä voi muokata tai julkaista. Niitä voi edelleen tarkastella.",
      SE: "Arkiverade formulär är skrivskyddade och kan inte redigeras eller publiceras. De kan fortfarande visas för referens."
    },
    {
      key: "forms.builder.archive",
      EN: "Archive",
      DA: "Arkivér",
      NO: "Arkiver",
      FI: "Arkistoi",
      SE: "Arkivera"
    },
    {
      key: "forms.builder.archiving",
      EN: "Archiving...",
      DA: "Arkiverer...",
      NO: "Arkiverer...",
      FI: "Arkistoidaan...",
      SE: "Arkiverar..."
    },
    {
      key: "forms.builder.createDraft",
      EN: "Create New Draft",
      DA: "Opret ny kladde",
      NO: "Opprett nytt utkast",
      FI: "Luo uusi luonnos",
      SE: "Skapa nytt utkast"
    },
    {
      key: "forms.builder.creating",
      EN: "Creating Draft...",
      DA: "Opretter kladde...",
      NO: "Oppretter utkast...",
      FI: "Luodaan luonnosta...",
      SE: "Skapar utkast..."
    },
    {
      key: "forms.builder.name.label",
      EN: "Form Name",
      DA: "Formular navn",
      NO: "Skjemanavn",
      FI: "Lomakkeen nimi",
      SE: "Formulärnamn"
    },
    {
      key: "forms.builder.name.placeholder",
      EN: "Enter form name",
      DA: "Indtast formular navn",
      NO: "Skriv inn skjemanavn",
      FI: "Anna lomakkeen nimi",
      SE: "Ange formulärnamn"
    },
    {
      key: "forms.builder.description.label",
      EN: "Description",
      DA: "Beskrivelse",
      NO: "Beskrivelse",
      FI: "Kuvaus",
      SE: "Beskrivning"
    },
    {
      key: "forms.builder.description.placeholder",
      EN: "Enter form description",
      DA: "Indtast formular beskrivelse",
      NO: "Skriv inn skjemabeskrivelse",
      FI: "Anna lomakkeen kuvaus",
      SE: "Ange formulärbeskrivning"
    },
    {
      key: "forms.builder.palette.title",
      EN: "Field Types",
      DA: "Felttyper",
      NO: "Felttyper",
      FI: "Kenttätyypit",
      SE: "Fälttyper"
    },
    {
      key: "forms.builder.tabs.title",
      EN: "Tabs",
      DA: "Faner",
      NO: "Faner",
      FI: "Välilehdet",
      SE: "Flikar"
    },
    {
      key: "forms.builder.tabs.add",
      EN: "Add tab",
      DA: "Tilføj fane",
      NO: "Legg til fane",
      FI: "Lisää välilehti",
      SE: "Lägg till flik"
    },
    {
      key: "forms.builder.tabs.remove",
      EN: "Remove tab",
      DA: "Fjern fane",
      NO: "Fjern fane",
      FI: "Poista välilehti",
      SE: "Ta bort flik"
    },
    {
      key: "forms.builder.fields.title",
      EN: "Fields",
      DA: "Felter",
      NO: "Felter",
      FI: "Kentät",
      SE: "Fält"
    },
    {
      key: "forms.builder.fields.remove",
      EN: "Remove field",
      DA: "Fjern felt",
      NO: "Fjern felt",
      FI: "Poista kenttä",
      SE: "Ta bort fält"
    },
    {
      key: "forms.builder.fields.label",
      EN: "Field Label",
      DA: "Felt etiket",
      NO: "Feltetikett",
      FI: "Kentän otsikko",
      SE: "Fältetikett"
    },
    {
      key: "forms.builder.fields.labelPlaceholder",
      EN: "Enter field label",
      DA: "Indtast felt etiket",
      NO: "Skriv inn feltetikett",
      FI: "Anna kentän otsikko",
      SE: "Ange fältetikett"
    },
    {
      key: "forms.builder.fields.helpText",
      EN: "Help Text",
      DA: "Hjælpetekst",
      NO: "Hjelpetekst",
      FI: "Ohjeteksti",
      SE: "Hjälptext"
    },
    {
      key: "forms.builder.fields.helpTextPlaceholder",
      EN: "Enter help text (optional)",
      DA: "Indtast hjælpetekst (valgfri)",
      NO: "Skriv inn hjelpetekst (valgfritt)",
      FI: "Anna ohjeteksti (valinnainen)",
      SE: "Ange hjälptext (valfritt)"
    },
    {
      key: "forms.builder.fields.required",
      EN: "Required",
      DA: "Påkrævet",
      NO: "Påkrevd",
      FI: "Pakollinen",
      SE: "Obligatorisk"
    },
    {
      key: "forms.builder.fields.pattern",
      EN: "Pattern (regex)",
      DA: "Mønster (regex)",
      NO: "Mønster (regex)",
      FI: "Malli (regex)",
      SE: "Mönster (regex)"
    },
    {
      key: "forms.builder.fields.patternPlaceholder",
      EN: "Enter validation pattern (optional)",
      DA: "Indtast valideringsmønster (valgfri)",
      NO: "Skriv inn valideringsmønster (valgfritt)",
      FI: "Anna validointimalli (valinnainen)",
      SE: "Ange valideringsmönster (valfritt)"
    },
    {
      key: "forms.builder.fields.options",
      EN: "Options",
      DA: "Valgmuligheder",
      NO: "Alternativer",
      FI: "Vaihtoehdot",
      SE: "Alternativ"
    },
    {
      key: "forms.builder.fields.addOption",
      EN: "Add option",
      DA: "Tilføj valgmulighed",
      NO: "Legg til alternativ",
      FI: "Lisää vaihtoehto",
      SE: "Lägg till alternativ"
    },
    {
      key: "forms.builder.fields.optionValue",
      EN: "Value",
      DA: "Værdi",
      NO: "Verdi",
      FI: "Arvo",
      SE: "Värde"
    },
    {
      key: "forms.builder.fields.optionLabel",
      EN: "Label",
      DA: "Etiket",
      NO: "Etikett",
      FI: "Otsikko",
      SE: "Etikett"
    },
    {
      key: "forms.builder.fields.empty",
      EN: "No fields yet. Add fields from the palette on the left.",
      DA: "Ingen felter endnu. Tilføj felter fra paletten til venstre.",
      NO: "Ingen felter ennå. Legg til felter fra paletten til venstre.",
      FI: "Ei kenttiä vielä. Lisää kenttiä vasemmalla olevasta paletista.",
      SE: "Inga fält ännu. Lägg till fält från paletten till vänster."
    },
    {
      key: "forms.builder.preview.title",
      EN: "Preview",
      DA: "Forhåndsvisning",
      NO: "Forhåndsvisning",
      FI: "Esikatselu",
      SE: "Förhandsgranskning"
    },
    {
      key: "forms.builder.preview.hint",
      EN: "See how your form looks to users",
      DA: "Se hvordan din formular ser ud for brugerne",
      NO: "Se hvordan skjemaet ditt ser ut for brukerne",
      FI: "Katso miltä lomakkeesi näyttää käyttäjille",
      SE: "Se hur ditt formulär ser ut för användarna"
    },
    {
      key: "forms.builder.preview.untitled",
      EN: "Untitled Form",
      DA: "Unavngivet formular",
      NO: "Uten tittel skjema",
      FI: "Nimetön lomake",
      SE: "Namnlöst formulär"
    },
    {
      key: "forms.builder.preview.enterText",
      EN: "Enter text...",
      DA: "Indtast tekst...",
      NO: "Skriv inn tekst...",
      FI: "Anna teksti...",
      SE: "Ange text..."
    },
    {
      key: "forms.builder.preview.chooseOption",
      EN: "Choose an option...",
      DA: "Vælg en mulighed...",
      NO: "Velg et alternativ...",
      FI: "Valitse vaihtoehto...",
      SE: "Välj ett alternativ..."
    },
    {
      key: "forms.builder.saveDraft",
      EN: "Save as Draft",
      DA: "Gem som kladde",
      NO: "Lagre som utkast",
      FI: "Tallenna luonnoksena",
      SE: "Spara som utkast"
    },
    {
      key: "forms.builder.publish",
      EN: "Publish",
      DA: "Udgiv",
      NO: "Publiser",
      FI: "Julkaise",
      SE: "Publicera"
    },
    {
      key: "forms.builder.publishing",
      EN: "Publishing...",
      DA: "Udgiver...",
      NO: "Publiserer...",
      FI: "Julkaistaan...",
      SE: "Publicerar..."
    },
    {
      key: "forms.builder.discard",
      EN: "Discard",
      DA: "Kassér",
      NO: "Forkast",
      FI: "Hylkää",
      SE: "Kasta"
    },
    {
      key: "forms.fieldtype.text.desc",
      EN: "Single line text input",
      DA: "Enkelt linje tekstinput",
      NO: "Enkeltlinje tekstinndata",
      FI: "Yhden rivin tekstinsyöttö",
      SE: "Enradig textinmatning"
    },
    {
      key: "forms.fieldtype.select-one.desc",
      EN: "Dropdown selection (single choice)",
      DA: "Rullemenuvælg (enkelt valg)",
      NO: "Rullegardinvalg (enkelt valg)",
      FI: "Pudotusvalikko (yksi valinta)",
      SE: "Rullgardinsval (ett val)"
    },
    {
      key: "forms.fieldtype.select-multiple.desc",
      EN: "Checkbox selection (multiple choices)",
      DA: "Afkrydsningsfeltvælg (flere valg)",
      NO: "Avkryssingsboksvalg (flere valg)",
      FI: "Valintaruutu (useita valintoja)",
      SE: "Kryssrutor (flera val)"
    },
    {
      key: "forms.fieldtype.file.desc",
      EN: "File upload",
      DA: "Filupload",
      NO: "Filopplasting",
      FI: "Tiedoston lataus",
      SE: "Filuppladdning"
    },
    {
      key: "forms.fieldtype.image.desc",
      EN: "Image upload",
      DA: "Billedupload",
      NO: "Bildeopplasting",
      FI: "Kuvan lataus",
      SE: "Bilduppladdning"
    },
    {
      key: "forms.successarchive",
      EN: "Form archived successfully",
      DA: "Formular arkiveret",
      NO: "Skjema arkivert",
      FI: "Lomake arkistoitu onnistuneesti",
      SE: "Formulär arkiverat"
    },
    {
      key: "forms.successdraft",
      EN: "New draft created successfully",
      DA: "Ny kladde oprettet",
      NO: "Nytt utkast opprettet",
      FI: "Uusi luonnos luotu onnistuneesti",
      SE: "Nytt utkast skapat"
    },
    {
      key: "forms.successsave",
      EN: "Form saved successfully",
      DA: "Formular gemt",
      NO: "Skjema lagret",
      FI: "Lomake tallennettu onnistuneesti",
      SE: "Formulär sparat"
    },
    {
      key: "forms.confirmarchive.title",
      EN: "Confirm Archive",
      DA: "Bekræft arkivering",
      NO: "Bekreft arkivering",
      FI: "Vahvista arkistointi",
      SE: "Bekräfta arkivering"
    },
    {
      key: "forms.confirmarchive.message",
      EN: "Are you sure you want to archive this form template? Archived templates cannot be linked to new tasks or projects, but existing links and responses will be preserved.",
      DA: "Er du sikker på, at du vil arkivere denne formularskabelon? Arkiverede skabeloner kan ikke linkes til nye opgaver eller projekter, men eksisterende links og svar vil blive bevaret.",
      NO: "Er du sikker på at du vil arkivere denne skjemamalen? Arkiverte maler kan ikke kobles til nye oppgaver eller prosjekter, men eksisterende koblinger og svar vil bli bevart.",
      FI: "Haluatko varmasti arkistoida tämän lomakepohjan? Arkistoituja pohjia ei voi linkittää uusiin tehtäviin tai projekteihin, mutta olemassa olevat linkit ja vastaukset säilytetään.",
      SE: "Är du säker på att du vill arkivera den här formulärmallen? Arkiverade mallar kan inte länkas till nya uppgifter eller projekt, men befintliga länkar och svar kommer att bevaras."
    },
    {
      key: "forms.archive",
      EN: "Archive",
      DA: "Arkivér",
      NO: "Arkiver",
      FI: "Arkistoi",
      SE: "Arkivera"
    },
    {
      key: "forms.cancel",
      EN: "Cancel",
      DA: "Annullér",
      NO: "Avbryt",
      FI: "Peruuta",
      SE: "Avbryt"
    },
    {
      key: "forms.confirmdraft.title",
      EN: "Create New Draft?",
      DA: "Opret ny kladde?",
      NO: "Opprett nytt utkast?",
      FI: "Luo uusi luonnos?",
      SE: "Skapa nytt utkast?"
    },
    {
      key: "forms.confirmdraft.message",
      EN: "This will create an editable draft that you can modify and publish as the next version. The current published version will remain unchanged.",
      DA: "Dette vil oprette en redigerbar kladde, som du kan ændre og udgive som den næste version. Den nuværende udgivne version forbliver uændret.",
      NO: "Dette vil opprette et redigerbart utkast som du kan endre og publisere som neste versjon. Den nåværende publiserte versjonen vil forbli uendret.",
      FI: "Tämä luo muokattavan luonnoksen, jonka voit muokata ja julkaista seuraavana versiona. Nykyinen julkaistu versio pysyy muuttumattomana.",
      SE: "Detta kommer att skapa ett redigerbart utkast som du kan ändra och publicera som nästa version. Den nuvarande publicerade versionen förblir oförändrad."
    },
    {
      key: "forms.createdraft",
      EN: "Create Draft",
      DA: "Opret kladde",
      NO: "Opprett utkast",
      FI: "Luo luonnos",
      SE: "Skapa utkast"
    },
    {
      key: "forms.confirmpublish.title",
      EN: "Confirm Publish",
      DA: "Bekræft udgivelse",
      NO: "Bekreft publisering",
      FI: "Vahvista julkaisu",
      SE: "Bekräfta publicering"
    },
    {
      key: "forms.confirmpublish.message",
      EN: "Are you sure you want to publish this form? This will create a new immutable version. Published versions cannot be edited.",
      DA: "Er du sikker på, at du vil udgive denne formular? Dette vil oprette en ny uforanderlig version. Udgivne versioner kan ikke redigeres.",
      NO: "Er du sikker på at du vil publisere dette skjemaet? Dette vil opprette en ny uforanderlig versjon. Publiserte versjoner kan ikke redigeres.",
      FI: "Haluatko varmasti julkaista tämän lomakkeen? Tämä luo uuden muuttumattoman version. Julkaistuja versioita ei voi muokata.",
      SE: "Är du säker på att du vill publicera det här formuläret? Detta kommer att skapa en ny oföränderlig version. Publicerade versioner kan inte redigeras."
    },
    {
      key: "forms.publish",
      EN: "Publish",
      DA: "Udgiv",
      NO: "Publiser",
      FI: "Julkaise",
      SE: "Publicera"
    },
    {
      key: "orgprojectadd.workloadfte",
      EN: "Workload (FTE)",
      DA: "Arbejdsbyrde (FTE)",
      NO: "Arbeidsmengde (FTE)",
      FI: "Työkuorma (FTE)",
      SE: "Arbetsbelastning (FTE)"
    },
    {
      key: "projectdash.loading",
      EN: "Loading dashboard data...",
      DA: "Indlæser dashboard data...",
      NO: "Laster dashboard-data...",
      FI: "Ladataan dashboard-tietoja...",
      SE: "Laddar instrumentpanelsdata..."
    },
    {
      key: "projectdash.nodata",
      EN: "No data available yet",
      DA: "Ingen data tilgængelig endnu",
      NO: "Ingen data tilgjengelig ennå",
      FI: "Ei tietoja saatavilla vielä",
      SE: "Ingen data tillgänglig ännu"
    },
    {
      key: "projectdash.projectspermonth",
      EN: "Projects per month",
      DA: "Projekter pr. måned",
      NO: "Prosjekter per måned",
      FI: "Projektit kuukaudessa",
      SE: "Projekt per månad"
    },
    {
      key: "projectdash.executionspeed",
      EN: "Execution speed",
      DA: "Udførelseshastighed",
      NO: "Utførelseshastighet",
      FI: "Suoritusnopeus",
      SE: "Exekveringshastighet"
    },
    {
      key: "projectdash.speed",
      EN: "Speed",
      DA: "Hastighed",
      NO: "Hastighet",
      FI: "Nopeus",
      SE: "Hastighet"
    },
    {
      key: "projectdash.capacityvsplannedwork",
      EN: "Capacity vs Planned Work",
      DA: "Kapacitet vs. Planlagt arbejde",
      NO: "Kapasitet vs. Planlagt arbeid",
      FI: "Kapasiteetti vs. Suunniteltu työ",
      SE: "Kapacitet vs. Planerat arbete"
    },
    {
      key: "projectdash.week",
      EN: "Week",
      DA: "Uge",
      NO: "Uke",
      FI: "Viikko",
      SE: "Vecka"
    },
    {
      key: "projectdash.nocapacitydata",
      EN: "No capacity data available. Ensure team members are configured with FTE values.",
      DA: "Ingen kapacitetsdata tilgængelig. Sørg for at teammedlemmer er konfigureret med FTE-værdier.",
      NO: "Ingen kapasitetsdata tilgjengelig. Forsikre deg om at teammedlemmer er konfigurert med FTE-verdier.",
      FI: "Kapasiteettitietoja ei ole saatavilla. Varmista, että tiimin jäsenille on määritetty FTE-arvot.",
      SE: "Ingen kapacitetsdata tillgänglig. Se till att teammedlemmar är konfigurerade med FTE-värden."
    },
    {
      key: "projectdash.capacity",
      EN: "Capacity",
      DA: "Kapacitet",
      NO: "Kapasitet",
      FI: "Kapasiteetti",
      SE: "Kapacitet"
    },
    {
      key: "projectdash.plannedwork",
      EN: "Planned Work",
      DA: "Planlagt arbejde",
      NO: "Planlagt arbeid",
      FI: "Suunniteltu työ",
      SE: "Planerat arbete"
    },
    {
      key: "projectdash.adhoc",
      EN: "Adhoc tasks",
      DA: "Adhoc-opgaver",
      NO: "Adhoc-oppgaver",
      FI: "Adhoc-tehtävät",
      SE: "Adhoc-uppgifter"
    },
    {
      key: "timetrackingpanel.timetracking",
      EN: "Time tracking",
      DA: "Tidsregistrering",
      NO: "Tidsregistrering",
      FI: "Aikaseuranta",
      SE: "Tidsrapportering"
    },
    {
      key: "timetrackingpanel.estimate",
      EN: "Estimate",
      DA: "Estimat",
      NO: "Estimert",
      FI: "Arvio",
      SE: "Uppskattning"
    },
    {
      key: "timetrackingpanel.notset",
      EN: "Not set",
      DA: "Ikke angivet",
      NO: "Ikke satt",
      FI: "Ei asetettu",
      SE: "Inte inställt"
    },
    {
      key: "timetrackingpanel.logged",
      EN: "Logged",
      DA: "Registreret",
      NO: "Registrert",
      FI: "Kirjattu",
      SE: "Registrerad"
    },
    {
      key: "timetrackingpanel.history",
      EN: "History",
      DA: "Historik",
      NO: "Historikk",
      FI: "Historia",
      SE: "Historik"
    },
    {
      key: "timetrackingpanel.remaining",
      EN: "Remaining",
      DA: "Resterende",
      NO: "Gjenstående",
      FI: "Jäljellä",
      SE: "Återstående"
    },
    {
      key: "timetrackingpanel.newestimate",
      EN: "New estimate",
      DA: "Nyt estimat",
      NO: "Ny estimat",
      FI: "Uusi arvio",
      SE: "Ny uppskattning"
    },
    {
      key: "timetrackingpanel.commentoptional",
      EN: "Comment (optional)",
      DA: "Kommentar (valgfri)",
      NO: "Kommentar (valgfri)",
      FI: "Kommentti (valinnainen)",
      SE: "Kommentar (valfri)"
    },
    {
      key: "timetrackingpanel.setestimate",
      EN: "Set estimate",
      DA: "Angiv estimat",
      NO: "Angi estimat",
      FI: "Aseta arvio",
      SE: "Ange uppskattning"
    },
    {
      key: "timetrackingpanel.date",
      EN: "Date",
      DA: "Dato",
      NO: "Dato",
      FI: "Päivämäärä",
      SE: "Datum"
    },
    {
      key: "timetrackingpanel.hours",
      EN: "Hours",
      DA: "Timer",
      NO: "Timer",
      FI: "Tunnit",
      SE: "Timmar"
    },
    {
      key: "timetrackingpanel.noteoptional",
      EN: "Note (optional)",
      DA: "Note (valgfri)",
      NO: "Note (valgfri)",
      FI: "Huomautus (valinnainen)",
      SE: "Notering (valfri)"
    },
    {
      key: "timetrackingpanel.logtime",
      EN: "Log time",
      DA: "Registrer tid",
      NO: "Logg tid",
      FI: "Kirjaa aika",
      SE: "Logga tid"
    },
    {
      key: "timetrackingpanel.loadingtimeentries",
      EN: "Loading time entries…",
      DA: "Indlæser tidsregistreringer…",
      NO: "Laster tidsregistreringer…",
      FI: "Ladataan aikamerkintöjä…",
      SE: "Läser in tidsregistreringar…"
    },
    {
      key: "timetrackingpanel.remove",
      EN: "Remove",
      DA: "Fjern",
      NO: "Fjern",
      FI: "Poista",
      SE: "Ta bort"
    },
    {
      key: "timetrackingpanel.notimelogged",
      EN: "No time logged yet.",
      DA: "Ingen tid registreret endnu.",
      NO: "Ingen tid registrert ennå.",
      FI: "Aikaa ei ole vielä kirjattu.",
      SE: "Ingen tid registrerad än."
    }

  ];
  translate(key: string): string {
    const lang = SessionHelper.getLanguage() ?? 'EN';
    const entry = this.translations.find(t => t.key === key);
    return entry?.[lang] || entry?.EN || `missing: ${key}`;
  }
}
